import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as React from 'react';
import * as ApolloReactComponents from '../graphql/customGqlComponents';
import * as ApolloReactHooks from '../graphql/customGqlHooks';

export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
const defaultOptions = {};
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
    ID: string;
    String: string;
    Boolean: boolean;
    Int: number;
    Float: number;
    /** Date custom scalar type */
    Date: any;
    /** Date custom scalar type */
    Timeline: any;
    /** The `Upload` scalar type represents a file upload. */
    Upload: any;
}

export enum AbiType {
    Arm64 = 'arm64',
    Armeabi = 'armeabi',
    X86_64 = 'x86_64'
}

export interface Account {
    __typename?: 'Account';
    cultureCode?: Maybe<Culture>;
    email: Scalars['String'];
    employee?: Maybe<Employee>;
    firstName: Scalars['String'];
    id: Scalars['ID'];
    imageUrl?: Maybe<Scalars['String']>;
    languageCode?: Maybe<Culture>;
    lastName: Scalars['String'];
}

export interface AccountCreate {
    email: Scalars['String'];
    firstName: Scalars['String'];
    id?: Maybe<Scalars['ID']>;
    imageUrl?: Maybe<Scalars['String']>;
    lastName: Scalars['String'];
    password: Scalars['String'];
}

export interface AccountUpdate {
    email?: Maybe<Scalars['String']>;
    firstName?: Maybe<Scalars['String']>;
    imageUrl?: Maybe<Scalars['String']>;
    lastName?: Maybe<Scalars['String']>;
    password?: Maybe<Scalars['String']>;
}

export enum AccountingItemState {
    Canceled = 'Canceled',
    Moved = 'Moved',
    Opened = 'Opened',
    Paid = 'Paid',
    SoftRemoved = 'SoftRemoved',
    Voided = 'Voided'
}

export interface AddToOrder {
    id: Scalars['ID'];
    lines: Array<OrderLineCreate>;
    scheduledDate?: Maybe<Scalars['Date']>;
}

export interface AppPermissions {
    __typename?: 'AppPermissions';
    backoffice: Array<BackofficePermission>;
    pos: Array<PosPermission>;
    warehouse: Array<WarehousePermission>;
}

export interface AverageOrderStatistics {
    __typename?: 'AverageOrderStatistics';
    averageBillAmount: Scalars['Float'];
    billCount: Scalars['Int'];
    itemsPerOrder: Scalars['Float'];
    orderCount: Scalars['Float'];
}

export enum BackofficePermission {
    CanAddPaymentMethods = 'CAN_ADD_PAYMENT_METHODS',
    CanDeletePaymentMethods = 'CAN_DELETE_PAYMENT_METHODS',
    CanUpdatePaymentMethods = 'CAN_UPDATE_PAYMENT_METHODS',
    CanViewPaymentMethods = 'CAN_VIEW_PAYMENT_METHODS',
    HasAccess = 'HAS_ACCESS'
}

export interface Bill {
    __typename?: 'Bill';
    billNumber: Scalars['String'];
    billState: BillState;
    billTaxes: Array<BillTaxes>;
    canceledBy?: Maybe<Employee>;
    canceledById?: Maybe<Scalars['ID']>;
    canceledUtc?: Maybe<Scalars['Date']>;
    cashRegister?: Maybe<CashRegister>;
    cashRegisterId?: Maybe<Scalars['String']>;
    customer?: Maybe<Customer>;
    customerId?: Maybe<Scalars['ID']>;
    customPaymentMethod?: Maybe<CustomPaymentMethod>;
    customPaymentMethodId?: Maybe<Scalars['ID']>;
    /** Total value with discount */
    dicountedTotalValue?: Maybe<Scalars['Int']>;
    /** Total value of discount */
    discountedValue?: Maybe<Scalars['Int']>;
    fiscalRecord?: Maybe<FiscalRecord>;
    grossTips?: Maybe<Scalars['Int']>;
    id: Scalars['ID'];
    issuedBy: Employee;
    issuedById: Scalars['ID'];
    issuedUtc: Scalars['Date'];
    isToGo: Scalars['Boolean'];
    netTips?: Maybe<Scalars['Int']>;
    note: Scalars['String'];
    order: Order;
    orderId: Scalars['ID'];
    orderLines: Array<OrderLine>;
    paymentMethod: PaymentMethod;
    place?: Maybe<Place>;
    placeId?: Maybe<Scalars['ID']>;
    roundedPrice?: Maybe<Scalars['Int']>;
    rounding?: Maybe<Scalars['Int']>;
    total: Scalars['Int'];
    totalPriceCurrency: Currency;
    totalPriceCurrencyCurrencyCode: CurrencyCode;
    venue: Venue;
    venueId: Scalars['ID'];
    version: Scalars['Int'];
}

export interface BillDiscountPreview {
    __typename?: 'BillDiscountPreview';
    billNumber: Scalars['String'];
    billState: BillState;
    canceledById?: Maybe<Scalars['ID']>;
    canceledUtc?: Maybe<Scalars['Date']>;
    cashRegister?: Maybe<CashRegister>;
    cashRegisterId?: Maybe<Scalars['String']>;
    customer?: Maybe<Customer>;
    customerId?: Maybe<Scalars['ID']>;
    customPaymentMethod?: Maybe<CustomPaymentMethod>;
    customPaymentMethodId?: Maybe<Scalars['ID']>;
    /** Total value with discount */
    dicountedTotalValue?: Maybe<Scalars['Int']>;
    /** Total value of discount */
    discountedValue?: Maybe<Scalars['Int']>;
    grossTips?: Maybe<Scalars['Int']>;
    id: Scalars['ID'];
    issuedById: Scalars['ID'];
    issuedUtc: Scalars['Date'];
    isToGo: Scalars['Boolean'];
    netTips?: Maybe<Scalars['Int']>;
    note: Scalars['String'];
    orderId: Scalars['ID'];
    paymentMethod: PaymentMethod;
    placeId?: Maybe<Scalars['ID']>;
    roundedPrice?: Maybe<Scalars['Int']>;
    rounding?: Maybe<Scalars['Int']>;
    total: Scalars['Int'];
    totalPriceCurrency: Currency;
    totalPriceCurrencyCurrencyCode: CurrencyCode;
    venueId: Scalars['ID'];
    version: Scalars['Int'];
}

export interface BillFilters {
    billNumber?: Maybe<Scalars['String']>;
    cashRegisterId?: Maybe<Scalars['ID']>;
    date?: Maybe<DateFromTo>;
    dateFromTo?: Maybe<DateFromTo>;
    moreFilters?: Maybe<MoreFiltersBill>;
    name?: Maybe<Scalars['String']>;
    openedBy?: Maybe<Scalars['ID']>;
    place?: Maybe<Scalars['ID']>;
}

export enum BillState {
    Paid = 'Paid',
    Voided = 'Voided'
}

export interface BillTaxes {
    __typename?: 'BillTaxes';
    bill: Bill;
    billId: Scalars['ID'];
    grossTotal: Scalars['Int'];
    id: Scalars['ID'];
    netPrice: Scalars['Int'];
    tax: Tax;
    taxId: Scalars['ID'];
    taxValue: Scalars['Int'];
}

export interface CancelOrderLines {
    id: Scalars['ID'];
    orderLines: Array<OrderLineDto>;
    reason: OrderCancelationReason;
}

export interface CanceledOrderLines {
    __typename?: 'CanceledOrderLines';
    canceledValue: Scalars['Int'];
    itemCount: Scalars['Float'];
}

export interface CashDrawerOperation {
    __typename?: 'CashDrawerOperation';
    amount: Scalars['Int'];
    cashRegister?: Maybe<CashRegister>;
    cashRegisterId?: Maybe<Scalars['String']>;
    createdBy: Employee;
    createdById: Scalars['ID'];
    createdUtc: Scalars['Date'];
    id: Scalars['ID'];
    note?: Maybe<Scalars['String']>;
    venue: Venue;
    venueShift: VenueShift;
    venueShiftId: Scalars['ID'];
}

export interface CashRegister {
    __typename?: 'CashRegister';
    assignedPrinters?: Maybe<Array<Device>>;
    billPrinter?: Maybe<Device>;
    billPrinterId?: Maybe<Scalars['ID']>;
    cashRegisterSettings: CashRegisterSettings;
    createdUtc: Scalars['Date'];
    deleteDateUtc?: Maybe<Scalars['Date']>;
    id: Scalars['String'];
    immerlyPosVersion?: Maybe<Scalars['String']>;
    isMainRegister: Scalars['Boolean'];
    model: Scalars['String'];
    name: Scalars['String'];
    parentCashRegister?: Maybe<CashRegister>;
    parentCashRegisterId?: Maybe<Scalars['String']>;
    updatedUtc?: Maybe<Scalars['Date']>;
    venue: Venue;
    venueId: Scalars['ID'];
}

export interface CashRegisterCreate {
    billPrinterId?: Maybe<Scalars['String']>;
    deviceId: Scalars['String'];
    isMainRegister: Scalars['Boolean'];
    model: Scalars['String'];
    name: Scalars['String'];
    parentCashRegisterId?: Maybe<Scalars['String']>;
    venueId?: Maybe<Scalars['String']>;
}

export interface CashRegisterSettings {
    __typename?: 'CashRegisterSettings';
    id: Scalars['ID'];
    shouldOpenCashDrawerOnPayment: Scalars['Boolean'];
    skipOwnOrdersPrinting: Scalars['Boolean'];
}

export interface CategoriesStatistics {
    __typename?: 'CategoriesStatistics';
    categoryId?: Maybe<Scalars['ID']>;
    color?: Maybe<Color>;
    foodCost?: Maybe<Scalars['Float']>;
    grossRevenue: Scalars['Int'];
    id: Scalars['ID'];
    name: Scalars['String'];
    netMargin?: Maybe<Scalars['Int']>;
    netRevenue: Scalars['Int'];
    primeCost?: Maybe<Scalars['Int']>;
    productWithNoRecipeCount?: Maybe<Scalars['Int']>;
    quantity: Scalars['Float'];
}

export interface Category {
    __typename?: 'Category';
    category?: Maybe<Category>;
    categoryId?: Maybe<Scalars['ID']>;
    color?: Maybe<Color>;
    deleteDate?: Maybe<Scalars['Date']>;
    description?: Maybe<Scalars['String']>;
    id: Scalars['ID'];
    imageUrl?: Maybe<Scalars['String']>;
    name: Scalars['String'];
    ordering?: Maybe<Scalars['Int']>;
    products?: Maybe<Array<Product>>;
    venue: Venue;
    venueId: Scalars['ID'];
}

export interface CategoryProductCount {
    __typename?: 'CategoryProductCount';
    categoryId: Scalars['String'];
    productCount: Scalars['Int'];
}

export interface ChartData {
    __typename?: 'ChartData';
    date: Scalars['Date'];
    income: Scalars['Int'];
    paymentMethod: PaymentMethod;
}

export enum Color {
    Blue = 'Blue',
    Green = 'Green',
    Orange = 'Orange',
    Purple = 'Purple'
}

export interface ConnectedStockCard {
    __typename?: 'ConnectedStockCard';
    createdAtUtc: Scalars['Date'];
    createdById: Scalars['ID'];
    deleteDateUtc?: Maybe<Scalars['Date']>;
    deletedById?: Maybe<Scalars['ID']>;
    id: Scalars['ID'];
    products?: Maybe<Array<Product>>;
    quantity: Scalars['Int'];
    stockCard: StockCard;
    stockCardId: Scalars['ID'];
    updatedAtUtc?: Maybe<Scalars['Date']>;
    updatedById?: Maybe<Scalars['ID']>;
    venue: Venue;
    venueId: Scalars['ID'];
    version: Scalars['Int'];
    warehouseId: Scalars['ID'];
}

export enum Country {
    Afghanistan = 'Afghanistan',
    AlandIslands = 'AlandIslands',
    Albania = 'Albania',
    Algeria = 'Algeria',
    AmericanSamoa = 'AmericanSamoa',
    Andorra = 'Andorra',
    Angola = 'Angola',
    Anguilla = 'Anguilla',
    Antarctica = 'Antarctica',
    AntiguaAndBarbuda = 'AntiguaAndBarbuda',
    Argentina = 'Argentina',
    Armenia = 'Armenia',
    Aruba = 'Aruba',
    Australia = 'Australia',
    Austria = 'Austria',
    Azerbaijan = 'Azerbaijan',
    Bahamas = 'Bahamas',
    Bahrain = 'Bahrain',
    Bangladesh = 'Bangladesh',
    Barbados = 'Barbados',
    Belarus = 'Belarus',
    Belgium = 'Belgium',
    Belize = 'Belize',
    Benin = 'Benin',
    Bermuda = 'Bermuda',
    Bhutan = 'Bhutan',
    Bolivia = 'Bolivia',
    BosniaAndHerzegovina = 'BosniaAndHerzegovina',
    Botswana = 'Botswana',
    BouvetIsland = 'BouvetIsland',
    Brazil = 'Brazil',
    BritishIndianOceanTerritory = 'BritishIndianOceanTerritory',
    BruneiDarussalam = 'BruneiDarussalam',
    Bulgaria = 'Bulgaria',
    BurkinaFaso = 'BurkinaFaso',
    Burundi = 'Burundi',
    Cambodia = 'Cambodia',
    Cameroon = 'Cameroon',
    Canada = 'Canada',
    CapeVerde = 'CapeVerde',
    CaymanIslands = 'CaymanIslands',
    CentralAfricanRepublic = 'CentralAfricanRepublic',
    Chad = 'Chad',
    Chile = 'Chile',
    China = 'China',
    ChristmasIsland = 'ChristmasIsland',
    CocosKeelingIslands = 'CocosKeelingIslands',
    Colombia = 'Colombia',
    Comoros = 'Comoros',
    Congo = 'Congo',
    CongoDemocraticRepublic = 'CongoDemocraticRepublic',
    CookIslands = 'CookIslands',
    CostaRica = 'CostaRica',
    CoteDIvoire = 'CoteDIvoire',
    Croatia = 'Croatia',
    Cuba = 'Cuba',
    Cyprus = 'Cyprus',
    CzechRepublic = 'CzechRepublic',
    Denmark = 'Denmark',
    Djibouti = 'Djibouti',
    Dominica = 'Dominica',
    DominicanRepublic = 'DominicanRepublic',
    Ecuador = 'Ecuador',
    Egypt = 'Egypt',
    ElSalvador = 'ElSalvador',
    EquatorialGuinea = 'EquatorialGuinea',
    Eritrea = 'Eritrea',
    Estonia = 'Estonia',
    Ethiopia = 'Ethiopia',
    FalklandIslands = 'FalklandIslands',
    FaroeIslands = 'FaroeIslands',
    Fiji = 'Fiji',
    Finland = 'Finland',
    France = 'France',
    FrenchGuiana = 'FrenchGuiana',
    FrenchPolynesia = 'FrenchPolynesia',
    FrenchSouthernTerritories = 'FrenchSouthernTerritories',
    Gabon = 'Gabon',
    Gambia = 'Gambia',
    Georgia = 'Georgia',
    Germany = 'Germany',
    Ghana = 'Ghana',
    Gibraltar = 'Gibraltar',
    Greece = 'Greece',
    Greenland = 'Greenland',
    Grenada = 'Grenada',
    Guadeloupe = 'Guadeloupe',
    Guam = 'Guam',
    Guatemala = 'Guatemala',
    Guernsey = 'Guernsey',
    Guinea = 'Guinea',
    GuineaBissau = 'GuineaBissau',
    Guyana = 'Guyana',
    Haiti = 'Haiti',
    HeardIslandMcdonaldIslands = 'HeardIslandMcdonaldIslands',
    HolySeeVaticanCityState = 'HolySeeVaticanCityState',
    Honduras = 'Honduras',
    HongKong = 'HongKong',
    Hungary = 'Hungary',
    Iceland = 'Iceland',
    India = 'India',
    Indonesia = 'Indonesia',
    Iran = 'Iran',
    Iraq = 'Iraq',
    Ireland = 'Ireland',
    IsleOfMan = 'IsleOfMan',
    Israel = 'Israel',
    Italy = 'Italy',
    Jamaica = 'Jamaica',
    Japan = 'Japan',
    Jersey = 'Jersey',
    Jordan = 'Jordan',
    Kazakhstan = 'Kazakhstan',
    Kenya = 'Kenya',
    Kiribati = 'Kiribati',
    Korea = 'Korea',
    Kuwait = 'Kuwait',
    Kyrgyzstan = 'Kyrgyzstan',
    LaoPeoplesDemocraticRepublic = 'LaoPeoplesDemocraticRepublic',
    Latvia = 'Latvia',
    Lebanon = 'Lebanon',
    Lesotho = 'Lesotho',
    Liberia = 'Liberia',
    LibyanArabJamahiriya = 'LibyanArabJamahiriya',
    Liechtenstein = 'Liechtenstein',
    Lithuania = 'Lithuania',
    Luxembourg = 'Luxembourg',
    Macao = 'Macao',
    Macedonia = 'Macedonia',
    Madagascar = 'Madagascar',
    Malawi = 'Malawi',
    Malaysia = 'Malaysia',
    Maldives = 'Maldives',
    Mali = 'Mali',
    Malta = 'Malta',
    MarshallIslands = 'MarshallIslands',
    Martinique = 'Martinique',
    Mauritania = 'Mauritania',
    Mauritius = 'Mauritius',
    Mayotte = 'Mayotte',
    Mexico = 'Mexico',
    Micronesia = 'Micronesia',
    Moldova = 'Moldova',
    Monaco = 'Monaco',
    Mongolia = 'Mongolia',
    Montenegro = 'Montenegro',
    Montserrat = 'Montserrat',
    Morocco = 'Morocco',
    Mozambique = 'Mozambique',
    Myanmar = 'Myanmar',
    Namibia = 'Namibia',
    Nauru = 'Nauru',
    Nepal = 'Nepal',
    Netherlands = 'Netherlands',
    NetherlandsAntilles = 'NetherlandsAntilles',
    NewCaledonia = 'NewCaledonia',
    NewZealand = 'NewZealand',
    Nicaragua = 'Nicaragua',
    Niger = 'Niger',
    Nigeria = 'Nigeria',
    Niue = 'Niue',
    NorfolkIsland = 'NorfolkIsland',
    NorthernMarianaIslands = 'NorthernMarianaIslands',
    Norway = 'Norway',
    Oman = 'Oman',
    Pakistan = 'Pakistan',
    Palau = 'Palau',
    PalestinianTerritory = 'PalestinianTerritory',
    Panama = 'Panama',
    PapuaNewGuinea = 'PapuaNewGuinea',
    Paraguay = 'Paraguay',
    Peru = 'Peru',
    Philippines = 'Philippines',
    Pitcairn = 'Pitcairn',
    Poland = 'Poland',
    Portugal = 'Portugal',
    PuertoRico = 'PuertoRico',
    Qatar = 'Qatar',
    Reunion = 'Reunion',
    Romania = 'Romania',
    RussianFederation = 'RussianFederation',
    Rwanda = 'Rwanda',
    SaintBarthelemy = 'SaintBarthelemy',
    SaintHelena = 'SaintHelena',
    SaintKittsAndNevis = 'SaintKittsAndNevis',
    SaintLucia = 'SaintLucia',
    SaintMartin = 'SaintMartin',
    SaintPierreAndMiquelon = 'SaintPierreAndMiquelon',
    SaintVincentAndGrenadines = 'SaintVincentAndGrenadines',
    Samoa = 'Samoa',
    SanMarino = 'SanMarino',
    SaoTomeAndPrincipe = 'SaoTomeAndPrincipe',
    SaudiArabia = 'SaudiArabia',
    Senegal = 'Senegal',
    Serbia = 'Serbia',
    Seychelles = 'Seychelles',
    SierraLeone = 'SierraLeone',
    Singapore = 'Singapore',
    Slovakia = 'Slovakia',
    Slovenia = 'Slovenia',
    SolomonIslands = 'SolomonIslands',
    Somalia = 'Somalia',
    SouthAfrica = 'SouthAfrica',
    SouthGeorgiaAndSandwichIsl = 'SouthGeorgiaAndSandwichIsl',
    Spain = 'Spain',
    SriLanka = 'SriLanka',
    Sudan = 'Sudan',
    Suriname = 'Suriname',
    SvalbardAndJanMayen = 'SvalbardAndJanMayen',
    Swaziland = 'Swaziland',
    Sweden = 'Sweden',
    Switzerland = 'Switzerland',
    SyrianArabRepublic = 'SyrianArabRepublic',
    Taiwan = 'Taiwan',
    Tajikistan = 'Tajikistan',
    Tanzania = 'Tanzania',
    Thailand = 'Thailand',
    TimorLeste = 'TimorLeste',
    Togo = 'Togo',
    Tokelau = 'Tokelau',
    Tonga = 'Tonga',
    TrinidadAndTobago = 'TrinidadAndTobago',
    Tunisia = 'Tunisia',
    Turkey = 'Turkey',
    Turkmenistan = 'Turkmenistan',
    TurksAndCaicosIslands = 'TurksAndCaicosIslands',
    Tuvalu = 'Tuvalu',
    Uganda = 'Uganda',
    Ukraine = 'Ukraine',
    UnitedArabEmirates = 'UnitedArabEmirates',
    UnitedKingdom = 'UnitedKingdom',
    UnitedStates = 'UnitedStates',
    UnitedStatesOutlyingIslands = 'UnitedStatesOutlyingIslands',
    Uruguay = 'Uruguay',
    Uzbekistan = 'Uzbekistan',
    Vanuatu = 'Vanuatu',
    Venezuela = 'Venezuela',
    VietNam = 'VietNam',
    VirginIslandsBritish = 'VirginIslandsBritish',
    VirginIslandsUs = 'VirginIslandsUS',
    WallisAndFutuna = 'WallisAndFutuna',
    WesternSahara = 'WesternSahara',
    Yemen = 'Yemen',
    Zambia = 'Zambia',
    Zimbabwe = 'Zimbabwe'
}

export interface CreateCashDrawerOperation {
    amount: Scalars['Int'];
    createdUtc?: Maybe<Scalars['Date']>;
    id?: Maybe<Scalars['ID']>;
    note?: Maybe<Scalars['String']>;
    venueShiftId: Scalars['ID'];
}

export interface CreateCustomPaymentMethodInput {
    isActive?: Maybe<Scalars['Boolean']>;
    name: Scalars['String'];
}

export interface CreatedBy {
    __typename?: 'CreatedBy';
    employeeId: Scalars['ID'];
    firstName: Scalars['String'];
    lastName: Scalars['String'];
}

export enum Culture {
    CsCz = 'cs_CZ',
    EnUs = 'en_US'
}

export interface Currency {
    __typename?: 'Currency';
    currencyCode: CurrencyCode;
    precision: Scalars['Int'];
}

export enum CurrencyCode {
    Czk = 'CZK',
    Eur = 'EUR'
}

export interface CustomPaymentMethod {
    __typename?: 'CustomPaymentMethod';
    createdAtUtc: Scalars['Date'];
    createdById: Scalars['ID'];
    deleteDateUtc?: Maybe<Scalars['Date']>;
    deletedById?: Maybe<Scalars['ID']>;
    id: Scalars['ID'];
    isActive: Scalars['Boolean'];
    name: Scalars['String'];
    paymentIntegration?: Maybe<PaymentIntegration>;
    paymentIntegrationAmounts: Array<PaymentIntegrationAmount>;
    paymentIntegrationId?: Maybe<Scalars['ID']>;
    updatedAtUtc?: Maybe<Scalars['Date']>;
    updatedById?: Maybe<Scalars['ID']>;
    venueId: Scalars['ID'];
    version: Scalars['Int'];
}

export interface Customer {
    __typename?: 'Customer';
    bills?: Maybe<Array<Bill>>;
    birthday?: Maybe<Scalars['Date']>;
    deleteDate?: Maybe<Scalars['Date']>;
    email: Scalars['String'];
    enterpriseId: Scalars['ID'];
    firstName: Scalars['String'];
    id: Scalars['ID'];
    lastName?: Maybe<Scalars['String']>;
    phoneNumber?: Maybe<Scalars['String']>;
    totalSpent: Scalars['Int'];
}

export interface CustomerCreate {
    birthday?: Maybe<Scalars['Date']>;
    email: Scalars['String'];
    firstName: Scalars['String'];
    id?: Maybe<Scalars['ID']>;
    lastName?: Maybe<Scalars['String']>;
    phoneNumber?: Maybe<Scalars['String']>;
}

export interface CustomerFilters {
    birthday?: Maybe<DateFromTo>;
    deleteDate?: Maybe<Scalars['Date']>;
    email?: Maybe<Scalars['String']>;
    firstName?: Maybe<Scalars['String']>;
    lastName?: Maybe<Scalars['String']>;
    phoneNumber?: Maybe<Scalars['String']>;
    totalSpent?: Maybe<Scalars['Int']>;
}

export interface CustomerUpdate {
    birthday?: Maybe<Scalars['Date']>;
    email?: Maybe<Scalars['String']>;
    firstName?: Maybe<Scalars['String']>;
    id: Scalars['ID'];
    lastName?: Maybe<Scalars['String']>;
    phoneNumber?: Maybe<Scalars['String']>;
}


export interface DateFromTo {
    from: Scalars['Date'];
    to: Scalars['Date'];
}

export interface DeductionAmounts {
    __typename?: 'DeductionAmounts';
    total: Scalars['Int'];
    waste: Scalars['Int'];
    writeOff: Scalars['Int'];
}

export interface DeductionAmountsSummary {
    __typename?: 'DeductionAmountsSummary';
    withoutVat: DeductionAmounts;
    withVat: DeductionAmounts;
}

export interface DeductionList {
    __typename?: 'DeductionList';
    createdAtUtc: Scalars['Date'];
    createdBy: CreatedBy;
    createdById: Scalars['ID'];
    deductionDateUtc: Scalars['Date'];
    deductionListItems?: Maybe<Array<DeductionListItem>>;
    deductionListItemsCount: Scalars['Int'];
    deductionListItemsTotalCost: Scalars['Int'];
    deductionReason: DeductionReason;
    deleteDateUtc?: Maybe<Scalars['Date']>;
    deletedById?: Maybe<Scalars['ID']>;
    id: Scalars['ID'];
    isProcessed?: Maybe<Scalars['Boolean']>;
    updatedAtUtc?: Maybe<Scalars['Date']>;
    updatedById?: Maybe<Scalars['ID']>;
    version: Scalars['Int'];
    warehouse: Warehouse;
    warehouseId: Scalars['ID'];
}

export interface DeductionListCreate {
    deductionListItems?: Maybe<Array<DeductionListItemCascadeCreate>>;
    deductionReason: DeductionReason;
    id?: Maybe<Scalars['ID']>;
    warehouseId: Scalars['ID'];
}

export interface DeductionListItem {
    __typename?: 'DeductionListItem';
    createdAtUtc: Scalars['Date'];
    createdById: Scalars['ID'];
    deductionListId: Scalars['ID'];
    deleteDateUtc?: Maybe<Scalars['Date']>;
    deletedById?: Maybe<Scalars['ID']>;
    id: Scalars['ID'];
    priceWithoutVat: Scalars['Int'];
    priceWithVat?: Maybe<Scalars['Int']>;
    quantity: Scalars['Float'];
    stockCard: StockCard;
    stockCardId: Scalars['ID'];
    unitType: UnitType;
    updatedAtUtc?: Maybe<Scalars['Date']>;
    updatedById?: Maybe<Scalars['ID']>;
    version: Scalars['Int'];
}

export interface DeductionListItemCascadeCreate {
    id?: Maybe<Scalars['ID']>;
    quantity: Scalars['Float'];
    stockCardId: Scalars['ID'];
    unitType: UnitType;
}

export interface DeductionListItemCreate {
    deductionListId: Scalars['ID'];
    id?: Maybe<Scalars['ID']>;
    quantity: Scalars['Float'];
    stockCardId: Scalars['ID'];
    unitType: UnitType;
}

export interface DeductionListItemUpdate {
    quantity?: Maybe<Scalars['Float']>;
    stockCardId?: Maybe<Scalars['ID']>;
    unitType?: Maybe<UnitType>;
}

export interface DeductionListUpdate {
    deductionReason?: Maybe<DeductionReason>;
    id: Scalars['ID'];
    warehouseId: Scalars['ID'];
}

export enum DeductionReason {
    Waste = 'Waste',
    Writeoff = 'Writeoff'
}

export interface DeliveryList {
    __typename?: 'DeliveryList';
    createdAtUtc: Scalars['Date'];
    createdById: Scalars['ID'];
    deleteDateUtc?: Maybe<Scalars['Date']>;
    deletedById?: Maybe<Scalars['ID']>;
    deliveryDateUtc: Scalars['Date'];
    deliveryListItems: Array<DeliveryListItem>;
    deliveryListItemsCount: Scalars['Int'];
    deliveryListItemsTotalCost: Scalars['Int'];
    id: Scalars['ID'];
    invoiceNumber?: Maybe<Scalars['String']>;
    isProcessed?: Maybe<Scalars['Boolean']>;
    supplier: Supplier;
    supplierId: Scalars['ID'];
    updatedAtUtc?: Maybe<Scalars['Date']>;
    updatedById?: Maybe<Scalars['ID']>;
    version: Scalars['Int'];
    warehouse: Warehouse;
    warehouseId: Scalars['ID'];
}

export interface DeliveryListCreate {
    deliveryDateUtc: Scalars['Date'];
    deliveryListItems?: Maybe<Array<DeliveryListItemCreate>>;
    id?: Maybe<Scalars['ID']>;
    invoiceNumber?: Maybe<Scalars['String']>;
    supplierId: Scalars['ID'];
    warehouseId: Scalars['ID'];
}

export interface DeliveryListItem {
    __typename?: 'DeliveryListItem';
    createdAtUtc: Scalars['Date'];
    createdById: Scalars['ID'];
    currency: Currency;
    currencyCurrencyCode: CurrencyCode;
    deleteDateUtc?: Maybe<Scalars['Date']>;
    deletedById?: Maybe<Scalars['ID']>;
    deliveryList: DeliveryList;
    deliveryListId: Scalars['ID'];
    id: Scalars['ID'];
    priceWithoutVat: Scalars['Int'];
    quantity: Scalars['Float'];
    stockCard: StockCard;
    stockCardId: Scalars['ID'];
    updatedAtUtc?: Maybe<Scalars['Date']>;
    updatedById?: Maybe<Scalars['ID']>;
    version: Scalars['Int'];
}

export interface DeliveryListItemCreate {
    id?: Maybe<Scalars['ID']>;
    priceWithoutVat: Scalars['Int'];
    quantity: Scalars['Float'];
    stockCardId: Scalars['ID'];
    unitType?: Maybe<UnitType>;
}

export interface DeliveryListUpdate {
    deliveryDateUtc?: Maybe<Scalars['Date']>;
    id: Scalars['ID'];
    invoiceNumber?: Maybe<Scalars['String']>;
    supplierId?: Maybe<Scalars['ID']>;
    warehouseId: Scalars['ID'];
}

export interface DeliveryOption {
    __typename?: 'DeliveryOption';
    conversionMultiplier: Scalars['Float'];
    conversionUnitType: UnitType;
    createdAtUtc: Scalars['Date'];
    createdById: Scalars['ID'];
    deleteDateUtc?: Maybe<Scalars['Date']>;
    deletedById?: Maybe<Scalars['ID']>;
    id: Scalars['ID'];
    itemCode: Scalars['String'];
    stockCardId: Scalars['ID'];
    supplierId: Scalars['ID'];
    updatedAtUtc?: Maybe<Scalars['Date']>;
    updatedById?: Maybe<Scalars['ID']>;
    venueId: Scalars['ID'];
    version: Scalars['Int'];
}

export interface DeliveryOptionCreate {
    conversionMultiplier: Scalars['Float'];
    conversionUnitType: UnitType;
    itemCode: Scalars['String'];
    stockCardId: Scalars['ID'];
    supplierId: Scalars['ID'];
}

export interface Device {
    __typename?: 'Device';
    cashRegister?: Maybe<Device>;
    cashRegisterId?: Maybe<Scalars['String']>;
    connectionType?: Maybe<PrinterConnectionType>;
    customName?: Maybe<Scalars['String']>;
    deviceId: Scalars['String'];
    id: Scalars['ID'];
    name: Scalars['String'];
    printerPaperSize: PrinterPaperSize;
    products?: Maybe<Array<Product>>;
    type: Scalars['String'];
    venue: Venue;
}

export interface DeviceCreate {
    connectionType: PrinterConnectionType;
    customName?: Maybe<Scalars['String']>;
    deviceId: Scalars['String'];
    name: Scalars['String'];
    type: Scalars['String'];
}

export interface Discount {
    __typename?: 'Discount';
    deleteDate?: Maybe<Scalars['Date']>;
    description?: Maybe<Scalars['String']>;
    id: Scalars['ID'];
    name: Scalars['String'];
    rate: Scalars['Float'];
    venue: Venue;
}

export interface DiscountCreate {
    description?: Maybe<Scalars['String']>;
    name: Scalars['String'];
    rate: Scalars['Float'];
}

export interface DiscountUpdate {
    description?: Maybe<Scalars['String']>;
    id: Scalars['String'];
    name?: Maybe<Scalars['String']>;
    rate?: Maybe<Scalars['Float']>;
}

export interface DiscountedOrderLines {
    __typename?: 'DiscountedOrderLines';
    discountedValue: Scalars['Int'];
    itemCount: Scalars['Float'];
}

export interface Employee {
    __typename?: 'Employee';
    account: Account;
    accountId: Scalars['ID'];
    closedOrders: Array<Order>;
    currentVenue: Venue;
    currentVenueId: Scalars['ID'];
    deleteDate?: Maybe<Scalars['Date']>;
    enterprise: Enterprise;
    enterpriseId: Scalars['ID'];
    id: Scalars['ID'];
    openedOrders: Array<Order>;
    pin?: Maybe<Scalars['String']>;
    places: Array<Place>;
    role: Role;
    shifts: Array<Shift>;
    venues: Array<Venue>;
}

export interface EmployeeRegister {
    defaultVenueId: Scalars['ID'];
    email: Scalars['String'];
    firstName: Scalars['String'];
    imageUrl?: Maybe<Scalars['String']>;
    lastName: Scalars['String'];
    password: Scalars['String'];
    pin?: Maybe<Scalars['String']>;
    role?: Maybe<Role>;
    venueIds: Array<Scalars['ID']>;
}

export interface EmployeeUpdate {
    defaultVenueId?: Maybe<Scalars['ID']>;
    email?: Maybe<Scalars['String']>;
    firstName?: Maybe<Scalars['String']>;
    lastName?: Maybe<Scalars['String']>;
    password?: Maybe<Scalars['String']>;
    pin?: Maybe<Scalars['String']>;
    role?: Maybe<Role>;
    venueIds?: Maybe<Array<Scalars['ID']>>;
}

export interface Enterprise {
    __typename?: 'Enterprise';
    /** City */
    city: Scalars['String'];
    companyIdentificationNumber: Scalars['String'];
    country?: Maybe<Country>;
    customers?: Maybe<Array<Customer>>;
    district?: Maybe<Scalars['String']>;
    employees?: Maybe<Array<Employee>>;
    /** Street address */
    headquarters: Scalars['String'];
    id: Scalars['ID'];
    legalName: Scalars['String'];
    postalCode: Scalars['String'];
    /** Apartment, Suite, Box number, etc. */
    premise: Scalars['String'];
    /** Czech EET "id provozovny" */
    premisesId?: Maybe<Scalars['String']>;
    stockCardCategories?: Maybe<Array<StockCardCategory>>;
    stockCards?: Maybe<Array<StockCard>>;
    suppliers?: Maybe<Array<Supplier>>;
    /** Tax Identification Number */
    tin: Scalars['String'];
    venues?: Maybe<Array<Venue>>;
}

export interface EnterpriseCreate {
    country: Country;
    id?: Maybe<Scalars['ID']>;
    legalName: Scalars['String'];
    /** City */
    locality: Scalars['String'];
    postalCode: Scalars['String'];
    /** Apartment, Suite, Box number, etc. */
    premise: Scalars['String'];
    /** Street address */
    thoroughfare: Scalars['String'];
    /** Tax Identification Number */
    tin: Scalars['String'];
}

export interface EnterpriseUpdate {
    country?: Maybe<Country>;
    legalName?: Maybe<Scalars['String']>;
    /** City */
    locality?: Maybe<Scalars['String']>;
    postalCode?: Maybe<Scalars['String']>;
    /** Apartment, Suite, Box number, etc. */
    premise?: Maybe<Scalars['String']>;
    /** Street address */
    thoroughfare?: Maybe<Scalars['String']>;
    /** Tax Identification Number */
    tin?: Maybe<Scalars['String']>;
}

export interface ExpectedVenueShiftAmounts {
    __typename?: 'ExpectedVenueShiftAmounts';
    expectedByCard: Scalars['Int'];
    expectedByCash: Scalars['Int'];
    expectedByOtherPaymentMethods: Scalars['Int'];
    paymentIntegrationAmounts: Array<PaymentIntegrationAmount>;
}

export interface FinishVenueShift {
    expectedCashAmount: Scalars['Int'];
    expectedCreditCardAmount: Scalars['Int'];
    finalCashAmount: Scalars['Int'];
    finalCreditCardAmount: Scalars['Int'];
    finishedUtc?: Maybe<Scalars['Date']>;
}

export interface FiscalIntegration {
    __typename?: 'FiscalIntegration';
    certificate: FiscalRegistryCertificate;
    certificatePassword: Scalars['String'];
    createdUtc: Scalars['Date'];
    deleteDate?: Maybe<Scalars['Date']>;
    id: Scalars['ID'];
    venue: Venue;
}

export interface FiscalRecord {
    __typename?: 'FiscalRecord';
    attemptedToReportUtc: Scalars['Date'];
    bill: Bill;
    billId: Scalars['ID'];
    cashRegisterdId: Scalars['String'];
    createdUtc: Scalars['Date'];
    fiscalCode?: Maybe<Scalars['String']>;
    formattedReportedValue: Scalars['String'];
    id: Scalars['ID'];
    payerSecurityCode: Scalars['String'];
    payerSignatureCode: Scalars['String'];
    premisesId: Scalars['String'];
    rawReportedValue: Scalars['Int'];
    revenueDateUtc: Scalars['Date'];
    state: FiscalRecordState;
    taxIdentifierNumber: Scalars['String'];
    updatedUtc: Scalars['Date'];
    venue: Venue;
}

export enum FiscalRecordState {
    Attempted = 'Attempted',
    Reported = 'Reported'
}

export interface FiscalRegistryCertificate {
    __typename?: 'FiscalRegistryCertificate';
    content: Scalars['String'];
    encoding: Scalars['String'];
    id: Scalars['ID'];
    integrations: Array<FiscalIntegration>;
    mimetype: Scalars['String'];
    name: Scalars['String'];
}

export interface GrossIncomeByPaymentMethod {
    __typename?: 'GrossIncomeByPaymentMethod';
    income: Scalars['Int'];
    paymentIntegrationPartner?: Maybe<PaymentIntegrationPartner>;
    paymentMethod: PaymentMethod;
}

export interface InventoryCount {
    __typename?: 'InventoryCount';
    createdAtUtc: Scalars['Date'];
    createdById: Scalars['ID'];
    deleteDateUtc?: Maybe<Scalars['Date']>;
    deletedById?: Maybe<Scalars['ID']>;
    deltas: WithWithoutVat;
    endDate?: Maybe<Scalars['Date']>;
    expectedValuation?: Maybe<Scalars['Int']>;
    expectedValuationWithVat?: Maybe<Scalars['Int']>;
    id: Scalars['ID'];
    inventoryCountItems: Array<InventoryCountItem>;
    notCalculatedCounts?: Maybe<Scalars['Int']>;
    notMatchingCounts?: Maybe<Scalars['Int']>;
    realValuation?: Maybe<Scalars['Int']>;
    realValuationWithVat?: Maybe<Scalars['Int']>;
    shortageSurplus: ShortageSurplus;
    startDate: Scalars['Date'];
    updatedAtUtc?: Maybe<Scalars['Date']>;
    updatedById?: Maybe<Scalars['ID']>;
    version: Scalars['Int'];
    warehouse: Warehouse;
    warehouseId: Scalars['ID'];
}

export interface InventoryCountItem {
    __typename?: 'InventoryCountItem';
    createdAtUtc: Scalars['Date'];
    createdById: Scalars['ID'];
    deleteDateUtc?: Maybe<Scalars['Date']>;
    deletedById?: Maybe<Scalars['ID']>;
    expectedCount: Scalars['Float'];
    id: Scalars['ID'];
    inventoryCount: InventoryCount;
    inventoryCountId: Scalars['ID'];
    pricePerUnitWithoutVAT: Scalars['Int'];
    pricePerUnitWithVAT: Scalars['Int'];
    realCount?: Maybe<Scalars['Float']>;
    stockCard: StockCard;
    stockCardId: Scalars['ID'];
    updatedAtUtc?: Maybe<Scalars['Date']>;
    updatedById?: Maybe<Scalars['ID']>;
    version: Scalars['Int'];
}

export interface InventoryCountItemCreate {
    id?: Maybe<Scalars['ID']>;
    pricePerUnitWithVAT: Scalars['Int'];
    stockCardId: Scalars['ID'];
}

export interface InventoryCountItemUpdate {
    realCount: Scalars['Float'];
    unitType: UnitType;
}

export interface InvoiceStatusUpdate {
    __typename?: 'InvoiceStatusUpdate';
    annotation: Scalars['String'];
    status: RossumUploadStatus;
    warehouseId: Scalars['ID'];
}

export interface LegalEntity {
    __typename?: 'LegalEntity';
    /** City */
    city: Scalars['String'];
    companyIdentificationNumber: Scalars['String'];
    country?: Maybe<Country>;
    district?: Maybe<Scalars['String']>;
    /** Street address */
    headquarters: Scalars['String'];
    id: Scalars['ID'];
    legalName: Scalars['String'];
    postalCode: Scalars['String'];
    /** Tax Identification Number */
    tin: Scalars['String'];
    venues?: Maybe<Array<Venue>>;
}

export interface LoginEmployee {
    email: Scalars['String'];
    password: Scalars['String'];
}

export interface Manifest {
    __typename?: 'Manifest';
    current: Scalars['String'];
    latest: Scalars['String'];
}

export interface MoreFiltersBill {
    card: Scalars['Boolean'];
    cash: Scalars['Boolean'];
    notReported: Scalars['Boolean'];
    paidOnly?: Maybe<Scalars['Boolean']>;
    reported: Scalars['Boolean'];
    voidedOnly: Scalars['Boolean'];
}

export interface MoreFiltersOrder {
    canceled: Scalars['Boolean'];
    closed: Scalars['Boolean'];
    multiple: Scalars['Boolean'];
    onPlace: Scalars['Boolean'];
    open: Scalars['Boolean'];
    single: Scalars['Boolean'];
    toGo: Scalars['Boolean'];
}

export interface MoveOrder {
    id: Scalars['ID'];
    placeId?: Maybe<Scalars['ID']>;
    targetOrderId?: Maybe<Scalars['ID']>;
}

export interface MoveOrderLines {
    id: Scalars['ID'];
    orderLines: Array<OrderLineDto>;
    placeId?: Maybe<Scalars['ID']>;
    targetOrderId?: Maybe<Scalars['ID']>;
}

export interface Mutation {
    __typename?: 'Mutation';
    addEmployeeVenue: Employee;
    addToOrder: Order;
    cancelOrder: Order;
    cancelOrderLines: Order;
    checkToken: Scalars['Boolean'];
    completeRossumUpload: RossumUpload;
    createAccount: Account;
    createAndPayOrder: Order;
    createCashDrawerOperation: CashDrawerOperation;
    createCashRegister: CashRegister;
    createCategory: Category;
    createCustomer: Customer;
    createCustomPaymentMethod: CustomPaymentMethod;
    createDeductionList: DeductionList;
    createDeductionListItem: DeductionListItem;
    createDeliveryList: DeliveryList;
    createDevice: Device;
    createDiscount: Discount;
    createEnterprise: Enterprise;
    createInventoryCount: InventoryCount;
    createInventoryCountItem: InventoryCountItem;
    createOrder: Order;
    createOrReplaceDeliveryOptions: Array<DeliveryOption>;
    createPlace: Place;
    createProductAndRecipe: Product;
    createRecipe: Recipe;
    createRecipeLine: RecipeLine;
    createSection: Section;
    createStockCard: StockCard;
    createStockCardCategory: StockCardCategory;
    createSupplier: Supplier;
    createVenue: Venue;
    createWarehouse: Warehouse;
    deleteEmployee: Scalars['Boolean'];
    deleteRossumUpload: Scalars['Boolean'];
    discountOrderPreview: OrderDiscountPreview;
    endShift: Shift;
    finishInventoryCount: InventoryCount;
    finishVenueShift: VenueShift;
    loginEmployee: Scalars['String'];
    moveOrder: Array<Order>;
    moveOrderLines: Array<Order>;
    payOrder: Order;
    registerEmployee: Employee;
    removeAccount: Scalars['Boolean'];
    removeCashRegister: Scalars['Boolean'];
    removeCategory: Scalars['Boolean'];
    removeCustomer: Scalars['Boolean'];
    removeCustomPaymentMethod: Scalars['Boolean'];
    removeDeductionList: Scalars['Boolean'];
    removeDeductionListItem: Scalars['Boolean'];
    removeDeliveryList: Scalars['Boolean'];
    removeDevice: Scalars['Boolean'];
    removeDiscount: Scalars['Boolean'];
    removeEmployee: Scalars['Boolean'];
    removeEmployeeVenue: Employee;
    removeEnterprise: Scalars['Boolean'];
    removePlace: Scalars['Boolean'];
    removeProduct: Scalars['Boolean'];
    removeRecipe: Scalars['Boolean'];
    removeRecipeLine: Scalars['Boolean'];
    removeSection: Scalars['Boolean'];
    removeStockCard: Scalars['Boolean'];
    removeStockCardCategory: Scalars['Boolean'];
    removeVenue: Scalars['Boolean'];
    removeWarehouse: Scalars['Boolean'];
    scheduleOrder: Order;
    splitOrderPayment: Order;
    startShift: Shift;
    startVenueShift: VenueShift;
    switchVenue: Scalars['String'];
    updateAccount: Account;
    updateBill: Bill;
    updateBillPrinter: CashRegister;
    updateCategory: Category;
    updateCustomer: Customer;
    updateCustomPaymentMethod: CustomPaymentMethod;
    updateDeductionList: DeductionList;
    updateDeductionListItem: DeductionListItem;
    updateDeliveryList: DeliveryList;
    updateDiscount: Discount;
    updateEmployee: Employee;
    updateEnterprise: Enterprise;
    updateInventoryCountItem: InventoryCountItem;
    updateOrderName: Order;
    updatePlace: Place;
    updateProductAndRecipe: Product;
    updateRecipe: Recipe;
    updateRecipeLine: RecipeLine;
    updateSectionName: Section;
    updateSectionsOrdering: Array<Section>;
    updateStockCard: StockCard;
    updateStockCardCategory: StockCardCategory;
    updateSupplier: Supplier;
    updateVenue: Venue;
    updateWarehouse: Warehouse;
    uploadCertificate: Scalars['Boolean'];
    uploadInvoices: Array<Scalars['String']>;
    voidBill: Bill;
}


export interface MutationAddEmployeeVenueArgs {
    id: Scalars['String'];
    venueId: Scalars['String'];
}


export interface MutationAddToOrderArgs {
    data: AddToOrder;
}


export interface MutationCancelOrderArgs {
    data: OrderCancel;
}


export interface MutationCancelOrderLinesArgs {
    data: CancelOrderLines;
}


export interface MutationCheckTokenArgs {
    token: Scalars['String'];
}


export interface MutationCompleteRossumUploadArgs {
    rossumUploadId: Scalars['ID'];
}


export interface MutationCreateAccountArgs {
    data: AccountCreate;
}


export interface MutationCreateAndPayOrderArgs {
    data: OrderCreateAndPay;
}


export interface MutationCreateCashDrawerOperationArgs {
    data: CreateCashDrawerOperation;
}


export interface MutationCreateCashRegisterArgs {
    data: CashRegisterCreate;
}


export interface MutationCreateCategoryArgs {
    childCategories?: Maybe<Array<Scalars['String']>>;
    color?: Maybe<Color>;
    id?: Maybe<Scalars['ID']>;
    name: Scalars['String'];
    parentCategoryId?: Maybe<Scalars['ID']>;
}


export interface MutationCreateCustomerArgs {
    data: CustomerCreate;
}


export interface MutationCreateCustomPaymentMethodArgs {
    data: CreateCustomPaymentMethodInput;
}


export interface MutationCreateDeductionListArgs {
    data: DeductionListCreate;
}


export interface MutationCreateDeductionListItemArgs {
    data: DeductionListItemCreate;
    deductionListId: Scalars['ID'];
    warehouseId: Scalars['ID'];
}


export interface MutationCreateDeliveryListArgs {
    data: DeliveryListCreate;
}


export interface MutationCreateDeviceArgs {
    data: DeviceCreate;
}


export interface MutationCreateDiscountArgs {
    data: DiscountCreate;
}


export interface MutationCreateEnterpriseArgs {
    data: EnterpriseCreate;
}


export interface MutationCreateInventoryCountArgs {
    warehouseId: Scalars['ID'];
}


export interface MutationCreateInventoryCountItemArgs {
    data: InventoryCountItemCreate;
    inventoryCountId: Scalars['ID'];
    warehouseId: Scalars['ID'];
}


export interface MutationCreateOrderArgs {
    data: OrderCreate;
}


export interface MutationCreateOrReplaceDeliveryOptionsArgs {
    deliveryOptions: Array<DeliveryOptionCreate>;
}


export interface MutationCreatePlaceArgs {
    data: PlaceCreate;
}


export interface MutationCreateProductAndRecipeArgs {
    product: ProductCreate;
    recipe?: Maybe<RecipeCreateWithProduct>;
}


export interface MutationCreateRecipeArgs {
    data: RecipeCreate;
}


export interface MutationCreateRecipeLineArgs {
    data: RecipeLineCreate;
}


export interface MutationCreateStockCardArgs {
    data: StockCardCreate;
    priceUpdateArgs?: Maybe<StockCardPriceUpdateInput>;
}


export interface MutationCreateStockCardCategoryArgs {
    data: StockCardCategoryCreate;
}


export interface MutationCreateSupplierArgs {
    data: SupplierCreate;
}


export interface MutationCreateVenueArgs {
    data: VenueCreate;
}


export interface MutationCreateWarehouseArgs {
    data: WarehouseCreate;
}


export interface MutationDeleteEmployeeArgs {
    id: Scalars['String'];
}


export interface MutationDeleteRossumUploadArgs {
    rossumUploadId: Scalars['ID'];
}


export interface MutationDiscountOrderPreviewArgs {
    data: OrderDiscountInput;
}


export interface MutationEndShiftArgs {
    id: Scalars['String'];
}


export interface MutationFinishInventoryCountArgs {
    id: Scalars['ID'];
    warehouseId: Scalars['ID'];
}


export interface MutationFinishVenueShiftArgs {
    data: FinishVenueShift;
}


export interface MutationLoginEmployeeArgs {
    data: LoginEmployee;
}


export interface MutationMoveOrderArgs {
    data: MoveOrder;
}


export interface MutationMoveOrderLinesArgs {
    data: MoveOrderLines;
}


export interface MutationPayOrderArgs {
    data: PayOrder;
}


export interface MutationRegisterEmployeeArgs {
    data: EmployeeRegister;
}


export interface MutationRemoveAccountArgs {
    id: Scalars['String'];
}


export interface MutationRemoveCashRegisterArgs {
    deviceId: Scalars['String'];
}


export interface MutationRemoveCategoryArgs {
    id: Scalars['String'];
}


export interface MutationRemoveCustomerArgs {
    id: Scalars['String'];
}


export interface MutationRemoveCustomPaymentMethodArgs {
    id: Scalars['ID'];
}


export interface MutationRemoveDeductionListArgs {
    id: Scalars['ID'];
    warehouseId: Scalars['ID'];
}


export interface MutationRemoveDeductionListItemArgs {
    deductionListId: Scalars['ID'];
    id: Scalars['ID'];
    warehouseId: Scalars['ID'];
}


export interface MutationRemoveDeliveryListArgs {
    id: Scalars['ID'];
    warehouseId: Scalars['ID'];
}


export interface MutationRemoveDeviceArgs {
    id: Scalars['String'];
}


export interface MutationRemoveDiscountArgs {
    id: Scalars['String'];
}


export interface MutationRemoveEmployeeArgs {
    id: Scalars['String'];
}


export interface MutationRemoveEmployeeVenueArgs {
    id: Scalars['String'];
    venueId: Scalars['String'];
}


export interface MutationRemoveEnterpriseArgs {
    id: Scalars['String'];
}


export interface MutationRemovePlaceArgs {
    id: Scalars['String'];
}


export interface MutationRemoveProductArgs {
    id: Scalars['String'];
}


export interface MutationRemoveRecipeArgs {
    id: Scalars['ID'];
}


export interface MutationRemoveRecipeLineArgs {
    id: Scalars['ID'];
}


export interface MutationRemoveSectionArgs {
    id: Scalars['String'];
}


export interface MutationRemoveStockCardArgs {
    id: Scalars['ID'];
    warehouseIds: Array<Scalars['ID']>;
}


export interface MutationRemoveStockCardCategoryArgs {
    id: Scalars['ID'];
}


export interface MutationRemoveVenueArgs {
    id: Scalars['String'];
}


export interface MutationRemoveWarehouseArgs {
    id: Scalars['ID'];
}


export interface MutationScheduleOrderArgs {
    data: ScheduleOrder;
}


export interface MutationSplitOrderPaymentArgs {
    data: OrderSplit;
}


export interface MutationStartVenueShiftArgs {
    data: StartVenueShift;
}


export interface MutationSwitchVenueArgs {
    venueId: Scalars['String'];
}


export interface MutationUpdateAccountArgs {
    data: AccountUpdate;
    id: Scalars['String'];
}


export interface MutationUpdateBillArgs {
    data: UpdateBill;
}


export interface MutationUpdateBillPrinterArgs {
    data: UpdateBillPrinter;
}


export interface MutationUpdateCategoryArgs {
    data: UpdateCategory;
    id: Scalars['String'];
}


export interface MutationUpdateCustomerArgs {
    data: CustomerUpdate;
}


export interface MutationUpdateCustomPaymentMethodArgs {
    data: UpdateCustomPaymentMethodInput;
    id: Scalars['ID'];
}


export interface MutationUpdateDeductionListArgs {
    data: DeductionListUpdate;
}


export interface MutationUpdateDeductionListItemArgs {
    data: DeductionListItemUpdate;
    deductionListId: Scalars['ID'];
    id: Scalars['ID'];
    warehouseId: Scalars['ID'];
}


export interface MutationUpdateDeliveryListArgs {
    data: DeliveryListUpdate;
}


export interface MutationUpdateDiscountArgs {
    data: DiscountUpdate;
}


export interface MutationUpdateEmployeeArgs {
    data: EmployeeUpdate;
    id: Scalars['String'];
}


export interface MutationUpdateEnterpriseArgs {
    data: EnterpriseUpdate;
    id: Scalars['String'];
}


export interface MutationUpdateInventoryCountItemArgs {
    data: InventoryCountItemUpdate;
    id: Scalars['ID'];
    inventoryCountId: Scalars['ID'];
    warehouseId: Scalars['ID'];
}


export interface MutationUpdateOrderNameArgs {
    data: UpdateOrderName;
}


export interface MutationUpdatePlaceArgs {
    data: PlaceUpdate;
    id: Scalars['String'];
}


export interface MutationUpdateProductAndRecipeArgs {
    id: Scalars['String'];
    product: ProductUpdate;
    recipe?: Maybe<RecipeUpdateWithProduct>;
}


export interface MutationUpdateRecipeArgs {
    data: RecipeUpdate;
}


export interface MutationUpdateRecipeLineArgs {
    data: RecipeLineUpdate;
}


export interface MutationUpdateSectionNameArgs {
    data: SectionUpdateName;
    id: Scalars['String'];
}


export interface MutationUpdateSectionsOrderingArgs {
    data: SectionUpdateOrder;
}


export interface MutationUpdateStockCardArgs {
    data: StockCardUpdate;
    id: Scalars['ID'];
    priceUpdateArgs?: Maybe<StockCardPriceUpdateInput>;
}


export interface MutationUpdateStockCardCategoryArgs {
    data: StockCardCategoryUpdate;
    id: Scalars['ID'];
}


export interface MutationUpdateSupplierArgs {
    data: SupplierUpdate;
}


export interface MutationUpdateVenueArgs {
    data: VenueUpdate;
    id: Scalars['String'];
}


export interface MutationUpdateWarehouseArgs {
    data: WarehouseUpdate;
    id: Scalars['ID'];
}


export interface MutationUploadCertificateArgs {
    file: Scalars['Upload'];
    password: Scalars['String'];
}


export interface MutationUploadInvoicesArgs {
    files: Array<Scalars['Upload']>;
    warehouseId: Scalars['ID'];
}


export interface MutationVoidBillArgs {
    id: Scalars['String'];
}

export interface Order {
    __typename?: 'Order';
    bills: Array<Bill>;
    canceledBy?: Maybe<Employee>;
    canceledById: Scalars['ID'];
    canceledUtc?: Maybe<Scalars['Date']>;
    cancelNote?: Maybe<Scalars['String']>;
    cancelReason?: Maybe<OrderCancelationReason>;
    closedBy?: Maybe<Employee>;
    closedById?: Maybe<Scalars['ID']>;
    closedUtc?: Maybe<Scalars['Date']>;
    createdUtc: Scalars['Date'];
    id: Scalars['ID'];
    isToGo: Scalars['Boolean'];
    joinedOrder?: Maybe<Order>;
    name?: Maybe<Scalars['String']>;
    openedBy: Employee;
    openedById: Scalars['ID'];
    orderHistory: Array<OrderHistory>;
    orderLines: Array<OrderLine>;
    orderNumber?: Maybe<Scalars['String']>;
    orderState: OrderState;
    place?: Maybe<Place>;
    placeId?: Maybe<Scalars['ID']>;
    scheduledUtc?: Maybe<Scalars['Date']>;
    updatedBy?: Maybe<Employee>;
    updatedById: Scalars['ID'];
    updatedUtc: Scalars['Date'];
    venue: Venue;
    venueId: Scalars['ID'];
    version: Scalars['Int'];
}

export interface OrderCancel {
    id: Scalars['ID'];
    note?: Maybe<Scalars['String']>;
    reason: OrderCancelationReason;
}

export enum OrderCancelationReason {
    ClientError = 'ClientError',
    Other = 'Other',
    PersonnelError = 'PersonnelError'
}

export interface OrderCreate {
    id?: Maybe<Scalars['ID']>;
    lines: Array<OrderLineCreate>;
    name?: Maybe<Scalars['String']>;
    placeId?: Maybe<Scalars['ID']>;
    scheduledDate?: Maybe<Scalars['Date']>;
}

export interface OrderCreateAndPay {
    cashRegisterdId: Scalars['String'];
    customerId?: Maybe<Scalars['ID']>;
    customPaymentMethodId?: Maybe<Scalars['ID']>;
    discountId?: Maybe<Scalars['ID']>;
    grossTips?: Maybe<Scalars['Int']>;
    id?: Maybe<Scalars['ID']>;
    issueDate?: Maybe<Scalars['Date']>;
    isToGo: Scalars['Boolean'];
    lines: Array<OrderLineCreate>;
    netTips?: Maybe<Scalars['Int']>;
    note?: Maybe<Scalars['String']>;
    paymentMethod: PaymentMethod;
    placeId?: Maybe<Scalars['ID']>;
    scheduledDate?: Maybe<Scalars['Date']>;
}

export interface OrderDiscountInput {
    discountId: Scalars['ID'];
    orderId: Scalars['ID'];
    orderLines: Array<OrderLineDto>;
}

export interface OrderDiscountPreview {
    __typename?: 'OrderDiscountPreview';
    bills: Array<BillDiscountPreview>;
    canceledById: Scalars['ID'];
    canceledUtc?: Maybe<Scalars['Date']>;
    cancelNote?: Maybe<Scalars['String']>;
    cancelReason?: Maybe<OrderCancelationReason>;
    closedById?: Maybe<Scalars['ID']>;
    closedUtc?: Maybe<Scalars['Date']>;
    createdUtc: Scalars['Date'];
    id: Scalars['ID'];
    isToGo: Scalars['Boolean'];
    name?: Maybe<Scalars['String']>;
    openedById: Scalars['ID'];
    orderLines: Array<OrderLineDiscountPreview>;
    orderNumber?: Maybe<Scalars['String']>;
    orderState: OrderState;
    placeId?: Maybe<Scalars['ID']>;
    scheduledUtc?: Maybe<Scalars['Date']>;
    updatedById: Scalars['ID'];
    updatedUtc: Scalars['Date'];
    venueId: Scalars['ID'];
    version: Scalars['Int'];
}

export enum OrderEvent {
    AddedCustomName = 'AddedCustomName',
    BillVoided = 'BillVoided',
    CanceledCompletely = 'CanceledCompletely',
    CanceledPartially = 'CanceledPartially',
    Created = 'Created',
    MovedAndJoined = 'MovedAndJoined',
    MovedCompletely = 'MovedCompletely',
    MovedPartially = 'MovedPartially',
    OrderLinesAdded = 'OrderLinesAdded',
    OrderLinesMovedFrom = 'OrderLinesMovedFrom',
    OrderLinesMovedTo = 'OrderLinesMovedTo',
    PaidCompletely = 'PaidCompletely',
    PaidPartially = 'PaidPartially',
    QuickSale = 'QuickSale',
    Rescheduled = 'Rescheduled',
    Scheduled = 'Scheduled'
}

export interface OrderFilters {
    date?: Maybe<DateFromTo>;
    moreFilters?: Maybe<MoreFiltersOrder>;
    name?: Maybe<Scalars['String']>;
    openedBy?: Maybe<Scalars['ID']>;
    place?: Maybe<Scalars['ID']>;
}

export interface OrderHistory {
    __typename?: 'OrderHistory';
    auditId: Scalars['ID'];
    changeReason: OrderEvent;
    createdAt: Scalars['Date'];
    id: Scalars['ID'];
    order: Order;
}

export interface OrderLine {
    __typename?: 'OrderLine';
    bill?: Maybe<Bill>;
    billId?: Maybe<Scalars['ID']>;
    cancelationReason?: Maybe<OrderCancelationReason>;
    canceledBy?: Maybe<Employee>;
    canceledUtc?: Maybe<Scalars['Date']>;
    closedUtc?: Maybe<Scalars['Date']>;
    createdUtc: Scalars['Date'];
    deleteDateUtc?: Maybe<Scalars['Date']>;
    discount?: Maybe<Discount>;
    discountedPrice?: Maybe<Scalars['Int']>;
    discountedUnitPrice?: Maybe<Scalars['Int']>;
    discountValue?: Maybe<Scalars['Int']>;
    id: Scalars['ID'];
    note?: Maybe<Scalars['String']>;
    order: Order;
    orderId: Scalars['ID'];
    orderLineState: AccountingItemState;
    price: Scalars['Int'];
    priceCurrency: Currency;
    priceCurrencyCurrencyCode: CurrencyCode;
    product: Product;
    productId: Scalars['ID'];
    quantity: Scalars['Float'];
    tax?: Maybe<Tax>;
    taxId?: Maybe<Scalars['ID']>;
    unitPrice: Scalars['Int'];
    updatedUtc?: Maybe<Scalars['Date']>;
    venue: Venue;
    venueId: Scalars['ID'];
    version: Scalars['Int'];
}

export interface OrderLineCreate {
    hasSeparatorAfter?: Maybe<Scalars['Boolean']>;
    id?: Maybe<Scalars['ID']>;
    note?: Maybe<Scalars['String']>;
    orderId?: Maybe<Scalars['ID']>;
    productId: Scalars['ID'];
    quantity: Scalars['Float'];
}

export interface OrderLineDiscountPreview {
    __typename?: 'OrderLineDiscountPreview';
    billId?: Maybe<Scalars['ID']>;
    cancelationReason?: Maybe<OrderCancelationReason>;
    canceledUtc?: Maybe<Scalars['Date']>;
    closedUtc?: Maybe<Scalars['Date']>;
    createdUtc: Scalars['Date'];
    deleteDateUtc?: Maybe<Scalars['Date']>;
    discount?: Maybe<Discount>;
    discountedPrice?: Maybe<Scalars['Int']>;
    discountedUnitPrice?: Maybe<Scalars['Int']>;
    discountValue?: Maybe<Scalars['Int']>;
    id: Scalars['ID'];
    note?: Maybe<Scalars['String']>;
    orderId: Scalars['ID'];
    orderLineState: AccountingItemState;
    price: Scalars['Int'];
    priceCurrency: Currency;
    priceCurrencyCurrencyCode: CurrencyCode;
    product: Product;
    productId: Scalars['ID'];
    quantity: Scalars['Float'];
    taxId?: Maybe<Scalars['ID']>;
    unitPrice: Scalars['Int'];
    updatedUtc?: Maybe<Scalars['Date']>;
    venueId: Scalars['ID'];
    version: Scalars['Int'];
}

export interface OrderLineDto {
    id: Scalars['ID'];
    quantity: Scalars['Float'];
}

export interface OrderSplit {
    cashRegisterdId: Scalars['String'];
    customerId?: Maybe<Scalars['ID']>;
    customPaymentMethodId?: Maybe<Scalars['ID']>;
    discountId?: Maybe<Scalars['ID']>;
    grossTips?: Maybe<Scalars['Int']>;
    id: Scalars['ID'];
    issueDate?: Maybe<Scalars['Date']>;
    isToGo?: Maybe<Scalars['Boolean']>;
    netTips?: Maybe<Scalars['Int']>;
    note?: Maybe<Scalars['String']>;
    orderLines: Array<OrderLineDto>;
    paymentMethod: PaymentMethod;
}

export enum OrderState {
    Canceled = 'Canceled',
    Closed = 'Closed',
    ClosedAndJoined = 'ClosedAndJoined',
    Opened = 'Opened'
}

export enum OrderUpdateTypes {
    CanceledCompletely = 'CanceledCompletely',
    CanceledPartially = 'CanceledPartially',
    Created = 'Created',
    CreatedAndPaid = 'CreatedAndPaid',
    JoinedPartially = 'JoinedPartially',
    MovedAndJoined = 'MovedAndJoined',
    MovedCompletely = 'MovedCompletely',
    MovedPartially = 'MovedPartially',
    NameUpdated = 'NameUpdated',
    OrderLinesAdded = 'OrderLinesAdded',
    OrderLinesAddedAndRescheduled = 'OrderLinesAddedAndRescheduled',
    OrderLinesAddedAndScheduled = 'OrderLinesAddedAndScheduled',
    PaidCompletely = 'PaidCompletely',
    PaidPartially = 'PaidPartially',
    Rescheduled = 'Rescheduled',
    Scheduled = 'Scheduled'
}

export interface OrderUpdatesSubscription {
    __typename?: 'OrderUpdatesSubscription';
    issuedCashRegisterId?: Maybe<Scalars['String']>;
    orders: Array<Order>;
    orderUpdateType: OrderUpdateTypes;
    updatedOrderLines?: Maybe<Array<UpdateOrderLine>>;
}

export interface PaginatedDeductionListItems {
    __typename?: 'PaginatedDeductionListItems';
    count: Scalars['Int'];
    items: Array<DeductionListItem>;
}

export interface PaginatedDeductionLists {
    __typename?: 'PaginatedDeductionLists';
    count: Scalars['Int'];
    items: Array<DeductionList>;
}

export interface PaginatedDeliveryLists {
    __typename?: 'PaginatedDeliveryLists';
    count: Scalars['Int'];
    items: Array<DeliveryList>;
}

export interface PaginatedInventoryCountItems {
    __typename?: 'PaginatedInventoryCountItems';
    count: Scalars['Int'];
    items: Array<InventoryCountItem>;
}

export interface PaginatedProductStatistic {
    __typename?: 'PaginatedProductStatistic';
    count: Scalars['Int'];
    items: Array<ProductStatistic>;
}

export interface PaginatedProducts {
    __typename?: 'PaginatedProducts';
    count: Scalars['Int'];
    items: Array<Product>;
}

export interface PaginatedStockCards {
    __typename?: 'PaginatedStockCards';
    count: Scalars['Int'];
    items: Array<StockCard>;
}

export interface Pagination {
    limit?: Maybe<Scalars['Int']>;
    offset?: Maybe<Scalars['Int']>;
}

export interface PayOrder {
    cashRegisterdId: Scalars['String'];
    customerId?: Maybe<Scalars['ID']>;
    customPaymentMethodId?: Maybe<Scalars['ID']>;
    discountId?: Maybe<Scalars['ID']>;
    grossTips?: Maybe<Scalars['Int']>;
    id: Scalars['ID'];
    issueDate?: Maybe<Scalars['Date']>;
    isToGo?: Maybe<Scalars['Boolean']>;
    netTips?: Maybe<Scalars['Int']>;
    note?: Maybe<Scalars['String']>;
    paymentMethod: PaymentMethod;
}

export interface PaymentIntegration {
    __typename?: 'PaymentIntegration';
    enterpriseId: Scalars['ID'];
    id: Scalars['ID'];
    paymentIntegrationPartner: PaymentIntegrationPartner;
    venueId: Scalars['ID'];
}

export interface PaymentIntegrationAmount {
    __typename?: 'PaymentIntegrationAmount';
    amount: Scalars['Int'];
    customPaymentMethod: CustomPaymentMethod;
    customPaymentMethodId: Scalars['ID'];
    id: Scalars['ID'];
    venueShiftId: Scalars['ID'];
}

export enum PaymentIntegrationPartner {
    Qerko = 'QERKO'
}

export enum PaymentMethod {
    Cash = 'Cash',
    CreditCard = 'CreditCard',
    Other = 'Other'
}

export interface PendingOrdersInfo {
    __typename?: 'PendingOrdersInfo';
    orderQuantity: Scalars['Int'];
    pendingTotalPrice: Scalars['Int'];
}

export interface Place {
    __typename?: 'Place';
    bills?: Maybe<Array<Bill>>;
    coordinateX: Scalars['Float'];
    coordinateY: Scalars['Float'];
    deleteDate?: Maybe<Scalars['Date']>;
    dimensionX: Scalars['Float'];
    dimensionY: Scalars['Float'];
    id: Scalars['ID'];
    isToGo: Scalars['Boolean'];
    name: Scalars['String'];
    orders?: Maybe<Array<Order>>;
    section: Section;
    sectionId: Scalars['ID'];
    venue: Venue;
    venueId: Scalars['ID'];
    waiter?: Maybe<Employee>;
}

export interface PlaceCreate {
    coordinateX: Scalars['Float'];
    coordinateY: Scalars['Float'];
    id?: Maybe<Scalars['ID']>;
    name: Scalars['String'];
    sectionId: Scalars['ID'];
}

export interface PlaceUpdate {
    coordinateX?: Maybe<Scalars['Float']>;
    coordinateY?: Maybe<Scalars['Float']>;
    isToGo?: Maybe<Scalars['Boolean']>;
    name?: Maybe<Scalars['String']>;
}

export enum PosPermission {
    CanCancelOrder = 'CAN_CANCEL_ORDER',
    CanGiveDiscount = 'CAN_GIVE_DISCOUNT',
    HasAccess = 'HAS_ACCESS'
}

export enum PrinterConnectionType {
    Bluetooth = 'Bluetooth',
    Lan = 'LAN',
    Usb = 'USB'
}

export enum PrinterPaperSize {
    Mm58 = 'mm58',
    Mm80 = 'mm80'
}

export interface Product {
    __typename?: 'Product';
    category: Category;
    categoryId: Scalars['ID'];
    connectedStockCard?: Maybe<ConnectedStockCard>;
    connectedStockCardId?: Maybe<Scalars['ID']>;
    deleteDate?: Maybe<Scalars['Date']>;
    description?: Maybe<Scalars['String']>;
    discountable: Scalars['Boolean'];
    displayName?: Maybe<Scalars['String']>;
    foodCost?: Maybe<Scalars['Float']>;
    id: Scalars['ID'];
    imageUrl?: Maybe<Scalars['String']>;
    markup?: Maybe<Scalars['Int']>;
    name: Scalars['String'];
    ordering?: Maybe<Scalars['Int']>;
    orderLines?: Maybe<Array<OrderLine>>;
    pohodaStockItemId?: Maybe<Scalars['String']>;
    priceBuy?: Maybe<Scalars['Int']>;
    priceBuyCurrency?: Maybe<Currency>;
    priceBuyCurrencyCurrencyCode?: Maybe<CurrencyCode>;
    priceSell: Scalars['Int'];
    priceSellCurrency: Currency;
    priceSellCurrencyCurrencyCode: CurrencyCode;
    printingDevices?: Maybe<Array<Device>>;
    recipe?: Maybe<Recipe>;
    recipeId?: Maybe<Scalars['ID']>;
    showInPos: Scalars['Boolean'];
    SKU?: Maybe<Scalars['String']>;
    tax: Tax;
    taxId: Scalars['ID'];
    toGoTax?: Maybe<Tax>;
    toGoTaxId?: Maybe<Scalars['ID']>;
    updatedAtUtc?: Maybe<Scalars['Date']>;
    venue: Venue;
    venueId: Scalars['ID'];
}

export interface ProductCreate {
    categoryId: Scalars['ID'];
    connectedStockCardId?: Maybe<Scalars['ID']>;
    description?: Maybe<Scalars['String']>;
    discountable?: Maybe<Scalars['Boolean']>;
    displayName?: Maybe<Scalars['String']>;
    foodCost?: Maybe<Scalars['Float']>;
    id?: Maybe<Scalars['ID']>;
    imageUrl?: Maybe<Scalars['String']>;
    markup?: Maybe<Scalars['Int']>;
    name: Scalars['String'];
    ordering?: Maybe<Scalars['Int']>;
    pohodaStockItemId?: Maybe<Scalars['String']>;
    priceBuy?: Maybe<Scalars['Int']>;
    priceBuyCurrencyCode?: Maybe<CurrencyCode>;
    priceSell: Scalars['Int'];
    printingDeviceIds?: Maybe<Array<Scalars['ID']>>;
    showInPos: Scalars['Boolean'];
    SKU?: Maybe<Scalars['String']>;
    stockCardId?: Maybe<Scalars['ID']>;
    stockCardWarehouseId?: Maybe<Scalars['ID']>;
    taxId: Scalars['ID'];
    toGoTaxId?: Maybe<Scalars['ID']>;
}

export interface ProductPrimeCostsSummary {
    __typename?: 'ProductPrimeCostsSummary';
    withoutVat: Scalars['Int'];
    withVat: Scalars['Int'];
}

export interface ProductStatistic {
    __typename?: 'ProductStatistic';
    foodCost?: Maybe<Scalars['Float']>;
    id: Scalars['ID'];
    markup?: Maybe<Scalars['Int']>;
    netRevenue: Scalars['Int'];
    primeCost?: Maybe<Scalars['Int']>;
    productName: Scalars['String'];
    quantity: Scalars['Float'];
    revenue: Scalars['Int'];
}

export interface ProductUpdate {
    categoryId?: Maybe<Scalars['ID']>;
    connectedStockCardId?: Maybe<Scalars['ID']>;
    description?: Maybe<Scalars['String']>;
    discountable?: Maybe<Scalars['Boolean']>;
    displayName?: Maybe<Scalars['String']>;
    foodCost?: Maybe<Scalars['Float']>;
    imageUrl?: Maybe<Scalars['String']>;
    markup?: Maybe<Scalars['Int']>;
    name?: Maybe<Scalars['String']>;
    ordering?: Maybe<Scalars['Int']>;
    pohodaStockItemId?: Maybe<Scalars['String']>;
    priceBuy?: Maybe<Scalars['Int']>;
    priceBuyCurrencyCode?: Maybe<CurrencyCode>;
    priceSell?: Maybe<Scalars['Int']>;
    printingDeviceIds?: Maybe<Array<Scalars['ID']>>;
    showInPos?: Maybe<Scalars['Boolean']>;
    SKU?: Maybe<Scalars['String']>;
    stockCardId?: Maybe<Scalars['ID']>;
    stockCardWarehouseId?: Maybe<Scalars['ID']>;
    taxId?: Maybe<Scalars['ID']>;
    toGoTaxId?: Maybe<Scalars['ID']>;
}

export interface Query {
    __typename?: 'Query';
    account?: Maybe<Account>;
    accounts: Array<Account>;
    averageOrderStatistics: AverageOrderStatistics;
    bill: Bill;
    bills: Array<Bill>;
    canceledOrderLines: CanceledOrderLines;
    cashDrawerOperation: CashDrawerOperation;
    cashDrawerOperations: Array<CashDrawerOperation>;
    cashDrawerReport: Scalars['String'];
    cashRegister?: Maybe<CashRegister>;
    cashRegisterByDeviceId?: Maybe<CashRegister>;
    cashRegisters: Array<CashRegister>;
    categories: Array<Category>;
    categoriesProductCount?: Maybe<Array<CategoryProductCount>>;
    categoriesStatistics: Array<CategoriesStatistics>;
    category?: Maybe<Category>;
    currentCashRegisterSettings: CashRegisterSettings;
    currentInventoryCount: InventoryCount;
    currentVenueCustomPaymentMethod: CustomPaymentMethod;
    currentVenueCustomPaymentMethods: Array<CustomPaymentMethod>;
    currentVenueInventoryCounts: Array<InventoryCount>;
    currentVenueSettings: VenueSettings;
    customer: Customer;
    customers: Array<Customer>;
    deductionAmounts: DeductionAmountsSummary;
    deductionList: DeductionList;
    deliveryList: DeliveryList;
    device?: Maybe<Device>;
    devices: Array<Device>;
    discount: Discount;
    discountedOrderLines: DiscountedOrderLines;
    discounts: Array<Discount>;
    employee: Employee;
    employeePermissions: AppPermissions;
    employees: Array<Employee>;
    enterprise?: Maybe<Enterprise>;
    enterprises: Array<Enterprise>;
    existingSuppliers: Array<Supplier>;
    getExpectedOpenedShiftAmount: ExpectedVenueShiftAmounts;
    getLastClosedShift?: Maybe<VenueShift>;
    grossIncomeByPaymentMethod: Array<GrossIncomeByPaymentMethod>;
    inventoryCount: InventoryCount;
    inventoryCountItem: InventoryCountItem;
    inventoryCounts: Array<InventoryCount>;
    moneyFlowReport: Scalars['String'];
    openedOrders: Array<Order>;
    order: Order;
    orders: Array<Order>;
    paginatedDeductionListItems: PaginatedDeductionListItems;
    paginatedDeductionLists: PaginatedDeductionLists;
    paginatedDeliveryLists: PaginatedDeliveryLists;
    paginatedInventoryCountItems: PaginatedInventoryCountItems;
    paginatedProducts: PaginatedProducts;
    paginatedStockCards: PaginatedStockCards;
    pendingOrders: PendingOrdersInfo;
    place?: Maybe<Place>;
    places: Array<Place>;
    pohodaIssueSlip: Scalars['String'];
    posManifest: Manifest;
    posUpdateUrl: Scalars['String'];
    product: Product;
    productCosts: ProductPrimeCostsSummary;
    products: Array<Product>;
    productsByCategory: Array<Product>;
    productsReport: Scalars['String'];
    productStatistics: PaginatedProductStatistic;
    recipe: Recipe;
    recipeLine: RecipeLine;
    recipeLinesByIds: Array<Maybe<RecipeLine>>;
    recipies: Array<Recipe>;
    removedEmployee: Employee;
    removedEmployees: Array<Employee>;
    rossumProcessedInvoiceByRossumUploadId?: Maybe<RossumProcessedInvoice>;
    rossumUploadsByWarehouseId: Array<RossumUpload>;
    rossumUploadsCountByWarehouseId: Scalars['Int'];
    salesChart: Array<ChartData>;
    salesChartData: Array<SalesChartData>;
    section?: Maybe<Section>;
    sections: Array<Section>;
    sharedStockCard: SharedStockCard;
    sharedStockCards: Array<Maybe<SharedStockCard>>;
    shift?: Maybe<Shift>;
    shifts: Array<Shift>;
    stockCard: StockCard;
    stockCardCategories: Array<StockCardCategory>;
    stockCardCategory: StockCardCategory;
    stockCards: Array<StockCard>;
    supplier: Supplier;
    suppliers: Array<Supplier>;
    tableStatistics: Array<TablesStatistics>;
    tax?: Maybe<Tax>;
    taxes: Array<Tax>;
    timeline: Array<Scalars['Timeline']>;
    topCategories: Array<TopCategories>;
    topEmployees: Array<TopEmployees>;
    topProducts: Array<TopProducts>;
    topTable: TopTable;
    unpopularCategories: Array<TopCategories>;
    unpopularProducts: Array<TopProducts>;
    venue?: Maybe<Venue>;
    venues: Array<Venue>;
    venueShift: VenueShift;
    venueShifts: Array<VenueShift>;
    voidedBills: VoidedBills;
    warehouse: Warehouse;
    warehouses: Array<Warehouse>;
}


export interface QueryAccountArgs {
    id: Scalars['String'];
}


export interface QueryAverageOrderStatisticsArgs {
    dateFilter?: Maybe<DateFromTo>;
}


export interface QueryBillArgs {
    id: Scalars['String'];
}


export interface QueryBillsArgs {
    filters?: Maybe<BillFilters>;
    limit?: Maybe<Scalars['Int']>;
    offset?: Maybe<Scalars['Int']>;
    pagination?: Maybe<Pagination>;
}


export interface QueryCanceledOrderLinesArgs {
    dateFromTo?: Maybe<DateFromTo>;
}


export interface QueryCashDrawerOperationArgs {
    id: Scalars['String'];
}


export interface QueryCashDrawerReportArgs {
    dateFromTo?: Maybe<DateFromTo>;
}


export interface QueryCashRegisterArgs {
    deviceId: Scalars['String'];
}


export interface QueryCashRegisterByDeviceIdArgs {
    deviceId: Scalars['String'];
}


export interface QueryCategoriesArgs {
    categoryType?: Maybe<Scalars['String']>;
}


export interface QueryCategoriesStatisticsArgs {
    dateFromTo?: Maybe<DateFromTo>;
}


export interface QueryCategoryArgs {
    id: Scalars['String'];
}


export interface QueryCurrentInventoryCountArgs {
    warehouseId: Scalars['ID'];
}


export interface QueryCurrentVenueCustomPaymentMethodArgs {
    id: Scalars['ID'];
}


export interface QueryCurrentVenueCustomPaymentMethodsArgs {
    onlyActive?: Maybe<Scalars['Boolean']>;
    withPaymentIntegrations?: Maybe<Scalars['Boolean']>;
}


export interface QueryCurrentVenueInventoryCountsArgs {
    from: Scalars['Date'];
    to: Scalars['Date'];
}


export interface QueryCustomerArgs {
    id: Scalars['String'];
}


export interface QueryCustomersArgs {
    filters?: Maybe<CustomerFilters>;
    limit?: Maybe<Scalars['Int']>;
    multivalueSearch?: Maybe<Scalars['String']>;
    offset?: Maybe<Scalars['Int']>;
}


export interface QueryDeductionAmountsArgs {
    from: Scalars['Date'];
    to: Scalars['Date'];
}


export interface QueryDeductionListArgs {
    id: Scalars['ID'];
    warehouseId: Scalars['ID'];
}


export interface QueryDeliveryListArgs {
    id: Scalars['ID'];
    warehouseId: Scalars['ID'];
}


export interface QueryDeviceArgs {
    id: Scalars['String'];
}


export interface QueryDiscountArgs {
    id: Scalars['String'];
}


export interface QueryDiscountedOrderLinesArgs {
    dateFromTo?: Maybe<DateFromTo>;
}


export interface QueryEmployeeArgs {
    id: Scalars['String'];
}


export interface QueryEnterpriseArgs {
    id: Scalars['String'];
}


export interface QueryGrossIncomeByPaymentMethodArgs {
    dateFilter?: Maybe<DateFromTo>;
}


export interface QueryInventoryCountArgs {
    id: Scalars['ID'];
    warehouseId: Scalars['ID'];
}


export interface QueryInventoryCountItemArgs {
    id: Scalars['ID'];
    inventoryCountId: Scalars['ID'];
}


export interface QueryInventoryCountsArgs {
    dateFromTo?: Maybe<DateFromTo>;
    limit?: Maybe<Scalars['Int']>;
    offset?: Maybe<Scalars['Int']>;
    warehouseId: Scalars['ID'];
}


export interface QueryMoneyFlowReportArgs {
    dateFromTo?: Maybe<DateFromTo>;
}


export interface QueryOrderArgs {
    id: Scalars['String'];
    onlyOpenedItems?: Maybe<Scalars['Boolean']>;
}


export interface QueryOrdersArgs {
    filters?: Maybe<OrderFilters>;
    limit?: Maybe<Scalars['Int']>;
    offset?: Maybe<Scalars['Int']>;
}


export interface QueryPaginatedDeductionListItemsArgs {
    deductionListId: Scalars['ID'];
    limit?: Maybe<Scalars['Int']>;
    offset?: Maybe<Scalars['Int']>;
}


export interface QueryPaginatedDeductionListsArgs {
    deductionDateUtc?: Maybe<Scalars['Date']>;
    deductionReason?: Maybe<DeductionReason>;
    isProcessed?: Maybe<Scalars['Boolean']>;
    limit?: Maybe<Scalars['Int']>;
    offset?: Maybe<Scalars['Int']>;
    warehouseId: Scalars['ID'];
}


export interface QueryPaginatedDeliveryListsArgs {
    deliveryDateUtc?: Maybe<Scalars['Date']>;
    invoiceNumber?: Maybe<Scalars['String']>;
    isProcessed?: Maybe<Scalars['Boolean']>;
    limit?: Maybe<Scalars['Int']>;
    offset?: Maybe<Scalars['Int']>;
    supplierId?: Maybe<Scalars['ID']>;
    warehouseId: Scalars['ID'];
}


export interface QueryPaginatedInventoryCountItemsArgs {
    inventoryCountId: Scalars['ID'];
    lessThanExpectedOnly?: Maybe<Scalars['Boolean']>;
    limit?: Maybe<Scalars['Int']>;
    moreThanExpectedOnly?: Maybe<Scalars['Boolean']>;
    notCountedOnly?: Maybe<Scalars['Boolean']>;
    offset?: Maybe<Scalars['Int']>;
    stockCardCategoryId?: Maybe<Scalars['ID']>;
    stockCardNameOrSku?: Maybe<Scalars['String']>;
    unmatchedOnly?: Maybe<Scalars['Boolean']>;
}


export interface QueryPaginatedProductsArgs {
    categories?: Maybe<Array<Scalars['ID']>>;
    foodCostSort?: Maybe<SortOrder>;
    markupSort?: Maybe<SortOrder>;
    name?: Maybe<Scalars['String']>;
    pagination?: Maybe<Pagination>;
}


export interface QueryPaginatedStockCardsArgs {
    limit?: Maybe<Scalars['Int']>;
    nameOrSku?: Maybe<Scalars['String']>;
    offset?: Maybe<Scalars['Int']>;
    stockCardCategoryId?: Maybe<Scalars['ID']>;
    stockCardNameSortOrder?: Maybe<SortOrder>;
    stockCardQuantitySortOrder?: Maybe<SortOrder>;
    stockCardsIds?: Maybe<Array<Scalars['ID']>>;
    storageUnit?: Maybe<UnitType>;
    warehouseIds: Array<Scalars['ID']>;
}


export interface QueryPlaceArgs {
    id: Scalars['String'];
}


export interface QueryPohodaIssueSlipArgs {
    dateFromTo?: Maybe<DateFromTo>;
}


export interface QueryPosUpdateUrlArgs {
    abi: AbiType;
}


export interface QueryProductArgs {
    id: Scalars['String'];
}


export interface QueryProductCostsArgs {
    from: Scalars['Date'];
    to: Scalars['Date'];
}


export interface QueryProductsByCategoryArgs {
    categoryId: Scalars['String'];
}


export interface QueryProductsReportArgs {
    dateFromTo?: Maybe<DateFromTo>;
}


export interface QueryProductStatisticsArgs {
    dateFromTo?: Maybe<DateFromTo>;
    foodCostSort?: Maybe<SortOrder>;
    limit?: Maybe<Scalars['Int']>;
    markupSort?: Maybe<SortOrder>;
    offset?: Maybe<Scalars['Int']>;
    productName?: Maybe<Scalars['String']>;
    quantitySortOrder?: Maybe<SortOrder>;
    revenueSortOrder?: Maybe<SortOrder>;
}


export interface QueryRecipeArgs {
    id: Scalars['ID'];
}


export interface QueryRecipeLineArgs {
    id: Scalars['ID'];
}


export interface QueryRecipeLinesByIdsArgs {
    ids: Array<Scalars['ID']>;
}


export interface QueryRecipiesArgs {
    limit?: Maybe<Scalars['Int']>;
    offset?: Maybe<Scalars['Int']>;
    stockCardId?: Maybe<Scalars['ID']>;
}


export interface QueryRemovedEmployeeArgs {
    id: Scalars['String'];
}


export interface QueryRossumProcessedInvoiceByRossumUploadIdArgs {
    rossumUploadId: Scalars['ID'];
    warehouseId: Scalars['ID'];
}


export interface QueryRossumUploadsByWarehouseIdArgs {
    warehouseId: Scalars['ID'];
}


export interface QueryRossumUploadsCountByWarehouseIdArgs {
    warehouseId: Scalars['ID'];
}


export interface QuerySalesChartArgs {
    dateFilter?: Maybe<DateFromTo>;
}


export interface QuerySalesChartDataArgs {
    dateFilter?: Maybe<DateFromTo>;
}


export interface QuerySectionArgs {
    id: Scalars['String'];
}


export interface QuerySharedStockCardArgs {
    id: Scalars['ID'];
}


export interface QuerySharedStockCardsArgs {
    limit?: Maybe<Scalars['Int']>;
    name?: Maybe<Scalars['String']>;
    offset?: Maybe<Scalars['Int']>;
    sku?: Maybe<Scalars['String']>;
}


export interface QueryShiftArgs {
    id: Scalars['String'];
}


export interface QueryStockCardArgs {
    id: Scalars['ID'];
}


export interface QueryStockCardCategoriesArgs {
    limit?: Maybe<Scalars['Int']>;
    name?: Maybe<Scalars['String']>;
    offset?: Maybe<Scalars['Int']>;
}


export interface QueryStockCardCategoryArgs {
    id: Scalars['ID'];
}


export interface QueryStockCardsArgs {
    limit?: Maybe<Scalars['Int']>;
    nameOrSku?: Maybe<Scalars['String']>;
    offset?: Maybe<Scalars['Int']>;
    stockCardCategoryId?: Maybe<Scalars['ID']>;
    stockCardNameSortOrder?: Maybe<SortOrder>;
    stockCardQuantitySortOrder?: Maybe<SortOrder>;
    stockCardsIds?: Maybe<Array<Scalars['ID']>>;
    storageUnit?: Maybe<UnitType>;
    warehouseIds: Array<Scalars['ID']>;
}


export interface QuerySupplierArgs {
    id: Scalars['ID'];
}


export interface QuerySuppliersArgs {
    limit?: Maybe<Scalars['Int']>;
    multiValueSearch?: Maybe<Scalars['String']>;
    offset?: Maybe<Scalars['Int']>;
}


export interface QueryTableStatisticsArgs {
    dateFromTo?: Maybe<DateFromTo>;
}


export interface QueryTaxArgs {
    id: Scalars['String'];
}


export interface QueryTimelineArgs {
    orderId: Scalars['String'];
}


export interface QueryTopCategoriesArgs {
    dateFromTo?: Maybe<DateFromTo>;
}


export interface QueryTopEmployeesArgs {
    dateFromTo?: Maybe<DateFromTo>;
}


export interface QueryTopProductsArgs {
    dateFromTo?: Maybe<DateFromTo>;
}


export interface QueryTopTableArgs {
    dateFromTo?: Maybe<DateFromTo>;
}


export interface QueryUnpopularCategoriesArgs {
    dateFromTo?: Maybe<DateFromTo>;
}


export interface QueryUnpopularProductsArgs {
    dateFromTo?: Maybe<DateFromTo>;
}


export interface QueryVenueArgs {
    id: Scalars['String'];
}


export interface QueryVenueShiftArgs {
    id: Scalars['String'];
}


export interface QueryVenueShiftsArgs {
    dateFromTo?: Maybe<DateFromTo>;
    limit?: Maybe<Scalars['Int']>;
    offset?: Maybe<Scalars['Int']>;
    pagination?: Maybe<Pagination>;
}


export interface QueryVoidedBillsArgs {
    dateFromTo?: Maybe<DateFromTo>;
}


export interface QueryWarehouseArgs {
    id: Scalars['ID'];
}


export interface QueryWarehousesArgs {
    onlyCurrentVenue?: Maybe<Scalars['Boolean']>;
}

export interface Recipe {
    __typename?: 'Recipe';
    createdAtUtc: Scalars['Date'];
    createdById: Scalars['ID'];
    deleteDateUtc?: Maybe<Scalars['Date']>;
    deletedById?: Maybe<Scalars['ID']>;
    enterprise: Enterprise;
    enterpriseId: Scalars['ID'];
    id: Scalars['ID'];
    name: Scalars['String'];
    products?: Maybe<Array<Product>>;
    recipeLines: Array<RecipeLine>;
    recipes: Array<Maybe<Recipe>>;
    updatedAtUtc?: Maybe<Scalars['Date']>;
    updatedById?: Maybe<Scalars['ID']>;
    version: Scalars['Int'];
}

export interface RecipeCreate {
    id?: Maybe<Scalars['ID']>;
    name: Scalars['String'];
    recipeIds?: Maybe<Array<Scalars['ID']>>;
    recipeLines?: Maybe<Array<RecipeLineCascadeCreate>>;
}

export interface RecipeCreateWithProduct {
    id?: Maybe<Scalars['ID']>;
    recipeIds?: Maybe<Array<Scalars['ID']>>;
    recipeLines?: Maybe<Array<RecipeLineCascadeCreate>>;
}

export interface RecipeLine {
    __typename?: 'RecipeLine';
    createdAtUtc: Scalars['Date'];
    createdById: Scalars['ID'];
    deleteDateUtc?: Maybe<Scalars['Date']>;
    deletedById?: Maybe<Scalars['ID']>;
    id: Scalars['ID'];
    quantity: Scalars['Float'];
    recipe: Recipe;
    recipeId: Scalars['ID'];
    stockCard: StockCard;
    stockCardId: Scalars['ID'];
    unitType: UnitType;
    updatedAtUtc?: Maybe<Scalars['Date']>;
    updatedById?: Maybe<Scalars['ID']>;
    version: Scalars['Int'];
    warehouseId: Scalars['ID'];
    waste: Scalars['Float'];
}

export interface RecipeLineCascadeCreate {
    id?: Maybe<Scalars['ID']>;
    quantity: Scalars['Float'];
    stockCardId: Scalars['ID'];
    unitType: UnitType;
    warehouseId: Scalars['ID'];
    waste: Scalars['Float'];
}

export interface RecipeLineCascadeUpdate {
    id?: Maybe<Scalars['ID']>;
    quantity?: Maybe<Scalars['Float']>;
    stockCardId?: Maybe<Scalars['ID']>;
    unitType?: Maybe<UnitType>;
    warehouseId?: Maybe<Scalars['ID']>;
    waste?: Maybe<Scalars['Float']>;
}

export interface RecipeLineCreate {
    id?: Maybe<Scalars['ID']>;
    quantity: Scalars['Float'];
    recipeId: Scalars['ID'];
    stockCardId: Scalars['ID'];
    unitType: UnitType;
    warehouseId: Scalars['ID'];
    waste: Scalars['Float'];
}

export interface RecipeLineUpdate {
    id: Scalars['ID'];
    quantity?: Maybe<Scalars['Float']>;
    recipeId?: Maybe<Scalars['ID']>;
    stockCardId?: Maybe<Scalars['ID']>;
    unitType?: Maybe<UnitType>;
    warehouseId?: Maybe<Scalars['ID']>;
    waste?: Maybe<Scalars['Float']>;
}

export interface RecipeUpdate {
    id: Scalars['ID'];
    name?: Maybe<Scalars['String']>;
    recipeIds?: Maybe<Array<Scalars['ID']>>;
    recipeLines?: Maybe<Array<RecipeLineCascadeUpdate>>;
}

export interface RecipeUpdateWithProduct {
    id?: Maybe<Scalars['ID']>;
    recipeIds?: Maybe<Array<Scalars['ID']>>;
    recipeLines?: Maybe<Array<RecipeLineCascadeCreate>>;
}

export enum ReviewState {
    Approved = 'Approved',
    Declined = 'Declined',
    Pending = 'Pending'
}

export enum Role {
    Admin = 'Admin',
    User = 'User',
    WarehouseGeneralManager = 'WarehouseGeneralManager',
    WarehouseManager = 'WarehouseManager',
    WarehouseUser = 'WarehouseUser'
}

export interface RossumProcessedInvoice {
    __typename?: 'RossumProcessedInvoice';
    createdAtUtc: Scalars['Date'];
    createdById: Scalars['ID'];
    currencyCode: CurrencyCode;
    deleteDateUtc?: Maybe<Scalars['Date']>;
    deletedById?: Maybe<Scalars['ID']>;
    deliveryDate: Scalars['Date'];
    id: Scalars['ID'];
    invoiceNumber?: Maybe<Scalars['String']>;
    paymentMethod?: Maybe<PaymentMethod>;
    processedListItems: Array<RossumProcessedListItem>;
    rossumUploadId: Scalars['ID'];
    rounding?: Maybe<Scalars['Int']>;
    supplierId: Scalars['ID'];
    totalAmount?: Maybe<Scalars['Int']>;
    totalBase?: Maybe<Scalars['Int']>;
    totalTax?: Maybe<Scalars['Int']>;
    updatedAtUtc?: Maybe<Scalars['Date']>;
    updatedById?: Maybe<Scalars['ID']>;
    version: Scalars['Int'];
    warehouseId: Scalars['ID'];
}

export interface RossumProcessedListItem {
    __typename?: 'RossumProcessedListItem';
    code: Scalars['String'];
    createdAtUtc: Scalars['Date'];
    createdById: Scalars['ID'];
    deleteDateUtc?: Maybe<Scalars['Date']>;
    deletedById?: Maybe<Scalars['ID']>;
    deliveryOption?: Maybe<DeliveryOption>;
    description: Scalars['String'];
    id: Scalars['ID'];
    processedInvoiceId: Scalars['ID'];
    quantity: Scalars['Int'];
    totalAmount?: Maybe<Scalars['Int']>;
    totalBase?: Maybe<Scalars['Int']>;
    unitOfMeasure?: Maybe<UnitType>;
    unitPrice?: Maybe<Scalars['Int']>;
    unitPriceWithoutVat?: Maybe<Scalars['Int']>;
    updatedAtUtc?: Maybe<Scalars['Date']>;
    updatedById?: Maybe<Scalars['ID']>;
    vatRate?: Maybe<Scalars['Int']>;
    version: Scalars['Int'];
}

export interface RossumUpload {
    __typename?: 'RossumUpload';
    createdAtUtc: Scalars['Date'];
    createdById: Scalars['ID'];
    deleteDateUtc?: Maybe<Scalars['Date']>;
    deletedById?: Maybe<Scalars['ID']>;
    filename: Scalars['String'];
    id: Scalars['ID'];
    rossumAnnotationUrl: Scalars['String'];
    status: RossumUploadStatus;
    updatedAtUtc?: Maybe<Scalars['Date']>;
    updatedById?: Maybe<Scalars['ID']>;
    version: Scalars['Int'];
}

export enum RossumUploadStatus {
    CompletedByUser = 'CompletedByUser',
    Confirmed = 'Confirmed',
    Deleted = 'Deleted',
    Exported = 'Exported',
    Exporting = 'Exporting',
    FailedExport = 'FailedExport',
    FailedImport = 'FailedImport',
    Importing = 'Importing',
    Postponed = 'Postponed',
    Rejected = 'Rejected',
    Reviewing = 'Reviewing',
    Split = 'Split',
    ToReview = 'ToReview'
}

export interface SalesChartData {
    __typename?: 'SalesChartData';
    date: Scalars['Date'];
    income?: Maybe<Scalars['Int']>;
    paymentMethod?: Maybe<PaymentMethod>;
}

export interface ScheduleOrder {
    id: Scalars['ID'];
    scheduledDate: Scalars['Date'];
}

export interface Section {
    __typename?: 'Section';
    createdAt: Scalars['Date'];
    deleteDate?: Maybe<Scalars['Date']>;
    id: Scalars['ID'];
    name: Scalars['String'];
    ordering?: Maybe<Scalars['Int']>;
    places?: Maybe<Array<Place>>;
    venue: Venue;
}

export interface SectionUpdateName {
    name: Scalars['String'];
}

export interface SectionUpdateOrder {
    orderedSections: Array<SectionWithOrder>;
}

export interface SectionWithOrder {
    id: Scalars['ID'];
    ordering: Scalars['Int'];
}

export interface SharedStockCard {
    __typename?: 'SharedStockCard';
    conversionUnit?: Maybe<UnitType>;
    convertedAmount?: Maybe<Scalars['Float']>;
    createdAtUtc: Scalars['Date'];
    createdById: Scalars['ID'];
    deleteDateUtc?: Maybe<Scalars['Date']>;
    deletedById?: Maybe<Scalars['ID']>;
    id: Scalars['ID'];
    name: Scalars['String'];
    reviewState: ReviewState;
    sku?: Maybe<Scalars['String']>;
    stockCards?: Maybe<Array<StockCard>>;
    storageUnit: UnitType;
    updatedAtUtc?: Maybe<Scalars['Date']>;
    updatedById?: Maybe<Scalars['ID']>;
    version: Scalars['Int'];
}

export interface Shift {
    __typename?: 'Shift';
    employee: Employee;
    employeeId: Scalars['ID'];
    end?: Maybe<Scalars['Date']>;
    id: Scalars['ID'];
    start: Scalars['Date'];
}

export interface ShortageSurplus {
    __typename?: 'ShortageSurplus';
    shortage: WithWithoutVat;
    surplus: WithWithoutVat;
}

export enum SortOrder {
    Asc = 'ASC',
    Desc = 'DESC'
}

export interface StartVenueShift {
    id?: Maybe<Scalars['ID']>;
    initialCashAmount: Scalars['Int'];
    startedUtc?: Maybe<Scalars['Date']>;
}

export interface StockCard {
    __typename?: 'StockCard';
    conversionUnit?: Maybe<UnitType>;
    convertedAmount?: Maybe<Scalars['Float']>;
    createdAtUtc: Scalars['Date'];
    createdById: Scalars['ID'];
    deductionListItems?: Maybe<Array<DeductionListItem>>;
    deleteDateUtc?: Maybe<Scalars['Date']>;
    deletedById?: Maybe<Scalars['ID']>;
    deliveryListItems?: Maybe<Array<DeliveryListItem>>;
    enterprise: Enterprise;
    enterpriseId: Scalars['ID'];
    id: Scalars['ID'];
    inventoryCountItems?: Maybe<Array<InventoryCountItem>>;
    manualPriceOverride?: Maybe<Scalars['Boolean']>;
    name: Scalars['String'];
    recipeLines?: Maybe<Array<RecipeLine>>;
    sharedStockCard: SharedStockCard;
    sharedStockCardId: Scalars['ID'];
    sku?: Maybe<Scalars['String']>;
    stockCardCategory?: Maybe<StockCardCategory>;
    stockCardCategoryId?: Maybe<Scalars['ID']>;
    stockLevels: Array<StockLevel>;
    storageUnit: UnitType;
    tax: Tax;
    taxId: Scalars['ID'];
    updatedAtUtc?: Maybe<Scalars['Date']>;
    updatedById?: Maybe<Scalars['ID']>;
    version: Scalars['Int'];
    warehouses: Array<Warehouse>;
}


export interface StockCardWarehousesArgs {
    currentVenueOnly?: Maybe<Scalars['Boolean']>;
}

export interface StockCardCategory {
    __typename?: 'StockCardCategory';
    color?: Maybe<Color>;
    createdAtUtc: Scalars['Date'];
    createdById: Scalars['ID'];
    deleteDateUtc?: Maybe<Scalars['Date']>;
    deletedById?: Maybe<Scalars['ID']>;
    enterprise: Enterprise;
    enterpriseId: Scalars['ID'];
    id: Scalars['ID'];
    name: Scalars['String'];
    stockCards?: Maybe<Array<StockCard>>;
    updatedAtUtc?: Maybe<Scalars['Date']>;
    updatedById?: Maybe<Scalars['ID']>;
    version: Scalars['Int'];
}

export interface StockCardCategoryCreate {
    color?: Maybe<Color>;
    id?: Maybe<Scalars['ID']>;
    name: Scalars['String'];
}

export interface StockCardCategoryUpdate {
    color?: Maybe<Color>;
    name?: Maybe<Scalars['String']>;
}

export interface StockCardCreate {
    conversionUnit?: Maybe<UnitType>;
    convertedAmount?: Maybe<Scalars['Float']>;
    id?: Maybe<Scalars['ID']>;
    manualPriceOverride?: Maybe<Scalars['Boolean']>;
    name: Scalars['String'];
    sharedStockCardId?: Maybe<Scalars['ID']>;
    sku?: Maybe<Scalars['String']>;
    stockCardCategoryId?: Maybe<Scalars['ID']>;
    storageUnit: UnitType;
    taxId: Scalars['ID'];
    warehouseIds: Array<Scalars['ID']>;
}

export interface StockCardPriceUpdateInput {
    priceWithoutVat: Scalars['Int'];
    warehouseIds: Array<Scalars['ID']>;
}

export interface StockCardUpdate {
    manualPriceOverride?: Maybe<Scalars['Boolean']>;
    name?: Maybe<Scalars['String']>;
    sku?: Maybe<Scalars['String']>;
    stockCardCategoryId?: Maybe<Scalars['ID']>;
    taxId?: Maybe<Scalars['ID']>;
    warehouseIds: Array<Scalars['ID']>;
}

export interface StockLevel {
    __typename?: 'StockLevel';
    createdAtUtc: Scalars['Date'];
    createdById: Scalars['ID'];
    currency: Currency;
    currencyCurrencyCode: CurrencyCode;
    deleteDateUtc?: Maybe<Scalars['Date']>;
    deletedById?: Maybe<Scalars['ID']>;
    history?: Maybe<Array<StockLevelHistory>>;
    id: Scalars['ID'];
    priceWithoutVat: Scalars['Int'];
    pricingMode?: Maybe<StockLevelPricingMode>;
    quantity: Scalars['Float'];
    stockCard: StockCard;
    stockCardId: Scalars['ID'];
    updatedAtUtc?: Maybe<Scalars['Date']>;
    updatedById?: Maybe<Scalars['ID']>;
    version: Scalars['Int'];
    warehouse: Warehouse;
    warehouseId: Scalars['ID'];
}

export interface StockLevelHistory {
    __typename?: 'StockLevelHistory';
    createdAtUtc: Scalars['Date'];
    id: Scalars['ID'];
    modifierId: Scalars['ID'];
    modifierType: StockLevelModifierType;
    newValue: Scalars['Float'];
    oldValue?: Maybe<Scalars['Float']>;
    quantityChanged: Scalars['Float'];
    stockLevel: StockLevel;
    stockLevelId: Scalars['ID'];
}

export enum StockLevelModifierType {
    DeductionListItem = 'DeductionListItem',
    DeliveryListItem = 'DeliveryListItem',
    InventoryCountItem = 'InventoryCountItem',
    OrderLine = 'OrderLine',
    StockCardReasign = 'StockCardReasign'
}

export enum StockLevelPricingMode {
    Average = 'Average',
    LastDelivery = 'LastDelivery'
}

export interface Subscription {
    __typename?: 'Subscription';
    invoiceStatusUpdates: InvoiceStatusUpdate;
    orderUpdates: OrderUpdatesSubscription;
    productUpdates: Product;
}


export interface SubscriptionInvoiceStatusUpdatesArgs {
    warehouseId: Scalars['ID'];
}

export interface Supplier {
    __typename?: 'Supplier';
    /** City */
    city?: Maybe<Scalars['String']>;
    companyIdentificationNumber?: Maybe<Scalars['String']>;
    country?: Maybe<Country>;
    createdAtUtc: Scalars['Date'];
    createdById: Scalars['ID'];
    deleteDateUtc?: Maybe<Scalars['Date']>;
    deletedById?: Maybe<Scalars['ID']>;
    district?: Maybe<Scalars['String']>;
    /** Street address */
    headquarters?: Maybe<Scalars['String']>;
    id: Scalars['ID'];
    legalName: Scalars['String'];
    postalCode?: Maybe<Scalars['String']>;
    reviewState: ReviewState;
    /** Tax Identification Number */
    tin?: Maybe<Scalars['String']>;
    updatedAtUtc?: Maybe<Scalars['Date']>;
    updatedById?: Maybe<Scalars['ID']>;
    version: Scalars['Int'];
}

export interface SupplierCreate {
    /** City */
    city?: Maybe<Scalars['String']>;
    companyIdentificationNumber?: Maybe<Scalars['String']>;
    country?: Maybe<Country>;
    district?: Maybe<Scalars['String']>;
    /** Street address */
    headquarters?: Maybe<Scalars['String']>;
    id?: Maybe<Scalars['ID']>;
    legalName: Scalars['String'];
    postalCode?: Maybe<Scalars['String']>;
    /** Tax Identification Number */
    tin?: Maybe<Scalars['String']>;
}

export interface SupplierUpdate {
    /** City */
    city?: Maybe<Scalars['String']>;
    companyIdentificationNumber?: Maybe<Scalars['String']>;
    country?: Maybe<Country>;
    district?: Maybe<Scalars['String']>;
    /** Street address */
    headquarters?: Maybe<Scalars['String']>;
    id: Scalars['ID'];
    legalName?: Maybe<Scalars['String']>;
    postalCode?: Maybe<Scalars['String']>;
    /** Tax Identification Number */
    tin?: Maybe<Scalars['String']>;
}

export interface TablesStatistics {
    __typename?: 'TablesStatistics';
    billCount: Scalars['Int'];
    grossRevenue?: Maybe<Scalars['Int']>;
    id: Scalars['ID'];
    placeName: Scalars['String'];
    sectionId: Scalars['ID'];
    sectionName: Scalars['String'];
}

export interface Tax {
    __typename?: 'Tax';
    countryCode: Country;
    id: Scalars['ID'];
    name: Scalars['String'];
    rate: Scalars['Float'];
}


export interface TopCategories {
    __typename?: 'TopCategories';
    color?: Maybe<Color>;
    foodCost?: Maybe<Scalars['Float']>;
    id: Scalars['ID'];
    name: Scalars['String'];
    netMargin?: Maybe<Scalars['Int']>;
    productWithNoRecipeCount?: Maybe<Scalars['Int']>;
    quantity: Scalars['Float'];
    totalPriceSold: Scalars['Int'];
}

export interface TopEmployees {
    __typename?: 'TopEmployees';
    billCount: Scalars['Int'];
    firstName: Scalars['String'];
    id: Scalars['ID'];
    lastName: Scalars['String'];
    totalPriceSold: Scalars['Int'];
}

export interface TopProducts {
    __typename?: 'TopProducts';
    foodCost?: Maybe<Scalars['Float']>;
    id: Scalars['ID'];
    name: Scalars['String'];
    netMargin?: Maybe<Scalars['Int']>;
    quantity: Scalars['Float'];
    quantitySoldWithoutRecipe: Scalars['Float'];
    totalPriceSold: Scalars['Int'];
}

export interface TopTable {
    __typename?: 'TopTable';
    id: Scalars['ID'];
    name: Scalars['String'];
    orderQuantity: Scalars['Int'];
    totalPriceSold: Scalars['Int'];
}

export enum UnitType {
    G = 'G',
    Kg = 'Kg',
    Liter = 'Liter',
    Ml = 'Ml',
    Pcs = 'Pcs'
}

export interface UpdateBill {
    customPaymentMethodId?: Maybe<Scalars['ID']>;
    id: Scalars['ID'];
    paymentMethod: PaymentMethod;
}

export interface UpdateBillPrinter {
    billPrinterId: Scalars['String'];
    cashRegisterId: Scalars['String'];
}

export interface UpdateCategory {
    color?: Maybe<Color>;
    description?: Maybe<Scalars['String']>;
    name?: Maybe<Scalars['String']>;
    ordering?: Maybe<Scalars['Int']>;
    parentCategoryId?: Maybe<Scalars['ID']>;
}

export interface UpdateCustomPaymentMethodInput {
    isActive?: Maybe<Scalars['Boolean']>;
    name: Scalars['String'];
}

export interface UpdateOrderLine {
    __typename?: 'UpdateOrderLine';
    hasSeparatorAfter?: Maybe<Scalars['Boolean']>;
    note?: Maybe<Scalars['String']>;
    productId: Scalars['ID'];
    quantity: Scalars['Float'];
}

export interface UpdateOrderName {
    id: Scalars['ID'];
    name: Scalars['String'];
}


export interface Venue {
    __typename?: 'Venue';
    bills?: Maybe<Array<Bill>>;
    categories?: Maybe<Array<Category>>;
    cultureCode: Scalars['String'];
    customPaymentMethods?: Maybe<Array<CustomPaymentMethod>>;
    debt?: Maybe<Scalars['Int']>;
    defaultCurrency: Currency;
    defaultCurrencyCurrencyCode: CurrencyCode;
    defaultTimezone: Scalars['String'];
    discounts?: Maybe<Array<Discount>>;
    dueDate?: Maybe<Scalars['Date']>;
    eetId?: Maybe<Scalars['String']>;
    employees?: Maybe<Array<Employee>>;
    enterprise: Enterprise;
    enterpriseId: Scalars['ID'];
    id: Scalars['ID'];
    languageCode: Scalars['String'];
    legalEntity: LegalEntity;
    legalEntityId: Scalars['ID'];
    /** City */
    locality: Scalars['String'];
    name: Scalars['String'];
    orderLines?: Maybe<Array<OrderLine>>;
    orders?: Maybe<Array<Order>>;
    places?: Maybe<Array<Place>>;
    pohodaCentreId?: Maybe<Scalars['String']>;
    postalCode: Scalars['String'];
    /** Apartment, Suite, Box number, etc. */
    premise: Scalars['String'];
    products?: Maybe<Array<Product>>;
    sections?: Maybe<Array<Section>>;
    /** Street address */
    thoroughfare: Scalars['String'];
    venueSettings: VenueSettings;
    venueType: VenueType;
    warehouses?: Maybe<Array<Warehouse>>;
}

export interface VenueCreate {
    defaultLocale?: Maybe<Scalars['String']>;
    defaultTimezone?: Maybe<Scalars['String']>;
    eetId: Scalars['String'];
    id?: Maybe<Scalars['ID']>;
    /** City */
    locality: Scalars['String'];
    name: Scalars['String'];
    pohodaCentreId?: Maybe<Scalars['String']>;
    postalCode: Scalars['String'];
    /** Apartment, Suite, Box number, etc. */
    premise: Scalars['String'];
    /** Street address */
    thoroughfare: Scalars['String'];
}

export interface VenueSettings {
    __typename?: 'VenueSettings';
    id: Scalars['ID'];
    /** Forces venue shift to be open before operating cash register */
    isVenueShiftForced: Scalars['Boolean'];
}

export interface VenueShift {
    __typename?: 'VenueShift';
    cashDrawerOperations: Array<CashDrawerOperation>;
    cashIncome?: Maybe<Scalars['Int']>;
    cashRegister?: Maybe<CashRegister>;
    cashRegisterId?: Maybe<Scalars['String']>;
    customPaymentMethodAmount?: Maybe<Scalars['Int']>;
    expectedCashAmount?: Maybe<Scalars['Int']>;
    expectedCreditCardAmount?: Maybe<Scalars['Int']>;
    finalCashAmount?: Maybe<Scalars['Int']>;
    finalCreditCardAmount?: Maybe<Scalars['Int']>;
    finishedBy?: Maybe<Employee>;
    finishedById: Scalars['ID'];
    finishedUtc?: Maybe<Scalars['Date']>;
    id: Scalars['ID'];
    initialCashAmount: Scalars['Int'];
    paymentIntegrationAmounts?: Maybe<Array<PaymentIntegrationAmount>>;
    startedBy: Employee;
    startedById: Scalars['ID'];
    startedUtc: Scalars['Date'];
    venue: Venue;
}

export enum VenueType {
    Ecommerce = 'Ecommerce',
    Restaurant = 'Restaurant'
}

export interface VenueUpdate {
    defaultLocale?: Maybe<Scalars['String']>;
    defaultTimezone?: Maybe<Scalars['String']>;
    eetId?: Maybe<Scalars['String']>;
    /** City */
    locality?: Maybe<Scalars['String']>;
    name?: Maybe<Scalars['String']>;
    pohodaCentreId?: Maybe<Scalars['String']>;
    postalCode?: Maybe<Scalars['String']>;
    /** Apartment, Suite, Box number, etc. */
    premise?: Maybe<Scalars['String']>;
    /** Street address */
    thoroughfare?: Maybe<Scalars['String']>;
}

export interface VoidedBills {
    __typename?: 'VoidedBills';
    itemCount: Scalars['Int'];
    voidedValue: Scalars['Int'];
}

export interface Warehouse {
    __typename?: 'Warehouse';
    createdAtUtc: Scalars['Date'];
    createdById: Scalars['ID'];
    deductionLists?: Maybe<Array<DeductionList>>;
    deleteDateUtc?: Maybe<Scalars['Date']>;
    deletedById?: Maybe<Scalars['ID']>;
    deliveryLists?: Maybe<Array<DeliveryList>>;
    enterprise: Enterprise;
    enterpriseId: Scalars['ID'];
    id: Scalars['ID'];
    inventoryCounts?: Maybe<Array<InventoryCount>>;
    name: Scalars['String'];
    pricingMode: StockLevelPricingMode;
    stockCardCategories?: Maybe<Array<StockCardCategory>>;
    stockCards: Array<StockCard>;
    stockLevels?: Maybe<Array<StockLevel>>;
    updatedAtUtc?: Maybe<Scalars['Date']>;
    updatedById?: Maybe<Scalars['ID']>;
    venueIds: Array<Scalars['ID']>;
    version: Scalars['Int'];
}

export interface WarehouseCreate {
    id?: Maybe<Scalars['ID']>;
    name: Scalars['String'];
    pricingMode?: Maybe<StockLevelPricingMode>;
    venueIds: Array<Scalars['ID']>;
}

export enum WarehousePermission {
    CanAddDeductionList = 'CAN_ADD_DEDUCTION_LIST',
    CanAddDeliveryList = 'CAN_ADD_DELIVERY_LIST',
    CanAddStockCard = 'CAN_ADD_STOCK_CARD',
    CanAddStockCardCategory = 'CAN_ADD_STOCK_CARD_CATEGORY',
    CanAddWarehouse = 'CAN_ADD_WAREHOUSE',
    CanCreateRecipes = 'CAN_CREATE_RECIPES',
    CanDeleteRecipes = 'CAN_DELETE_RECIPES',
    CanDeleteStockCard = 'CAN_DELETE_STOCK_CARD',
    CanDeleteStockCardCategory = 'CAN_DELETE_STOCK_CARD_CATEGORY',
    CanDeleteWarehouse = 'CAN_DELETE_WAREHOUSE',
    CanEndInventoryCount = 'CAN_END_INVENTORY_COUNT',
    CanStartInventoryCount = 'CAN_START_INVENTORY_COUNT',
    CanUpdateInventoryCounts = 'CAN_UPDATE_INVENTORY_COUNTS',
    CanUpdateRecipes = 'CAN_UPDATE_RECIPES',
    CanUpdateStockCard = 'CAN_UPDATE_STOCK_CARD',
    CanUpdateStockCardCategory = 'CAN_UPDATE_STOCK_CARD_CATEGORY',
    CanUpdateWarehouse = 'CAN_UPDATE_WAREHOUSE',
    CanViewDeductionList = 'CAN_VIEW_DEDUCTION_LIST',
    CanViewDeliveryList = 'CAN_VIEW_DELIVERY_LIST',
    CanViewInventoryCount = 'CAN_VIEW_INVENTORY_COUNT',
    CanViewInventoryCountExpectedValuation = 'CAN_VIEW_INVENTORY_COUNT_EXPECTED_VALUATION',
    CanViewInventoryCountItemExpectedCount = 'CAN_VIEW_INVENTORY_COUNT_ITEM_EXPECTED_COUNT',
    CanViewInventoryCountRealValuation = 'CAN_VIEW_INVENTORY_COUNT_REAL_VALUATION',
    CanViewStockCard = 'CAN_VIEW_STOCK_CARD',
    CanViewStockCardCategory = 'CAN_VIEW_STOCK_CARD_CATEGORY',
    CanViewStockCardLeftovers = 'CAN_VIEW_STOCK_CARD_LEFTOVERS',
    CanViewWarehouse = 'CAN_VIEW_WAREHOUSE'
}

export interface WarehouseUpdate {
    name?: Maybe<Scalars['String']>;
    pricingMode?: Maybe<StockLevelPricingMode>;
    venueIds?: Maybe<Array<Scalars['ID']>>;
}

export interface WithWithoutVat {
    __typename?: 'WithWithoutVat';
    withoutVat: Scalars['Int'];
    withVat: Scalars['Int'];
}

export interface CategoriesFragment { __typename?: 'Category'; name: string; id: string }

export interface DevicesFragment { __typename?: 'Device'; id: string; name: string; customName?: Maybe<string> }

export interface TaxesFragment { __typename?: 'Tax'; name: string; id: string }

export interface VenuesFragment { __typename?: 'Venue'; name: string; id: string }

export interface SectionsFragment { __typename?: 'Section'; name: string; id: string }

export interface WarehousesFragment { __typename?: 'Warehouse'; name: string; id: string }

export interface SuppliersFragment { __typename?: 'Supplier'; id: string; legalName: string }

export type SwitchVenueMutationVariables = Exact<{
    venueId: Scalars['String'];
}>;


export interface SwitchVenueMutation { __typename?: 'Mutation'; switchVenue: string }

export interface VenuesWithPohodaCentreIdFragment { __typename?: 'Venue'; pohodaCentreId?: Maybe<string> }

export type GetInitInfoQueryVariables = Exact<{ [key: string]: never }>;


export interface GetInitInfoQuery { __typename?: 'Query'; venues: Array<{ __typename?: 'Venue'; pohodaCentreId?: Maybe<string>; dueDate?: Maybe<any>; debt?: Maybe<number>; name: string; id: string }>; employeePermissions: { __typename?: 'AppPermissions'; warehouse: Array<WarehousePermission>; backoffice: Array<BackofficePermission> } }

export type BillsQueryVariables = Exact<{
    offset?: Maybe<Scalars['Int']>;
    limit?: Maybe<Scalars['Int']>;
    filters?: Maybe<BillFilters>;
}>;


export interface BillsQuery { __typename?: 'Query'; bills: Array<{ __typename?: 'Bill'; id: string; total: number; dicountedTotalValue?: Maybe<number>; roundedPrice?: Maybe<number>; issuedUtc: any; billState: BillState; billNumber: string; paymentMethod: PaymentMethod; totalPriceCurrency: { __typename?: 'Currency'; currencyCode: CurrencyCode }; fiscalRecord?: Maybe<{ __typename?: 'FiscalRecord'; id: string; state: FiscalRecordState }>; place?: Maybe<{ __typename?: 'Place'; id: string; name: string }>; issuedBy: { __typename?: 'Employee'; id: string; account: { __typename?: 'Account'; id: string; firstName: string; lastName: string; imageUrl?: Maybe<string> } }; customPaymentMethod?: Maybe<{ __typename?: 'CustomPaymentMethod'; name: string }> }> }

export type BillQueryVariables = Exact<{
    id: Scalars['String'];
}>;


export interface BillQuery { __typename?: 'Query'; bill: { __typename?: 'Bill'; id: string; total: number; dicountedTotalValue?: Maybe<number>; roundedPrice?: Maybe<number>; issuedUtc: any; billState: BillState; billNumber: string; paymentMethod: PaymentMethod; order: { __typename?: 'Order'; id: string; name?: Maybe<string>; orderNumber?: Maybe<string>; place?: Maybe<{ __typename?: 'Place'; id: string; name: string }> }; orderLines: Array<{ __typename?: 'OrderLine'; id: string; price: number; discountedPrice?: Maybe<number>; discountedUnitPrice?: Maybe<number>; quantity: number; unitPrice: number; priceCurrency: { __typename?: 'Currency'; currencyCode: CurrencyCode }; tax?: Maybe<{ __typename?: 'Tax'; id: string; rate: number }>; product: { __typename?: 'Product'; id: string; name: string; tax: { __typename?: 'Tax'; id: string; rate: number } } }>; totalPriceCurrency: { __typename?: 'Currency'; currencyCode: CurrencyCode }; place?: Maybe<{ __typename?: 'Place'; id: string; name: string }>; issuedBy: { __typename?: 'Employee'; id: string; account: { __typename?: 'Account'; id: string; firstName: string; lastName: string; imageUrl?: Maybe<string> } }; customPaymentMethod?: Maybe<{ __typename?: 'CustomPaymentMethod'; name: string }> } }

export interface SectionsOptionFragment { __typename?: 'Section'; name: string; id: string; places?: Maybe<Array<{ __typename?: 'Place'; id: string; name: string }>> }

export interface EmployeeOptionFragment { __typename?: 'Employee'; id: string; account: { __typename?: 'Account'; id: string; firstName: string; lastName: string } }

export type GetBillFiltersOptionsQueryVariables = Exact<{ [key: string]: never }>;


export interface GetBillFiltersOptionsQuery { __typename?: 'Query'; sections: Array<{ __typename?: 'Section'; name: string; id: string; places?: Maybe<Array<{ __typename?: 'Place'; id: string; name: string }>> }>; employees: Array<{ __typename?: 'Employee'; id: string; account: { __typename?: 'Account'; id: string; firstName: string; lastName: string } }> }

export type VenueShiftsQueryVariables = Exact<{
    offset?: Maybe<Scalars['Int']>;
    limit?: Maybe<Scalars['Int']>;
    dateFromTo?: Maybe<DateFromTo>;
}>;


export interface VenueShiftsQuery { __typename?: 'Query'; venueShifts: Array<{ __typename?: 'VenueShift'; id: string; startedUtc: any; finishedUtc?: Maybe<any>; initialCashAmount: number; expectedCashAmount?: Maybe<number>; finalCashAmount?: Maybe<number>; expectedCreditCardAmount?: Maybe<number>; finalCreditCardAmount?: Maybe<number>; cashIncome?: Maybe<number>; cashDrawerOperations: Array<{ __typename?: 'CashDrawerOperation'; id: string; amount: number; createdUtc: any; note?: Maybe<string>; createdBy: { __typename?: 'Employee'; account: { __typename?: 'Account'; firstName: string; lastName: string } } }>; startedBy: { __typename?: 'Employee'; account: { __typename?: 'Account'; firstName: string; lastName: string } }; finishedBy?: Maybe<{ __typename?: 'Employee'; account: { __typename?: 'Account'; firstName: string; lastName: string } }> }> }

export type GetCashDrawerReportQueryVariables = Exact<{
    dateFromTo?: Maybe<DateFromTo>;
}>;


export interface GetCashDrawerReportQuery { __typename?: 'Query'; cashDrawerReport: string }

export type CreateCategoryMutationVariables = Exact<{
    name: Scalars['String'];
    id?: Maybe<Scalars['ID']>;
    parentCategoryId?: Maybe<Scalars['ID']>;
    childCategories?: Maybe<Array<Scalars['String']> | Scalars['String']>;
    color?: Maybe<Color>;
}>;


export interface CreateCategoryMutation { __typename?: 'Mutation'; createCategory: { __typename?: 'Category'; id: string; name: string; description?: Maybe<string>; category?: Maybe<{ __typename?: 'Category'; id: string; name: string }> } }

export type UpdateCategoryMutationVariables = Exact<{
    id: Scalars['String'];
    name?: Maybe<Scalars['String']>;
    description?: Maybe<Scalars['String']>;
    parentCategoryId?: Maybe<Scalars['ID']>;
    color?: Maybe<Color>;
}>;


export interface UpdateCategoryMutation { __typename?: 'Mutation'; updateCategory: { __typename?: 'Category'; id: string; name: string; description?: Maybe<string>; color?: Maybe<Color>; category?: Maybe<{ __typename?: 'Category'; id: string }> } }

export type RemoveCategoryMutationVariables = Exact<{
    id: Scalars['String'];
}>;


export interface RemoveCategoryMutation { __typename?: 'Mutation'; removeCategory: boolean }

export type CategoryQueryVariables = Exact<{
    id: Scalars['String'];
}>;


export interface CategoryQuery { __typename?: 'Query'; category?: Maybe<{ __typename?: 'Category'; name: string; description?: Maybe<string>; id: string; color?: Maybe<Color>; category?: Maybe<{ __typename?: 'Category'; id: string }> }>; categories: Array<{ __typename?: 'Category'; name: string; id: string }> }

export type ProductsByCategoryQueryVariables = Exact<{
    categoryId: Scalars['String'];
}>;


export interface ProductsByCategoryQuery { __typename?: 'Query'; productsByCategory: Array<{ __typename?: 'Product'; name: string; id: string }> }

export type CategoriesQueryVariables = Exact<{ [key: string]: never }>;


export interface CategoriesQuery { __typename?: 'Query'; categories: Array<{ __typename?: 'Category'; id: string; name: string; color?: Maybe<Color>; description?: Maybe<string>; ordering?: Maybe<number>; category?: Maybe<{ __typename?: 'Category'; id: string }> }>; categoriesProductCount?: Maybe<Array<{ __typename?: 'CategoryProductCount'; categoryId: string; productCount: number }>> }

export type GetCategoryOptionsQueryVariables = Exact<{ [key: string]: never }>;


export interface GetCategoryOptionsQuery { __typename?: 'Query'; categories: Array<{ __typename?: 'Category'; name: string; id: string }> }

export type TopEmployeesQueryVariables = Exact<{
    dateFromTo: DateFromTo;
}>;


export interface TopEmployeesQuery { __typename?: 'Query'; topEmployees: Array<{ __typename?: 'TopEmployees'; id: string; firstName: string; lastName: string; billCount: number; totalPriceSold: number }> }

export type TopProductsQueryVariables = Exact<{
    dateFromTo: DateFromTo;
}>;


export interface TopProductsQuery { __typename?: 'Query'; topProducts: Array<{ __typename?: 'TopProducts'; id: string; name: string; quantity: number; totalPriceSold: number; netMargin?: Maybe<number>; foodCost?: Maybe<number> }> }

export type UnpopularProductsQueryVariables = Exact<{
    dateFromTo: DateFromTo;
}>;


export interface UnpopularProductsQuery { __typename?: 'Query'; unpopularProducts: Array<{ __typename?: 'TopProducts'; id: string; name: string; quantity: number; totalPriceSold: number; netMargin?: Maybe<number>; foodCost?: Maybe<number> }> }

export type TopCategoriesQueryVariables = Exact<{
    dateFromTo: DateFromTo;
}>;


export interface TopCategoriesQuery { __typename?: 'Query'; topCategories: Array<{ __typename?: 'TopCategories'; id: string; name: string; totalPriceSold: number; quantity: number; color?: Maybe<Color>; netMargin?: Maybe<number>; foodCost?: Maybe<number>; productWithNoRecipeCount?: Maybe<number> }> }

export type UnpopularCategoriesQueryVariables = Exact<{
    dateFromTo: DateFromTo;
}>;


export interface UnpopularCategoriesQuery { __typename?: 'Query'; unpopularCategories: Array<{ __typename?: 'TopCategories'; id: string; name: string; totalPriceSold: number; quantity: number; color?: Maybe<Color>; netMargin?: Maybe<number>; foodCost?: Maybe<number>; productWithNoRecipeCount?: Maybe<number> }> }

export type TopTableQueryVariables = Exact<{
    dateFromTo: DateFromTo;
}>;


export interface TopTableQuery { __typename?: 'Query'; topTable: { __typename?: 'TopTable'; id: string; name: string; orderQuantity: number; totalPriceSold: number } }

export type PendingOrdersQueryVariables = Exact<{ [key: string]: never }>;


export interface PendingOrdersQuery { __typename?: 'Query'; pendingOrders: { __typename?: 'PendingOrdersInfo'; pendingTotalPrice: number; orderQuantity: number } }

export type SalesChartQueryVariables = Exact<{
    dateFromTo: DateFromTo;
}>;


export interface SalesChartQuery { __typename?: 'Query'; salesChartData: Array<{ __typename?: 'SalesChartData'; income?: Maybe<number>; date: any; paymentMethod?: Maybe<PaymentMethod> }> }

export type GrossIncomeByPaymentMethodQueryVariables = Exact<{
    dateFromTo: DateFromTo;
}>;


export interface GrossIncomeByPaymentMethodQuery { __typename?: 'Query'; venues: Array<{ __typename?: 'Venue'; id: string; dueDate?: Maybe<any>; debt?: Maybe<number> }>; employeePermissions: { __typename?: 'AppPermissions'; warehouse: Array<WarehousePermission>; backoffice: Array<BackofficePermission> }; grossIncomeByPaymentMethod: Array<{ __typename?: 'GrossIncomeByPaymentMethod'; income: number; paymentMethod: PaymentMethod; paymentIntegrationPartner?: Maybe<PaymentIntegrationPartner> }> }

export type AverageOrderStatisticsQueryVariables = Exact<{
    dateFromTo: DateFromTo;
}>;


export interface AverageOrderStatisticsQuery { __typename?: 'Query'; averageOrderStatistics: { __typename?: 'AverageOrderStatistics'; billCount: number; itemsPerOrder: number; averageBillAmount: number; orderCount: number } }

export type CancelationsDiscountsVoidedQueryVariables = Exact<{
    dateFromTo: DateFromTo;
}>;


export interface CancelationsDiscountsVoidedQuery { __typename?: 'Query'; voidedBills: { __typename?: 'VoidedBills'; itemCount: number; voidedValue: number }; discountedOrderLines: { __typename?: 'DiscountedOrderLines'; itemCount: number; discountedValue: number }; canceledOrderLines: { __typename?: 'CanceledOrderLines'; itemCount: number; canceledValue: number } }

export type GetMoneyFlowReportQueryVariables = Exact<{
    dateFromTo?: Maybe<DateFromTo>;
}>;


export interface GetMoneyFlowReportQuery { __typename?: 'Query'; moneyFlowReport: string }

export type PaginatedDeductionListsQueryVariables = Exact<{
    deductionDateUtc?: Maybe<Scalars['Date']>;
    deductionReason?: Maybe<DeductionReason>;
    isProcessed?: Maybe<Scalars['Boolean']>;
    limit?: Maybe<Scalars['Int']>;
    offset?: Maybe<Scalars['Int']>;
    warehouseId: Scalars['ID'];
}>;


export interface PaginatedDeductionListsQuery { __typename?: 'Query'; paginatedDeductionLists: { __typename?: 'PaginatedDeductionLists'; count: number; items: Array<{ __typename?: 'DeductionList'; id: string; deductionReason: DeductionReason; deductionDateUtc: any; deductionListItemsCount: number; deductionListItemsTotalCost: number; createdBy: { __typename?: 'CreatedBy'; employeeId: string; firstName: string; lastName: string } }> } }

export type PaginatedDeductionListItemsQueryVariables = Exact<{
    deductionListId: Scalars['ID'];
    limit?: Maybe<Scalars['Int']>;
    offset?: Maybe<Scalars['Int']>;
}>;


export interface PaginatedDeductionListItemsQuery { __typename?: 'Query'; paginatedDeductionListItems: { __typename?: 'PaginatedDeductionListItems'; count: number; items: Array<{ __typename?: 'DeductionListItem'; id: string; priceWithoutVat: number; quantity: number; unitType: UnitType; stockCard: { __typename?: 'StockCard'; id: string; name: string } }> } }

export type DeductionListQueryVariables = Exact<{
    id: Scalars['ID'];
    warehouseId: Scalars['ID'];
}>;


export interface DeductionListQuery { __typename?: 'Query'; deductionList: { __typename?: 'DeductionList'; id: string; deductionDateUtc: any; deductionListItemsCount: number; deductionListItemsTotalCost: number; deductionReason: DeductionReason; createdBy: { __typename?: 'CreatedBy'; employeeId: string; firstName: string; lastName: string } } }

export type UploadInvoicesMutationVariables = Exact<{
    files: Array<Scalars['Upload']> | Scalars['Upload'];
    warehouseId: Scalars['ID'];
}>;


export interface UploadInvoicesMutation { __typename?: 'Mutation'; uploadInvoices: Array<string> }

export type DeleteRossumUploadMutationVariables = Exact<{
    rossumUploadId: Scalars['ID'];
}>;


export interface DeleteRossumUploadMutation { __typename?: 'Mutation'; deleteRossumUpload: boolean }

export type CompleteRossumUploadMutationVariables = Exact<{
    rossumUploadId: Scalars['ID'];
}>;


export interface CompleteRossumUploadMutation { __typename?: 'Mutation'; completeRossumUpload: { __typename?: 'RossumUpload'; id: string; status: RossumUploadStatus } }

export type CreateOrReplaceDeliveryOptionsMutationVariables = Exact<{
    deliveryOptions: Array<DeliveryOptionCreate> | DeliveryOptionCreate;
}>;


export interface CreateOrReplaceDeliveryOptionsMutation { __typename?: 'Mutation'; createOrReplaceDeliveryOptions: Array<{ __typename?: 'DeliveryOption'; itemCode: string; supplierId: string; stockCardId: string; conversionUnitType: UnitType; conversionMultiplier: number }> }

export type CreateDeliveryListMutationVariables = Exact<{
    data: DeliveryListCreate;
}>;


export interface CreateDeliveryListMutation { __typename?: 'Mutation'; createDeliveryList: { __typename?: 'DeliveryList'; id: string; invoiceNumber?: Maybe<string> } }

export type UpdateStockCardCategoryMutationVariables = Exact<{
    id: Scalars['ID'];
    data: StockCardCategoryUpdate;
}>;


export interface UpdateStockCardCategoryMutation { __typename?: 'Mutation'; updateStockCardCategory: { __typename?: 'StockCardCategory'; id: string; name: string } }

export type RossumUploadsByWarehouseIdQueryVariables = Exact<{
    warehouseId: Scalars['ID'];
}>;


export interface RossumUploadsByWarehouseIdQuery { __typename?: 'Query'; rossumUploadsByWarehouseId: Array<{ __typename?: 'RossumUpload'; id: string; createdAtUtc: any; filename: string; rossumAnnotationUrl: string; status: RossumUploadStatus }> }

export type RossumProcessedInvoiceByRossumUploadIdQueryVariables = Exact<{
    rossumUploadId: Scalars['ID'];
    warehouseId: Scalars['ID'];
}>;


export interface RossumProcessedInvoiceByRossumUploadIdQuery { __typename?: 'Query'; rossumProcessedInvoiceByRossumUploadId?: Maybe<{ __typename?: 'RossumProcessedInvoice'; invoiceNumber?: Maybe<string>; deliveryDate: any; supplierId: string; totalAmount?: Maybe<number>; processedListItems: Array<{ __typename?: 'RossumProcessedListItem'; id: string; code: string; description: string; quantity: number; vatRate?: Maybe<number>; unitPrice?: Maybe<number>; unitPriceWithoutVat?: Maybe<number>; totalBase?: Maybe<number>; totalAmount?: Maybe<number>; unitOfMeasure?: Maybe<UnitType>; deliveryOption?: Maybe<{ __typename?: 'DeliveryOption'; stockCardId: string; conversionUnitType: UnitType; conversionMultiplier: number }> }> }> }

export type PaginatedDeliveryListsQueryVariables = Exact<{
    offset?: Maybe<Scalars['Int']>;
    limit?: Maybe<Scalars['Int']>;
    warehouseId: Scalars['ID'];
    supplierId?: Maybe<Scalars['ID']>;
    invoiceNumber?: Maybe<Scalars['String']>;
    deliveryDateUtc?: Maybe<Scalars['Date']>;
    isProcessed?: Maybe<Scalars['Boolean']>;
}>;


export interface PaginatedDeliveryListsQuery { __typename?: 'Query'; paginatedDeliveryLists: { __typename?: 'PaginatedDeliveryLists'; count: number; items: Array<{ __typename?: 'DeliveryList'; id: string; createdAtUtc: any; updatedAtUtc?: Maybe<any>; createdById: string; invoiceNumber?: Maybe<string>; deliveryDateUtc: any; isProcessed?: Maybe<boolean>; deliveryListItemsCount: number; deliveryListItemsTotalCost: number; supplier: { __typename?: 'Supplier'; id: string; legalName: string } }> } }

export type ExistingSuppliersQueryVariables = Exact<{ [key: string]: never }>;


export interface ExistingSuppliersQuery { __typename?: 'Query'; existingSuppliers: Array<{ __typename?: 'Supplier'; id: string; legalName: string }> }

export type DeliveryListQueryVariables = Exact<{
    id: Scalars['ID'];
    warehouseId: Scalars['ID'];
}>;


export interface DeliveryListQuery { __typename?: 'Query'; deliveryList: { __typename?: 'DeliveryList'; id: string; createdAtUtc: any; updatedAtUtc?: Maybe<any>; createdById: string; invoiceNumber?: Maybe<string>; deliveryDateUtc: any; isProcessed?: Maybe<boolean>; deliveryListItemsCount: number; deliveryListItemsTotalCost: number; supplier: { __typename?: 'Supplier'; id: string; legalName: string }; deliveryListItems: Array<{ __typename?: 'DeliveryListItem'; id: string; quantity: number; priceWithoutVat: number; deliveryListId: string; stockCard: { __typename?: 'StockCard'; id: string; name: string; storageUnit: UnitType; conversionUnit?: Maybe<UnitType>; convertedAmount?: Maybe<number> } }> } }

export type StockCardCategoryQueryVariables = Exact<{
    id: Scalars['ID'];
}>;


export interface StockCardCategoryQuery { __typename?: 'Query'; stockCardCategory: { __typename?: 'StockCardCategory'; id: string; name: string } }

export type DeliveryListStockCardsQueryVariables = Exact<{
    warehouseIds: Array<Scalars['ID']> | Scalars['ID'];
    offset?: Maybe<Scalars['Int']>;
    limit?: Maybe<Scalars['Int']>;
    stockCardCategoryId?: Maybe<Scalars['ID']>;
    nameOrSku?: Maybe<Scalars['String']>;
}>;


export interface DeliveryListStockCardsQuery { __typename?: 'Query'; stockCards: Array<{ __typename?: 'StockCard'; id: string; name: string; storageUnit: UnitType; conversionUnit?: Maybe<UnitType>; convertedAmount?: Maybe<number>; sku?: Maybe<string>; taxId: string; stockLevels: Array<{ __typename?: 'StockLevel'; id: string; priceWithoutVat: number; warehouseId: string }>; tax: { __typename?: 'Tax'; rate: number } }> }

export type DeliveryListSuppliersQueryVariables = Exact<{
    offset?: Maybe<Scalars['Int']>;
    limit?: Maybe<Scalars['Int']>;
    multiValueSearch?: Maybe<Scalars['String']>;
}>;


export interface DeliveryListSuppliersQuery { __typename?: 'Query'; suppliers: Array<{ __typename?: 'Supplier'; id: string; legalName: string }> }

export type InvoiceStatusUpdatesSubscriptionVariables = Exact<{
    warehouseId: Scalars['ID'];
}>;


export interface InvoiceStatusUpdatesSubscription { __typename?: 'Subscription'; invoiceStatusUpdates: { __typename?: 'InvoiceStatusUpdate'; annotation: string; status: RossumUploadStatus } }

export type CreateDiscountMutationVariables = Exact<{
    rate: Scalars['Float'];
    name: Scalars['String'];
    description?: Maybe<Scalars['String']>;
}>;


export interface CreateDiscountMutation { __typename?: 'Mutation'; createDiscount: { __typename?: 'Discount'; id: string; rate: number; name: string; description?: Maybe<string> } }

export type UpdateDiscountMutationVariables = Exact<{
    id: Scalars['String'];
    rate?: Maybe<Scalars['Float']>;
    name?: Maybe<Scalars['String']>;
    description?: Maybe<Scalars['String']>;
}>;


export interface UpdateDiscountMutation { __typename?: 'Mutation'; updateDiscount: { __typename?: 'Discount'; id: string; rate: number; name: string; description?: Maybe<string> } }

export type RemoveDiscountMutationVariables = Exact<{
    id: Scalars['String'];
}>;


export interface RemoveDiscountMutation { __typename?: 'Mutation'; removeDiscount: boolean }

export type GetDiscountsQueryVariables = Exact<{ [key: string]: never }>;


export interface GetDiscountsQuery { __typename?: 'Query'; discounts: Array<{ __typename?: 'Discount'; id: string; name: string; description?: Maybe<string>; rate: number }> }

export type GetDiscountQueryVariables = Exact<{
    id: Scalars['String'];
}>;


export interface GetDiscountQuery { __typename?: 'Query'; discount: { __typename?: 'Discount'; id: string; name: string; description?: Maybe<string>; rate: number } }

export type RegisterEmployeeMutationVariables = Exact<{
    venueIds: Array<Scalars['ID']> | Scalars['ID'];
    defaultVenueId: Scalars['ID'];
    firstName: Scalars['String'];
    lastName: Scalars['String'];
    email: Scalars['String'];
    pin?: Maybe<Scalars['String']>;
    password: Scalars['String'];
    imageUrl?: Maybe<Scalars['String']>;
    role?: Maybe<Role>;
}>;


export interface RegisterEmployeeMutation { __typename?: 'Mutation'; registerEmployee: { __typename?: 'Employee'; id: string; pin?: Maybe<string>; role: Role; account: { __typename?: 'Account'; id: string; firstName: string; lastName: string; email: string }; venues: Array<{ __typename?: 'Venue'; id: string; name: string }>; currentVenue: { __typename?: 'Venue'; id: string; name: string } } }

export type UpdateEmployeeMutationVariables = Exact<{
    id: Scalars['String'];
    venueIds?: Maybe<Array<Scalars['ID']> | Scalars['ID']>;
    defaultVenueId?: Maybe<Scalars['ID']>;
    pin?: Maybe<Scalars['String']>;
    email?: Maybe<Scalars['String']>;
    password?: Maybe<Scalars['String']>;
    firstName?: Maybe<Scalars['String']>;
    lastName?: Maybe<Scalars['String']>;
    role?: Maybe<Role>;
}>;


export interface UpdateEmployeeMutation { __typename?: 'Mutation'; updateEmployee: { __typename?: 'Employee'; id: string; pin?: Maybe<string>; role: Role; account: { __typename?: 'Account'; id: string; firstName: string; lastName: string; email: string }; venues: Array<{ __typename?: 'Venue'; id: string; name: string }>; currentVenue: { __typename?: 'Venue'; id: string; name: string } } }

export type DeleteEmployeeMutationVariables = Exact<{
    id: Scalars['String'];
}>;


export interface DeleteEmployeeMutation { __typename?: 'Mutation'; deleteEmployee: boolean }

export type EmployeesQueryVariables = Exact<{ [key: string]: never }>;


export interface EmployeesQuery { __typename?: 'Query'; employees: Array<{ __typename?: 'Employee'; id: string; pin?: Maybe<string>; role: Role; account: { __typename?: 'Account'; id: string; firstName: string; lastName: string; email: string }; venues: Array<{ __typename?: 'Venue'; id: string; name: string }>; currentVenue: { __typename?: 'Venue'; id: string; name: string } }> }

export type GetEmployeeQueryVariables = Exact<{
    id: Scalars['String'];
}>;


export interface GetEmployeeQuery { __typename?: 'Query'; employee: { __typename?: 'Employee'; id: string; pin?: Maybe<string>; role: Role; account: { __typename?: 'Account'; id: string; firstName: string; lastName: string; email: string }; venues: Array<{ __typename?: 'Venue'; id: string; name: string }>; currentVenue: { __typename?: 'Venue'; id: string; name: string } }; venues: Array<{ __typename?: 'Venue'; name: string; id: string }> }

export type CreateEmployeeFormQueryVariables = Exact<{ [key: string]: never }>;


export interface CreateEmployeeFormQuery { __typename?: 'Query'; venues: Array<{ __typename?: 'Venue'; name: string; id: string }> }

export type LoginEmployeeMutationVariables = Exact<{
    email: Scalars['String'];
    password: Scalars['String'];
}>;


export interface LoginEmployeeMutation { __typename?: 'Mutation'; loginEmployee: string }

export type GetAccountsQueryVariables = Exact<{ [key: string]: never }>;


export interface GetAccountsQuery { __typename?: 'Query'; accounts: Array<{ __typename?: 'Account'; id: string; firstName: string; lastName: string; email: string }> }

export type GetAccountQueryVariables = Exact<{
    id: Scalars['String'];
}>;


export interface GetAccountQuery { __typename?: 'Query'; account?: Maybe<{ __typename?: 'Account'; id: string; firstName: string; lastName: string; email: string }> }

export type OrdersQueryVariables = Exact<{
    offset?: Maybe<Scalars['Int']>;
    limit?: Maybe<Scalars['Int']>;
    filters?: Maybe<OrderFilters>;
}>;


export interface OrdersQuery { __typename?: 'Query'; orders: Array<{ __typename?: 'Order'; id: string; createdUtc: any; orderState: OrderState; name?: Maybe<string>; orderNumber?: Maybe<string>; bills: Array<{ __typename?: 'Bill'; id: string; billState: BillState; total: number; dicountedTotalValue?: Maybe<number>; roundedPrice?: Maybe<number> }>; openedBy: { __typename?: 'Employee'; account: { __typename?: 'Account'; id: string; firstName: string; lastName: string; imageUrl?: Maybe<string> } }; orderLines: Array<{ __typename?: 'OrderLine'; id: string; price: number; orderLineState: AccountingItemState; billId?: Maybe<string>; quantity: number; tax?: Maybe<{ __typename?: 'Tax'; id: string; rate: number }>; product: { __typename?: 'Product'; id: string; name: string; priceSell: number; tax: { __typename?: 'Tax'; id: string; rate: number } } }>; place?: Maybe<{ __typename?: 'Place'; id: string; name: string }> }> }

export type OrderQueryVariables = Exact<{
    id: Scalars['String'];
}>;


export interface OrderQuery { __typename?: 'Query'; order: { __typename?: 'Order'; id: string; createdUtc: any; orderState: OrderState; name?: Maybe<string>; orderNumber?: Maybe<string>; openedBy: { __typename?: 'Employee'; account: { __typename?: 'Account'; id: string; firstName: string; lastName: string; imageUrl?: Maybe<string> } }; closedBy?: Maybe<{ __typename?: 'Employee'; account: { __typename?: 'Account'; id: string; firstName: string; lastName: string; imageUrl?: Maybe<string> } }>; orderLines: Array<{ __typename?: 'OrderLine'; id: string; price: number; unitPrice: number; quantity: number; discountedPrice?: Maybe<number>; discountedUnitPrice?: Maybe<number>; orderLineState: AccountingItemState; billId?: Maybe<string>; tax?: Maybe<{ __typename?: 'Tax'; id: string; rate: number }>; product: { __typename?: 'Product'; id: string; name: string; tax: { __typename?: 'Tax'; id: string; rate: number } } }>; bills: Array<{ __typename?: 'Bill'; id: string; issuedUtc: any; billNumber: string; total: number; dicountedTotalValue?: Maybe<number>; roundedPrice?: Maybe<number>; billState: BillState }>; place?: Maybe<{ __typename?: 'Place'; id: string; name: string }> } }

export type GetOrderFiltersOptionsQueryVariables = Exact<{ [key: string]: never }>;


export interface GetOrderFiltersOptionsQuery { __typename?: 'Query'; sections: Array<{ __typename?: 'Section'; name: string; id: string; places?: Maybe<Array<{ __typename?: 'Place'; id: string; name: string }>> }>; employees: Array<{ __typename?: 'Employee'; id: string; account: { __typename?: 'Account'; id: string; firstName: string; lastName: string } }> }

export type TimelineQueryVariables = Exact<{
    orderId: Scalars['String'];
}>;


export interface TimelineQuery { __typename?: 'Query'; timeline: Array<any> }

export type RemoveProductMutationVariables = Exact<{
    id: Scalars['String'];
}>;


export interface RemoveProductMutation { __typename?: 'Mutation'; removeProduct: boolean }

export type CreateProductAndRecipeMutationVariables = Exact<{
    product: ProductCreate;
    recipe?: Maybe<RecipeCreateWithProduct>;
}>;


export interface CreateProductAndRecipeMutation { __typename?: 'Mutation'; createProductAndRecipe: { __typename?: 'Product'; id: string; name: string; priceSell: number; priceBuy?: Maybe<number>; showInPos: boolean; pohodaStockItemId?: Maybe<string>; categoryId: string; taxId: string; toGoTaxId?: Maybe<string>; priceBuyCurrency?: Maybe<{ __typename?: 'Currency'; currencyCode: CurrencyCode }>; printingDevices?: Maybe<Array<{ __typename?: 'Device'; id: string; name: string; customName?: Maybe<string> }>> } }

export type UpdateProductAndRecipeMutationVariables = Exact<{
    id: Scalars['String'];
    product: ProductUpdate;
    recipe?: Maybe<RecipeUpdateWithProduct>;
}>;


export interface UpdateProductAndRecipeMutation { __typename?: 'Mutation'; updateProductAndRecipe: { __typename?: 'Product'; id: string; name: string; priceSell: number; priceBuy?: Maybe<number>; showInPos: boolean; pohodaStockItemId?: Maybe<string>; categoryId: string; taxId: string; toGoTaxId?: Maybe<string>; priceBuyCurrency?: Maybe<{ __typename?: 'Currency'; currencyCode: CurrencyCode }>; printingDevices?: Maybe<Array<{ __typename?: 'Device'; id: string; name: string; customName?: Maybe<string> }>> } }

export type GetPaginatedProductsQueryVariables = Exact<{
    pagination?: Maybe<Pagination>;
    name?: Maybe<Scalars['String']>;
    categories?: Maybe<Array<Scalars['ID']> | Scalars['ID']>;
    markupSort?: Maybe<SortOrder>;
    foodCostSort?: Maybe<SortOrder>;
}>;


export interface GetPaginatedProductsQuery { __typename?: 'Query'; paginatedProducts: { __typename?: 'PaginatedProducts'; count: number; items: Array<{ __typename?: 'Product'; id: string; name: string; priceSell: number; pohodaStockItemId?: Maybe<string>; markup?: Maybe<number>; foodCost?: Maybe<number>; tax: { __typename?: 'Tax'; id: string; rate: number }; category: { __typename?: 'Category'; id: string; name: string; categoryId?: Maybe<string> } }> }; taxes: Array<{ __typename?: 'Tax'; name: string; id: string }> }

export type GetProductQueryVariables = Exact<{
    id: Scalars['String'];
}>;


export interface GetProductQuery { __typename?: 'Query'; product: { __typename?: 'Product'; id: string; name: string; priceSell: number; priceBuy?: Maybe<number>; showInPos: boolean; description?: Maybe<string>; pohodaStockItemId?: Maybe<string>; categoryId: string; taxId: string; toGoTaxId?: Maybe<string>; priceBuyCurrency?: Maybe<{ __typename?: 'Currency'; currencyCode: CurrencyCode }>; printingDevices?: Maybe<Array<{ __typename?: 'Device'; id: string; name: string; customName?: Maybe<string> }>>; connectedStockCard?: Maybe<{ __typename?: 'ConnectedStockCard'; id: string; warehouseId: string; stockCardId: string; stockCard: { __typename?: 'StockCard'; id: string; name: string; storageUnit: UnitType; conversionUnit?: Maybe<UnitType>; warehouses: Array<{ __typename?: 'Warehouse'; id: string; name: string }> } }>; recipe?: Maybe<{ __typename?: 'Recipe'; id: string; recipeLines: Array<{ __typename?: 'RecipeLine'; id: string; warehouseId: string; unitType: UnitType; waste: number; quantity: number; stockCard: { __typename?: 'StockCard'; id: string; name: string; storageUnit: UnitType; conversionUnit?: Maybe<UnitType>; warehouses: Array<{ __typename?: 'Warehouse'; id: string; name: string }> } }> }> }; categories: Array<{ __typename?: 'Category'; categoryId?: Maybe<string>; color?: Maybe<Color>; name: string; id: string }>; taxes: Array<{ __typename?: 'Tax'; name: string; id: string }>; warehouses: Array<{ __typename?: 'Warehouse'; name: string; id: string }>; devices: Array<{ __typename?: 'Device'; id: string; name: string; customName?: Maybe<string> }> }

export type ProductFormQueryVariables = Exact<{ [key: string]: never }>;


export interface ProductFormQuery { __typename?: 'Query'; categories: Array<{ __typename?: 'Category'; categoryId?: Maybe<string>; color?: Maybe<Color>; name: string; id: string }>; taxes: Array<{ __typename?: 'Tax'; name: string; id: string }>; devices: Array<{ __typename?: 'Device'; id: string; name: string; customName?: Maybe<string> }>; warehouses: Array<{ __typename?: 'Warehouse'; name: string; id: string }> }

export type Get_Category_OptionsQueryVariables = Exact<{ [key: string]: never }>;


export interface Get_Category_OptionsQuery { __typename?: 'Query'; categories: Array<{ __typename?: 'Category'; name: string; id: string }> }

export type GetCategoryQueryVariables = Exact<{
    id: Scalars['String'];
}>;


export interface GetCategoryQuery { __typename?: 'Query'; category?: Maybe<{ __typename?: 'Category'; id: string; name: string }> }

export type GetExpensesQueryVariables = Exact<{
    from: Scalars['Date'];
    to: Scalars['Date'];
}>;


export interface GetExpensesQuery { __typename?: 'Query'; productCosts: { __typename?: 'ProductPrimeCostsSummary'; withoutVat: number; withVat: number }; deductionAmounts: { __typename?: 'DeductionAmountsSummary'; withoutVat: { __typename?: 'DeductionAmounts'; waste: number; writeOff: number; total: number }; withVat: { __typename?: 'DeductionAmounts'; waste: number; writeOff: number; total: number } }; currentVenueInventoryCounts: Array<{ __typename?: 'InventoryCount'; id: string; endDate?: Maybe<any>; deltas: { __typename?: 'WithWithoutVat'; withVat: number; withoutVat: number } }> }

export type CreateCustomPaymentMethodMutationVariables = Exact<{
    data: CreateCustomPaymentMethodInput;
}>;


export interface CreateCustomPaymentMethodMutation { __typename?: 'Mutation'; createCustomPaymentMethod: { __typename?: 'CustomPaymentMethod'; id: string; name: string; isActive: boolean } }

export type UpdateCustomPaymentMethodMutationVariables = Exact<{
    id: Scalars['ID'];
    data: UpdateCustomPaymentMethodInput;
}>;


export interface UpdateCustomPaymentMethodMutation { __typename?: 'Mutation'; updateCustomPaymentMethod: { __typename?: 'CustomPaymentMethod'; id: string; name: string; isActive: boolean } }

export type RemoveCustomPaymentMethodMutationVariables = Exact<{
    id: Scalars['ID'];
}>;


export interface RemoveCustomPaymentMethodMutation { __typename?: 'Mutation'; removeCustomPaymentMethod: boolean }

export type GetCurrentVenueCustomPaymentMethodsQueryVariables = Exact<{
    onlyActive?: Maybe<Scalars['Boolean']>;
}>;


export interface GetCurrentVenueCustomPaymentMethodsQuery { __typename?: 'Query'; currentVenueCustomPaymentMethods: Array<{ __typename?: 'CustomPaymentMethod'; id: string; name: string; isActive: boolean; paymentIntegrationId?: Maybe<string> }> }

export type GetCurrentVenueCustomPaymentMethodQueryVariables = Exact<{
    id: Scalars['ID'];
}>;


export interface GetCurrentVenueCustomPaymentMethodQuery { __typename?: 'Query'; currentVenueCustomPaymentMethod: { __typename?: 'CustomPaymentMethod'; id: string; name: string; isActive: boolean } }

export type GetGenericFiltersOptionsQueryVariables = Exact<{ [key: string]: never }>;


export interface GetGenericFiltersOptionsQuery { __typename?: 'Query'; sections: Array<{ __typename?: 'Section'; name: string; id: string; places?: Maybe<Array<{ __typename?: 'Place'; id: string; name: string }>> }>; employees: Array<{ __typename?: 'Employee'; id: string; account: { __typename?: 'Account'; id: string; firstName: string; lastName: string } }> }

export type GetPaginatedProductStatisticsQueryVariables = Exact<{
    offset?: Maybe<Scalars['Int']>;
    limit?: Maybe<Scalars['Int']>;
    productName?: Maybe<Scalars['String']>;
    dateFromTo?: Maybe<DateFromTo>;
    quantitySortOrder?: Maybe<SortOrder>;
    revenueSortOrder?: Maybe<SortOrder>;
    markupSort?: Maybe<SortOrder>;
    foodCostSort?: Maybe<SortOrder>;
}>;


export interface GetPaginatedProductStatisticsQuery { __typename?: 'Query'; productStatistics: { __typename?: 'PaginatedProductStatistic'; count: number; items: Array<{ __typename?: 'ProductStatistic'; id: string; quantity: number; revenue: number; productName: string; foodCost?: Maybe<number>; markup?: Maybe<number>; netRevenue: number; primeCost?: Maybe<number> }> } }

export type GetProductsReportQueryVariables = Exact<{
    dateFromTo?: Maybe<DateFromTo>;
}>;


export interface GetProductsReportQuery { __typename?: 'Query'; productsReport: string }

export type PohodaIssueSlipQueryVariables = Exact<{
    dateFromTo?: Maybe<DateFromTo>;
}>;


export interface PohodaIssueSlipQuery { __typename?: 'Query'; pohodaIssueSlip: string }

export type CategoriesStatisticsQueryVariables = Exact<{
    dateFromTo?: Maybe<DateFromTo>;
}>;


export interface CategoriesStatisticsQuery { __typename?: 'Query'; categoriesStatistics: Array<{ __typename?: 'CategoriesStatistics'; id: string; categoryId?: Maybe<string>; name: string; quantity: number; grossRevenue: number; netRevenue: number; color?: Maybe<Color>; foodCost?: Maybe<number>; netMargin?: Maybe<number>; productWithNoRecipeCount?: Maybe<number>; primeCost?: Maybe<number> }> }

export type TableStatisticsQueryVariables = Exact<{
    dateFromTo?: Maybe<DateFromTo>;
}>;


export interface TableStatisticsQuery { __typename?: 'Query'; tableStatistics: Array<{ __typename?: 'TablesStatistics'; id: string; placeName: string; sectionName: string; sectionId: string; billCount: number; grossRevenue?: Maybe<number> }> }

export type CreateSupplierMutationVariables = Exact<{
    data: SupplierCreate;
}>;


export interface CreateSupplierMutation { __typename?: 'Mutation'; createSupplier: { __typename?: 'Supplier'; id: string; legalName: string } }

export type UpdatePlaceCoordinatesMutationVariables = Exact<{
    id: Scalars['String'];
    x: Scalars['Float'];
    y: Scalars['Float'];
}>;


export interface UpdatePlaceCoordinatesMutation { __typename?: 'Mutation'; updatePlace: { __typename?: 'Place'; id: string; coordinateX: number; coordinateY: number } }

export type CreatePlaceMutationVariables = Exact<{
    name: Scalars['String'];
    coordinateX: Scalars['Float'];
    coordinateY: Scalars['Float'];
    sectionId: Scalars['ID'];
}>;


export interface CreatePlaceMutation { __typename?: 'Mutation'; createPlace: { __typename?: 'Place'; id: string; coordinateX: number; coordinateY: number; name: string } }

export type RemovePlaceMutationVariables = Exact<{
    id: Scalars['String'];
}>;


export interface RemovePlaceMutation { __typename?: 'Mutation'; removePlace: boolean }

export type UpdatePlaceNameMutationVariables = Exact<{
    id: Scalars['String'];
    name: Scalars['String'];
    isToGo: Scalars['Boolean'];
}>;


export interface UpdatePlaceNameMutation { __typename?: 'Mutation'; updatePlace: { __typename?: 'Place'; id: string; name: string; isToGo: boolean } }

export type UpdateSectionNameMutationVariables = Exact<{
    id: Scalars['String'];
    name: Scalars['String'];
}>;


export interface UpdateSectionNameMutation { __typename?: 'Mutation'; updateSectionName: { __typename?: 'Section'; id: string; name: string } }

export type UpdateSectionOrderMutationVariables = Exact<{
    orderedSections: Array<SectionWithOrder> | SectionWithOrder;
}>;


export interface UpdateSectionOrderMutation { __typename?: 'Mutation'; updateSectionsOrdering: Array<{ __typename?: 'Section'; id: string; ordering?: Maybe<number> }> }

export type CreateSectionMutationVariables = Exact<{ [key: string]: never }>;


export interface CreateSectionMutation { __typename?: 'Mutation'; createSection: { __typename?: 'Section'; id: string; name: string; createdAt: any; ordering?: Maybe<number> } }

export type DeleteSectionMutationVariables = Exact<{
    id: Scalars['String'];
}>;


export interface DeleteSectionMutation { __typename?: 'Mutation'; removeSection: boolean }

export type SectionsQueryVariables = Exact<{ [key: string]: never }>;


export interface SectionsQuery { __typename?: 'Query'; sections: Array<{ __typename?: 'Section'; id: string; name: string; createdAt: any; ordering?: Maybe<number>; places?: Maybe<Array<{ __typename?: 'Place'; id: string; name: string; isToGo: boolean; coordinateX: number; coordinateY: number }>> }> }

export type SectionsFragmentQueryVariables = Exact<{ [key: string]: never }>;


export interface SectionsFragmentQuery { __typename?: 'Query'; sections: Array<{ __typename?: 'Section'; createdAt: any; ordering?: Maybe<number>; name: string; id: string }> }

export type CreateWarehouseMutationVariables = Exact<{
    name: Scalars['String'];
    venueIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export interface CreateWarehouseMutation { __typename?: 'Mutation'; createWarehouse: { __typename?: 'Warehouse'; id: string; name: string; venueIds: Array<string> } }

export type UpdateWarehouseMutationVariables = Exact<{
    id: Scalars['ID'];
    name?: Maybe<Scalars['String']>;
    venueIds?: Maybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export interface UpdateWarehouseMutation { __typename?: 'Mutation'; updateWarehouse: { __typename?: 'Warehouse'; id: string; name: string; venueIds: Array<string> } }

export type CreateWarehouseCardMutationVariables = Exact<{
    data: StockCardCreate;
    priceUpdateArgs?: Maybe<StockCardPriceUpdateInput>;
}>;


export interface CreateWarehouseCardMutation { __typename?: 'Mutation'; createStockCard: { __typename?: 'StockCard'; id: string; name: string; storageUnit: UnitType; conversionUnit?: Maybe<UnitType>; convertedAmount?: Maybe<number>; warehouses: Array<{ __typename?: 'Warehouse'; id: string; name: string }>; stockCardCategory?: Maybe<{ __typename?: 'StockCardCategory'; id: string; name: string }>; tax: { __typename?: 'Tax'; rate: number } } }

export type UpdateWarehouseCardMutationVariables = Exact<{
    id: Scalars['ID'];
    data: StockCardUpdate;
    priceUpdateArgs?: Maybe<StockCardPriceUpdateInput>;
}>;


export interface UpdateWarehouseCardMutation { __typename?: 'Mutation'; updateStockCard: { __typename?: 'StockCard'; id: string; name: string; storageUnit: UnitType; conversionUnit?: Maybe<UnitType>; convertedAmount?: Maybe<number>; stockCardCategory?: Maybe<{ __typename?: 'StockCardCategory'; id: string; name: string }> } }

export type RemoveStockCardMutationVariables = Exact<{
    id: Scalars['ID'];
    warehouseIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export interface RemoveStockCardMutation { __typename?: 'Mutation'; removeStockCard: boolean }

export type CreateInventoryCountMutationVariables = Exact<{
    warehouseId: Scalars['ID'];
}>;


export interface CreateInventoryCountMutation { __typename?: 'Mutation'; createInventoryCount: { __typename?: 'InventoryCount'; id: string; inventoryCountItems: Array<{ __typename?: 'InventoryCountItem'; id: string; expectedCount: number; stockCard: { __typename?: 'StockCard'; id: string; name: string; storageUnit: UnitType; conversionUnit?: Maybe<UnitType> } }> } }

export type UpdateInventoryCountItemMutationVariables = Exact<{
    data: InventoryCountItemUpdate;
    warehouseId: Scalars['ID'];
    inventoryCountId: Scalars['ID'];
    id: Scalars['ID'];
}>;


export interface UpdateInventoryCountItemMutation { __typename?: 'Mutation'; updateInventoryCountItem: { __typename?: 'InventoryCountItem'; id: string; realCount?: Maybe<number>; expectedCount: number } }

export type FinishInventoryCountMutationVariables = Exact<{
    id: Scalars['ID'];
    warehouseId: Scalars['ID'];
}>;


export interface FinishInventoryCountMutation { __typename?: 'Mutation'; finishInventoryCount: { __typename?: 'InventoryCount'; id: string; realValuation?: Maybe<number>; endDate?: Maybe<any> } }

export type CreateDeductionListMutationVariables = Exact<{
    data: DeductionListCreate;
}>;


export interface CreateDeductionListMutation { __typename?: 'Mutation'; createDeductionList: { __typename?: 'DeductionList'; id: string } }

export type WarehousesQueryVariables = Exact<{
    onlyCurrentVenue?: Maybe<Scalars['Boolean']>;
}>;


export interface WarehousesQuery { __typename?: 'Query'; warehouses: Array<{ __typename?: 'Warehouse'; name: string; id: string }> }

export type WarehouseQueryVariables = Exact<{
    id: Scalars['ID'];
}>;


export interface WarehouseQuery { __typename?: 'Query'; warehouse: { __typename?: 'Warehouse'; id: string; name: string; venueIds: Array<string> } }

export type StockCardsQueryVariables = Exact<{
    warehouseIds: Array<Scalars['ID']> | Scalars['ID'];
    offset?: Maybe<Scalars['Int']>;
    limit?: Maybe<Scalars['Int']>;
    stockCardCategoryId?: Maybe<Scalars['ID']>;
    nameOrSku?: Maybe<Scalars['String']>;
    stockCardsIds?: Maybe<Array<Scalars['ID']> | Scalars['ID']>;
    storageUnit?: Maybe<UnitType>;
    stockCardNameSortOrder?: Maybe<SortOrder>;
    stockCardQuantitySortOrder?: Maybe<SortOrder>;
}>;


export interface StockCardsQuery { __typename?: 'Query'; stockCards: Array<{ __typename?: 'StockCard'; id: string; name: string; storageUnit: UnitType; conversionUnit?: Maybe<UnitType>; convertedAmount?: Maybe<number>; sku?: Maybe<string>; taxId: string; warehouses: Array<{ __typename?: 'Warehouse'; id: string }>; stockCardCategory?: Maybe<{ __typename?: 'StockCardCategory'; id: string; name: string }>; stockLevels: Array<{ __typename?: 'StockLevel'; id: string; quantity: number; warehouseId: string; priceWithoutVat: number }>; tax: { __typename?: 'Tax'; rate: number } }> }

export type PaginatedStockCardsQueryVariables = Exact<{
    warehouseIds: Array<Scalars['ID']> | Scalars['ID'];
    offset?: Maybe<Scalars['Int']>;
    limit?: Maybe<Scalars['Int']>;
    stockCardCategoryId?: Maybe<Scalars['ID']>;
    nameOrSku?: Maybe<Scalars['String']>;
    stockCardsIds?: Maybe<Array<Scalars['ID']> | Scalars['ID']>;
    storageUnit?: Maybe<UnitType>;
    stockCardNameSortOrder?: Maybe<SortOrder>;
    stockCardQuantitySortOrder?: Maybe<SortOrder>;
}>;


export interface PaginatedStockCardsQuery { __typename?: 'Query'; paginatedStockCards: { __typename?: 'PaginatedStockCards'; count: number; items: Array<{ __typename?: 'StockCard'; id: string; name: string; storageUnit: UnitType; conversionUnit?: Maybe<UnitType>; convertedAmount?: Maybe<number>; sku?: Maybe<string>; taxId: string; warehouses: Array<{ __typename?: 'Warehouse'; id: string }>; stockCardCategory?: Maybe<{ __typename?: 'StockCardCategory'; id: string; name: string }>; stockLevels: Array<{ __typename?: 'StockLevel'; id: string; quantity: number; warehouseId: string; priceWithoutVat: number }> }> }; stockCardCategories: Array<{ __typename?: 'StockCardCategory'; id: string; name: string }> }

export type WarehouseCardFormQueryVariables = Exact<{
    onlyCurrentVenue?: Maybe<Scalars['Boolean']>;
}>;


export interface WarehouseCardFormQuery { __typename?: 'Query'; warehouses: Array<{ __typename?: 'Warehouse'; id: string; name: string }>; stockCardCategories: Array<{ __typename?: 'StockCardCategory'; id: string; name: string }>; taxes: Array<{ __typename?: 'Tax'; name: string; id: string }> }

export type StockCardQueryVariables = Exact<{
    id: Scalars['ID'];
    currentVenueOnly?: Maybe<Scalars['Boolean']>;
}>;


export interface StockCardQuery { __typename?: 'Query'; stockCard: { __typename?: 'StockCard'; id: string; name: string; sku?: Maybe<string>; storageUnit: UnitType; conversionUnit?: Maybe<UnitType>; convertedAmount?: Maybe<number>; taxId: string; warehouses: Array<{ __typename?: 'Warehouse'; id: string; name: string }>; stockCardCategory?: Maybe<{ __typename?: 'StockCardCategory'; id: string }>; stockLevels: Array<{ __typename?: 'StockLevel'; id: string; warehouseId: string; priceWithoutVat: number }> } }

export type InventoryCountsQueryVariables = Exact<{
    warehouseId: Scalars['ID'];
}>;


export interface InventoryCountsQuery { __typename?: 'Query'; inventoryCounts: Array<{ __typename?: 'InventoryCount'; id: string; startDate: any; expectedValuation?: Maybe<number>; realValuation?: Maybe<number>; endDate?: Maybe<any>; deltas: { __typename?: 'WithWithoutVat'; withoutVat: number }; shortageSurplus: { __typename?: 'ShortageSurplus'; surplus: { __typename?: 'WithWithoutVat'; withoutVat: number }; shortage: { __typename?: 'WithWithoutVat'; withoutVat: number } } }> }

export type CurrentInventoryCountQueryVariables = Exact<{
    warehouseId: Scalars['ID'];
}>;


export interface CurrentInventoryCountQuery { __typename?: 'Query'; currentInventoryCount: { __typename?: 'InventoryCount'; id: string; inventoryCountItems: Array<{ __typename?: 'InventoryCountItem'; id: string; expectedCount: number; realCount?: Maybe<number>; stockCard: { __typename?: 'StockCard'; id: string; name: string; storageUnit: UnitType; conversionUnit?: Maybe<UnitType>; stockCardCategoryId?: Maybe<string>; stockCardCategory?: Maybe<{ __typename?: 'StockCardCategory'; name: string }> } }> }; stockCardCategories: Array<{ __typename?: 'StockCardCategory'; id: string; name: string }> }

export type InventoryCountQueryVariables = Exact<{
    id: Scalars['ID'];
    warehouseId: Scalars['ID'];
}>;


export interface InventoryCountQuery { __typename?: 'Query'; inventoryCount: { __typename?: 'InventoryCount'; id: string; startDate: any; endDate?: Maybe<any>; expectedValuation?: Maybe<number>; realValuation?: Maybe<number>; notMatchingCounts?: Maybe<number>; notCalculatedCounts?: Maybe<number>; deltas: { __typename?: 'WithWithoutVat'; withoutVat: number }; shortageSurplus: { __typename?: 'ShortageSurplus'; surplus: { __typename?: 'WithWithoutVat'; withoutVat: number }; shortage: { __typename?: 'WithWithoutVat'; withoutVat: number } } } }

export type PaginatedInventoryCountItemsQueryVariables = Exact<{
    offset?: Maybe<Scalars['Int']>;
    limit?: Maybe<Scalars['Int']>;
    inventoryCountId: Scalars['ID'];
    stockCardCategoryId?: Maybe<Scalars['ID']>;
    unmatchedOnly?: Maybe<Scalars['Boolean']>;
    notCountedOnly?: Maybe<Scalars['Boolean']>;
    moreThanExpectedOnly?: Maybe<Scalars['Boolean']>;
    lessThanExpectedOnly?: Maybe<Scalars['Boolean']>;
    stockCardNameOrSku?: Maybe<Scalars['String']>;
}>;


export interface PaginatedInventoryCountItemsQuery { __typename?: 'Query'; paginatedInventoryCountItems: { __typename?: 'PaginatedInventoryCountItems'; count: number; items: Array<{ __typename?: 'InventoryCountItem'; id: string; updatedById?: Maybe<string>; expectedCount: number; realCount?: Maybe<number>; pricePerUnitWithoutVAT: number; stockCard: { __typename?: 'StockCard'; id: string; name: string; storageUnit: UnitType; conversionUnit?: Maybe<UnitType>; convertedAmount?: Maybe<number>; stockCardCategory?: Maybe<{ __typename?: 'StockCardCategory'; id: string; name: string }> } }> } }

export type StockCardsSearchQueryVariables = Exact<{
    warehouseIds: Array<Scalars['ID']> | Scalars['ID'];
    offset?: Maybe<Scalars['Int']>;
    limit?: Maybe<Scalars['Int']>;
    stockCardCategoryId?: Maybe<Scalars['ID']>;
    nameOrSku?: Maybe<Scalars['String']>;
    storageUnit?: Maybe<UnitType>;
}>;


export interface StockCardsSearchQuery { __typename?: 'Query'; stockCards: Array<{ __typename?: 'StockCard'; id: string; name: string; storageUnit: UnitType; conversionUnit?: Maybe<UnitType>; warehouses: Array<{ __typename?: 'Warehouse'; id: string; name: string }>; stockCardCategory?: Maybe<{ __typename?: 'StockCardCategory'; id: string; name: string }> }> }

export type CreateStockCardCategoryMutationVariables = Exact<{
    data: StockCardCategoryCreate;
}>;


export interface CreateStockCardCategoryMutation { __typename?: 'Mutation'; createStockCardCategory: { __typename?: 'StockCardCategory'; id: string; name: string } }

export type RemoveStockCardCategoryMutationVariables = Exact<{
    id: Scalars['ID'];
}>;


export interface RemoveStockCardCategoryMutation { __typename?: 'Mutation'; removeStockCardCategory: boolean }

export type StockCardCategoriesQueryVariables = Exact<{ [key: string]: never }>;


export interface StockCardCategoriesQuery { __typename?: 'Query'; stockCardCategories: Array<{ __typename?: 'StockCardCategory'; id: string; name: string }> }

export type RossumUploadsCountByWarehouseIdQueryVariables = Exact<{
    warehouseId: Scalars['ID'];
}>;


export interface RossumUploadsCountByWarehouseIdQuery { __typename?: 'Query'; rossumUploadsCountByWarehouseId: number }

export const CategoriesFragmentDoc = gql`
    fragment CategoriesFragment on Category {
  name
  id
}
    `;
export const DevicesFragmentDoc = gql`
    fragment DevicesFragment on Device {
  id
  name
  customName
}
    `;
export const TaxesFragmentDoc = gql`
    fragment TaxesFragment on Tax {
  name
  id
}
    `;
export const VenuesFragmentDoc = gql`
    fragment VenuesFragment on Venue {
  name
  id
}
    `;
export const SectionsFragmentDoc = gql`
    fragment SectionsFragment on Section {
  name
  id
}
    `;
export const WarehousesFragmentDoc = gql`
    fragment WarehousesFragment on Warehouse {
  name
  id
}
    `;
export const SuppliersFragmentDoc = gql`
    fragment SuppliersFragment on Supplier {
  id
  legalName
}
    `;
export const VenuesWithPohodaCentreIdFragmentDoc = gql`
    fragment VenuesWithPohodaCentreIdFragment on Venue {
  pohodaCentreId
}
    `;
export const SectionsOptionFragmentDoc = gql`
    fragment SectionsOptionFragment on Section {
  name
  id
  places {
    id
    name
  }
}
    `;
export const EmployeeOptionFragmentDoc = gql`
    fragment EmployeeOptionFragment on Employee {
  id
  account {
    id
    firstName
    lastName
  }
}
    `;
export const SwitchVenueDocument = gql`
    mutation SwitchVenue($venueId: String!) {
  switchVenue(venueId: $venueId)
}
    `;
export type SwitchVenueMutationFn = Apollo.MutationFunction<SwitchVenueMutation, SwitchVenueMutationVariables>;
export type SwitchVenueComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<SwitchVenueMutation, SwitchVenueMutationVariables>, 'mutation'>;

export const SwitchVenueComponent = (props: SwitchVenueComponentProps) => (
    <ApolloReactComponents.Mutation<SwitchVenueMutation, SwitchVenueMutationVariables> mutation={SwitchVenueDocument} {...props} />
);


/**
 * __useSwitchVenueMutation__
 *
 * To run a mutation, you first call `useSwitchVenueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSwitchVenueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [switchVenueMutation, { data, loading, error }] = useSwitchVenueMutation({
 *   variables: {
 *      venueId: // value for 'venueId'
 *   },
 * });
 */
export function useSwitchVenueMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SwitchVenueMutation, SwitchVenueMutationVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<SwitchVenueMutation, SwitchVenueMutationVariables>(SwitchVenueDocument, options);
}
export type SwitchVenueMutationHookResult = ReturnType<typeof useSwitchVenueMutation>;
export type SwitchVenueMutationResult = Apollo.MutationResult<SwitchVenueMutation>;
export type SwitchVenueMutationOptions = Apollo.BaseMutationOptions<SwitchVenueMutation, SwitchVenueMutationVariables>;
export const GetInitInfoDocument = gql`
    query GetInitInfo {
  venues {
    ...VenuesFragment
    pohodaCentreId
    dueDate
    debt
  }
  employeePermissions {
    warehouse
    backoffice
  }
}
    ${VenuesFragmentDoc}`;
export type GetInitInfoComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetInitInfoQuery, GetInitInfoQueryVariables>, 'query'>;

export const GetInitInfoComponent = (props: GetInitInfoComponentProps) => (
    <ApolloReactComponents.Query<GetInitInfoQuery, GetInitInfoQueryVariables> query={GetInitInfoDocument} {...props} />
);


/**
 * __useGetInitInfoQuery__
 *
 * To run a query within a React component, call `useGetInitInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInitInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInitInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetInitInfoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetInitInfoQuery, GetInitInfoQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<GetInitInfoQuery, GetInitInfoQueryVariables>(GetInitInfoDocument, options);
}
export function useGetInitInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetInitInfoQuery, GetInitInfoQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<GetInitInfoQuery, GetInitInfoQueryVariables>(GetInitInfoDocument, options);
}
export type GetInitInfoQueryHookResult = ReturnType<typeof useGetInitInfoQuery>;
export type GetInitInfoLazyQueryHookResult = ReturnType<typeof useGetInitInfoLazyQuery>;
export type GetInitInfoQueryResult = Apollo.QueryResult<GetInitInfoQuery, GetInitInfoQueryVariables>;
export function refetchGetInitInfoQuery(variables?: GetInitInfoQueryVariables) {
    return { query: GetInitInfoDocument, variables };
}
export const BillsDocument = gql`
    query Bills($offset: Int, $limit: Int, $filters: BillFilters) {
  bills(offset: $offset, limit: $limit, filters: $filters) {
    id
    total
    dicountedTotalValue
    roundedPrice
    totalPriceCurrency {
      currencyCode
    }
    fiscalRecord {
      id
      state
    }
    place {
      id
      name
    }
    issuedBy {
      id
      account {
        id
        firstName
        lastName
        imageUrl
      }
    }
    issuedUtc
    billState
    billNumber
    paymentMethod
    customPaymentMethod {
      name
    }
  }
}
    `;
export type BillsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<BillsQuery, BillsQueryVariables>, 'query'>;

export const BillsComponent = (props: BillsComponentProps) => (
    <ApolloReactComponents.Query<BillsQuery, BillsQueryVariables> query={BillsDocument} {...props} />
);


/**
 * __useBillsQuery__
 *
 * To run a query within a React component, call `useBillsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBillsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBillsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useBillsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<BillsQuery, BillsQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<BillsQuery, BillsQueryVariables>(BillsDocument, options);
}
export function useBillsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BillsQuery, BillsQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<BillsQuery, BillsQueryVariables>(BillsDocument, options);
}
export type BillsQueryHookResult = ReturnType<typeof useBillsQuery>;
export type BillsLazyQueryHookResult = ReturnType<typeof useBillsLazyQuery>;
export type BillsQueryResult = Apollo.QueryResult<BillsQuery, BillsQueryVariables>;
export function refetchBillsQuery(variables?: BillsQueryVariables) {
    return { query: BillsDocument, variables };
}
export const BillDocument = gql`
    query Bill($id: String!) {
  bill(id: $id) {
    id
    order {
      id
      name
      orderNumber
      place {
        id
        name
      }
    }
    orderLines {
      id
      price
      discountedPrice
      discountedUnitPrice
      priceCurrency {
        currencyCode
      }
      quantity
      unitPrice
      tax {
        id
        rate
      }
      product {
        id
        name
        tax {
          id
          rate
        }
      }
    }
    total
    dicountedTotalValue
    roundedPrice
    totalPriceCurrency {
      currencyCode
    }
    place {
      id
      name
    }
    issuedBy {
      id
      account {
        id
        firstName
        lastName
        imageUrl
      }
    }
    issuedUtc
    billState
    billNumber
    paymentMethod
    customPaymentMethod {
      name
    }
  }
}
    `;
export type BillComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<BillQuery, BillQueryVariables>, 'query'> & ({ variables: BillQueryVariables; skip?: boolean } | { skip: boolean });

export const BillComponent = (props: BillComponentProps) => (
    <ApolloReactComponents.Query<BillQuery, BillQueryVariables> query={BillDocument} {...props} />
);


/**
 * __useBillQuery__
 *
 * To run a query within a React component, call `useBillQuery` and pass it any options that fit your needs.
 * When your component renders, `useBillQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBillQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBillQuery(baseOptions: ApolloReactHooks.QueryHookOptions<BillQuery, BillQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<BillQuery, BillQueryVariables>(BillDocument, options);
}
export function useBillLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BillQuery, BillQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<BillQuery, BillQueryVariables>(BillDocument, options);
}
export type BillQueryHookResult = ReturnType<typeof useBillQuery>;
export type BillLazyQueryHookResult = ReturnType<typeof useBillLazyQuery>;
export type BillQueryResult = Apollo.QueryResult<BillQuery, BillQueryVariables>;
export function refetchBillQuery(variables?: BillQueryVariables) {
    return { query: BillDocument, variables };
}
export const GetBillFiltersOptionsDocument = gql`
    query GetBillFiltersOptions {
  sections {
    ...SectionsOptionFragment
  }
  employees {
    ...EmployeeOptionFragment
  }
}
    ${SectionsOptionFragmentDoc}
${EmployeeOptionFragmentDoc}`;
export type GetBillFiltersOptionsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetBillFiltersOptionsQuery, GetBillFiltersOptionsQueryVariables>, 'query'>;

export const GetBillFiltersOptionsComponent = (props: GetBillFiltersOptionsComponentProps) => (
    <ApolloReactComponents.Query<GetBillFiltersOptionsQuery, GetBillFiltersOptionsQueryVariables> query={GetBillFiltersOptionsDocument} {...props} />
);


/**
 * __useGetBillFiltersOptionsQuery__
 *
 * To run a query within a React component, call `useGetBillFiltersOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBillFiltersOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBillFiltersOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBillFiltersOptionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetBillFiltersOptionsQuery, GetBillFiltersOptionsQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<GetBillFiltersOptionsQuery, GetBillFiltersOptionsQueryVariables>(GetBillFiltersOptionsDocument, options);
}
export function useGetBillFiltersOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBillFiltersOptionsQuery, GetBillFiltersOptionsQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<GetBillFiltersOptionsQuery, GetBillFiltersOptionsQueryVariables>(GetBillFiltersOptionsDocument, options);
}
export type GetBillFiltersOptionsQueryHookResult = ReturnType<typeof useGetBillFiltersOptionsQuery>;
export type GetBillFiltersOptionsLazyQueryHookResult = ReturnType<typeof useGetBillFiltersOptionsLazyQuery>;
export type GetBillFiltersOptionsQueryResult = Apollo.QueryResult<GetBillFiltersOptionsQuery, GetBillFiltersOptionsQueryVariables>;
export function refetchGetBillFiltersOptionsQuery(variables?: GetBillFiltersOptionsQueryVariables) {
    return { query: GetBillFiltersOptionsDocument, variables };
}
export const VenueShiftsDocument = gql`
    query venueShifts($offset: Int, $limit: Int, $dateFromTo: DateFromTo) {
  venueShifts(offset: $offset, limit: $limit, dateFromTo: $dateFromTo) {
    id
    startedUtc
    finishedUtc
    initialCashAmount
    expectedCashAmount
    finalCashAmount
    expectedCreditCardAmount
    finalCreditCardAmount
    cashIncome
    cashDrawerOperations {
      id
      amount
      createdUtc
      note
      createdBy {
        account {
          firstName
          lastName
        }
      }
    }
    startedBy {
      account {
        firstName
        lastName
      }
    }
    finishedBy {
      account {
        firstName
        lastName
      }
    }
  }
}
    `;
export type VenueShiftsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<VenueShiftsQuery, VenueShiftsQueryVariables>, 'query'>;

export const VenueShiftsComponent = (props: VenueShiftsComponentProps) => (
    <ApolloReactComponents.Query<VenueShiftsQuery, VenueShiftsQueryVariables> query={VenueShiftsDocument} {...props} />
);


/**
 * __useVenueShiftsQuery__
 *
 * To run a query within a React component, call `useVenueShiftsQuery` and pass it any options that fit your needs.
 * When your component renders, `useVenueShiftsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVenueShiftsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      dateFromTo: // value for 'dateFromTo'
 *   },
 * });
 */
export function useVenueShiftsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<VenueShiftsQuery, VenueShiftsQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<VenueShiftsQuery, VenueShiftsQueryVariables>(VenueShiftsDocument, options);
}
export function useVenueShiftsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<VenueShiftsQuery, VenueShiftsQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<VenueShiftsQuery, VenueShiftsQueryVariables>(VenueShiftsDocument, options);
}
export type VenueShiftsQueryHookResult = ReturnType<typeof useVenueShiftsQuery>;
export type VenueShiftsLazyQueryHookResult = ReturnType<typeof useVenueShiftsLazyQuery>;
export type VenueShiftsQueryResult = Apollo.QueryResult<VenueShiftsQuery, VenueShiftsQueryVariables>;
export function refetchVenueShiftsQuery(variables?: VenueShiftsQueryVariables) {
    return { query: VenueShiftsDocument, variables };
}
export const GetCashDrawerReportDocument = gql`
    query GetCashDrawerReport($dateFromTo: DateFromTo) {
  cashDrawerReport(dateFromTo: $dateFromTo)
}
    `;
export type GetCashDrawerReportComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetCashDrawerReportQuery, GetCashDrawerReportQueryVariables>, 'query'>;

export const GetCashDrawerReportComponent = (props: GetCashDrawerReportComponentProps) => (
    <ApolloReactComponents.Query<GetCashDrawerReportQuery, GetCashDrawerReportQueryVariables> query={GetCashDrawerReportDocument} {...props} />
);


/**
 * __useGetCashDrawerReportQuery__
 *
 * To run a query within a React component, call `useGetCashDrawerReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCashDrawerReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCashDrawerReportQuery({
 *   variables: {
 *      dateFromTo: // value for 'dateFromTo'
 *   },
 * });
 */
export function useGetCashDrawerReportQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCashDrawerReportQuery, GetCashDrawerReportQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<GetCashDrawerReportQuery, GetCashDrawerReportQueryVariables>(GetCashDrawerReportDocument, options);
}
export function useGetCashDrawerReportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCashDrawerReportQuery, GetCashDrawerReportQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<GetCashDrawerReportQuery, GetCashDrawerReportQueryVariables>(GetCashDrawerReportDocument, options);
}
export type GetCashDrawerReportQueryHookResult = ReturnType<typeof useGetCashDrawerReportQuery>;
export type GetCashDrawerReportLazyQueryHookResult = ReturnType<typeof useGetCashDrawerReportLazyQuery>;
export type GetCashDrawerReportQueryResult = Apollo.QueryResult<GetCashDrawerReportQuery, GetCashDrawerReportQueryVariables>;
export function refetchGetCashDrawerReportQuery(variables?: GetCashDrawerReportQueryVariables) {
    return { query: GetCashDrawerReportDocument, variables };
}
export const CreateCategoryDocument = gql`
    mutation CreateCategory($name: String!, $id: ID, $parentCategoryId: ID, $childCategories: [String!], $color: Color) {
  createCategory(name: $name, id: $id, parentCategoryId: $parentCategoryId, childCategories: $childCategories, color: $color) {
    id
    name
    description
    category {
      id
      name
    }
  }
}
    `;
export type CreateCategoryMutationFn = Apollo.MutationFunction<CreateCategoryMutation, CreateCategoryMutationVariables>;
export type CreateCategoryComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateCategoryMutation, CreateCategoryMutationVariables>, 'mutation'>;

export const CreateCategoryComponent = (props: CreateCategoryComponentProps) => (
    <ApolloReactComponents.Mutation<CreateCategoryMutation, CreateCategoryMutationVariables> mutation={CreateCategoryDocument} {...props} />
);


/**
 * __useCreateCategoryMutation__
 *
 * To run a mutation, you first call `useCreateCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCategoryMutation, { data, loading, error }] = useCreateCategoryMutation({
 *   variables: {
 *      name: // value for 'name'
 *      id: // value for 'id'
 *      parentCategoryId: // value for 'parentCategoryId'
 *      childCategories: // value for 'childCategories'
 *      color: // value for 'color'
 *   },
 * });
 */
export function useCreateCategoryMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateCategoryMutation, CreateCategoryMutationVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<CreateCategoryMutation, CreateCategoryMutationVariables>(CreateCategoryDocument, options);
}
export type CreateCategoryMutationHookResult = ReturnType<typeof useCreateCategoryMutation>;
export type CreateCategoryMutationResult = Apollo.MutationResult<CreateCategoryMutation>;
export type CreateCategoryMutationOptions = Apollo.BaseMutationOptions<CreateCategoryMutation, CreateCategoryMutationVariables>;
export const UpdateCategoryDocument = gql`
    mutation UpdateCategory($id: String!, $name: String, $description: String, $parentCategoryId: ID, $color: Color) {
  updateCategory(id: $id, data: {name: $name, description: $description, parentCategoryId: $parentCategoryId, color: $color}) {
    id
    name
    description
    color
    category {
      id
    }
  }
}
    `;
export type UpdateCategoryMutationFn = Apollo.MutationFunction<UpdateCategoryMutation, UpdateCategoryMutationVariables>;
export type UpdateCategoryComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateCategoryMutation, UpdateCategoryMutationVariables>, 'mutation'>;

export const UpdateCategoryComponent = (props: UpdateCategoryComponentProps) => (
    <ApolloReactComponents.Mutation<UpdateCategoryMutation, UpdateCategoryMutationVariables> mutation={UpdateCategoryDocument} {...props} />
);


/**
 * __useUpdateCategoryMutation__
 *
 * To run a mutation, you first call `useUpdateCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCategoryMutation, { data, loading, error }] = useUpdateCategoryMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      parentCategoryId: // value for 'parentCategoryId'
 *      color: // value for 'color'
 *   },
 * });
 */
export function useUpdateCategoryMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateCategoryMutation, UpdateCategoryMutationVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<UpdateCategoryMutation, UpdateCategoryMutationVariables>(UpdateCategoryDocument, options);
}
export type UpdateCategoryMutationHookResult = ReturnType<typeof useUpdateCategoryMutation>;
export type UpdateCategoryMutationResult = Apollo.MutationResult<UpdateCategoryMutation>;
export type UpdateCategoryMutationOptions = Apollo.BaseMutationOptions<UpdateCategoryMutation, UpdateCategoryMutationVariables>;
export const RemoveCategoryDocument = gql`
    mutation RemoveCategory($id: String!) {
  removeCategory(id: $id)
}
    `;
export type RemoveCategoryMutationFn = Apollo.MutationFunction<RemoveCategoryMutation, RemoveCategoryMutationVariables>;
export type RemoveCategoryComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<RemoveCategoryMutation, RemoveCategoryMutationVariables>, 'mutation'>;

export const RemoveCategoryComponent = (props: RemoveCategoryComponentProps) => (
    <ApolloReactComponents.Mutation<RemoveCategoryMutation, RemoveCategoryMutationVariables> mutation={RemoveCategoryDocument} {...props} />
);


/**
 * __useRemoveCategoryMutation__
 *
 * To run a mutation, you first call `useRemoveCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCategoryMutation, { data, loading, error }] = useRemoveCategoryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveCategoryMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveCategoryMutation, RemoveCategoryMutationVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<RemoveCategoryMutation, RemoveCategoryMutationVariables>(RemoveCategoryDocument, options);
}
export type RemoveCategoryMutationHookResult = ReturnType<typeof useRemoveCategoryMutation>;
export type RemoveCategoryMutationResult = Apollo.MutationResult<RemoveCategoryMutation>;
export type RemoveCategoryMutationOptions = Apollo.BaseMutationOptions<RemoveCategoryMutation, RemoveCategoryMutationVariables>;
export const CategoryDocument = gql`
    query Category($id: String!) {
  category(id: $id) {
    name
    description
    id
    color
    category {
      id
    }
  }
  categories(categoryType: "parentOnly") {
    ...CategoriesFragment
  }
}
    ${CategoriesFragmentDoc}`;
export type CategoryComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<CategoryQuery, CategoryQueryVariables>, 'query'> & ({ variables: CategoryQueryVariables; skip?: boolean } | { skip: boolean });

export const CategoryComponent = (props: CategoryComponentProps) => (
    <ApolloReactComponents.Query<CategoryQuery, CategoryQueryVariables> query={CategoryDocument} {...props} />
);


/**
 * __useCategoryQuery__
 *
 * To run a query within a React component, call `useCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCategoryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CategoryQuery, CategoryQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<CategoryQuery, CategoryQueryVariables>(CategoryDocument, options);
}
export function useCategoryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CategoryQuery, CategoryQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<CategoryQuery, CategoryQueryVariables>(CategoryDocument, options);
}
export type CategoryQueryHookResult = ReturnType<typeof useCategoryQuery>;
export type CategoryLazyQueryHookResult = ReturnType<typeof useCategoryLazyQuery>;
export type CategoryQueryResult = Apollo.QueryResult<CategoryQuery, CategoryQueryVariables>;
export function refetchCategoryQuery(variables?: CategoryQueryVariables) {
    return { query: CategoryDocument, variables };
}
export const ProductsByCategoryDocument = gql`
    query ProductsByCategory($categoryId: String!) {
  productsByCategory(categoryId: $categoryId) {
    name
    id
  }
}
    `;
export type ProductsByCategoryComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ProductsByCategoryQuery, ProductsByCategoryQueryVariables>, 'query'> & ({ variables: ProductsByCategoryQueryVariables; skip?: boolean } | { skip: boolean });

export const ProductsByCategoryComponent = (props: ProductsByCategoryComponentProps) => (
    <ApolloReactComponents.Query<ProductsByCategoryQuery, ProductsByCategoryQueryVariables> query={ProductsByCategoryDocument} {...props} />
);


/**
 * __useProductsByCategoryQuery__
 *
 * To run a query within a React component, call `useProductsByCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductsByCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductsByCategoryQuery({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *   },
 * });
 */
export function useProductsByCategoryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProductsByCategoryQuery, ProductsByCategoryQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<ProductsByCategoryQuery, ProductsByCategoryQueryVariables>(ProductsByCategoryDocument, options);
}
export function useProductsByCategoryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProductsByCategoryQuery, ProductsByCategoryQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<ProductsByCategoryQuery, ProductsByCategoryQueryVariables>(ProductsByCategoryDocument, options);
}
export type ProductsByCategoryQueryHookResult = ReturnType<typeof useProductsByCategoryQuery>;
export type ProductsByCategoryLazyQueryHookResult = ReturnType<typeof useProductsByCategoryLazyQuery>;
export type ProductsByCategoryQueryResult = Apollo.QueryResult<ProductsByCategoryQuery, ProductsByCategoryQueryVariables>;
export function refetchProductsByCategoryQuery(variables?: ProductsByCategoryQueryVariables) {
    return { query: ProductsByCategoryDocument, variables };
}
export const CategoriesDocument = gql`
    query Categories {
  categories {
    id
    name
    color
    description
    ordering
    category {
      id
    }
  }
  categoriesProductCount {
    categoryId
    productCount
  }
}
    `;
export type CategoriesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<CategoriesQuery, CategoriesQueryVariables>, 'query'>;

export const CategoriesComponent = (props: CategoriesComponentProps) => (
    <ApolloReactComponents.Query<CategoriesQuery, CategoriesQueryVariables> query={CategoriesDocument} {...props} />
);


/**
 * __useCategoriesQuery__
 *
 * To run a query within a React component, call `useCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCategoriesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CategoriesQuery, CategoriesQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<CategoriesQuery, CategoriesQueryVariables>(CategoriesDocument, options);
}
export function useCategoriesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CategoriesQuery, CategoriesQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<CategoriesQuery, CategoriesQueryVariables>(CategoriesDocument, options);
}
export type CategoriesQueryHookResult = ReturnType<typeof useCategoriesQuery>;
export type CategoriesLazyQueryHookResult = ReturnType<typeof useCategoriesLazyQuery>;
export type CategoriesQueryResult = Apollo.QueryResult<CategoriesQuery, CategoriesQueryVariables>;
export function refetchCategoriesQuery(variables?: CategoriesQueryVariables) {
    return { query: CategoriesDocument, variables };
}
export const GetCategoryOptionsDocument = gql`
    query GetCategoryOptions {
  categories(categoryType: "parentOnly") {
    ...CategoriesFragment
  }
}
    ${CategoriesFragmentDoc}`;
export type GetCategoryOptionsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetCategoryOptionsQuery, GetCategoryOptionsQueryVariables>, 'query'>;

export const GetCategoryOptionsComponent = (props: GetCategoryOptionsComponentProps) => (
    <ApolloReactComponents.Query<GetCategoryOptionsQuery, GetCategoryOptionsQueryVariables> query={GetCategoryOptionsDocument} {...props} />
);


/**
 * __useGetCategoryOptionsQuery__
 *
 * To run a query within a React component, call `useGetCategoryOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoryOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategoryOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCategoryOptionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCategoryOptionsQuery, GetCategoryOptionsQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<GetCategoryOptionsQuery, GetCategoryOptionsQueryVariables>(GetCategoryOptionsDocument, options);
}
export function useGetCategoryOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCategoryOptionsQuery, GetCategoryOptionsQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<GetCategoryOptionsQuery, GetCategoryOptionsQueryVariables>(GetCategoryOptionsDocument, options);
}
export type GetCategoryOptionsQueryHookResult = ReturnType<typeof useGetCategoryOptionsQuery>;
export type GetCategoryOptionsLazyQueryHookResult = ReturnType<typeof useGetCategoryOptionsLazyQuery>;
export type GetCategoryOptionsQueryResult = Apollo.QueryResult<GetCategoryOptionsQuery, GetCategoryOptionsQueryVariables>;
export function refetchGetCategoryOptionsQuery(variables?: GetCategoryOptionsQueryVariables) {
    return { query: GetCategoryOptionsDocument, variables };
}
export const TopEmployeesDocument = gql`
    query TopEmployees($dateFromTo: DateFromTo!) {
  topEmployees(dateFromTo: $dateFromTo) {
    id
    firstName
    lastName
    billCount
    totalPriceSold
  }
}
    `;
export type TopEmployeesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<TopEmployeesQuery, TopEmployeesQueryVariables>, 'query'> & ({ variables: TopEmployeesQueryVariables; skip?: boolean } | { skip: boolean });

export const TopEmployeesComponent = (props: TopEmployeesComponentProps) => (
    <ApolloReactComponents.Query<TopEmployeesQuery, TopEmployeesQueryVariables> query={TopEmployeesDocument} {...props} />
);


/**
 * __useTopEmployeesQuery__
 *
 * To run a query within a React component, call `useTopEmployeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTopEmployeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTopEmployeesQuery({
 *   variables: {
 *      dateFromTo: // value for 'dateFromTo'
 *   },
 * });
 */
export function useTopEmployeesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TopEmployeesQuery, TopEmployeesQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<TopEmployeesQuery, TopEmployeesQueryVariables>(TopEmployeesDocument, options);
}
export function useTopEmployeesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TopEmployeesQuery, TopEmployeesQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<TopEmployeesQuery, TopEmployeesQueryVariables>(TopEmployeesDocument, options);
}
export type TopEmployeesQueryHookResult = ReturnType<typeof useTopEmployeesQuery>;
export type TopEmployeesLazyQueryHookResult = ReturnType<typeof useTopEmployeesLazyQuery>;
export type TopEmployeesQueryResult = Apollo.QueryResult<TopEmployeesQuery, TopEmployeesQueryVariables>;
export function refetchTopEmployeesQuery(variables?: TopEmployeesQueryVariables) {
    return { query: TopEmployeesDocument, variables };
}
export const TopProductsDocument = gql`
    query TopProducts($dateFromTo: DateFromTo!) {
  topProducts(dateFromTo: $dateFromTo) {
    id
    name
    quantity
    totalPriceSold
    netMargin
    foodCost
  }
}
    `;
export type TopProductsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<TopProductsQuery, TopProductsQueryVariables>, 'query'> & ({ variables: TopProductsQueryVariables; skip?: boolean } | { skip: boolean });

export const TopProductsComponent = (props: TopProductsComponentProps) => (
    <ApolloReactComponents.Query<TopProductsQuery, TopProductsQueryVariables> query={TopProductsDocument} {...props} />
);


/**
 * __useTopProductsQuery__
 *
 * To run a query within a React component, call `useTopProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTopProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTopProductsQuery({
 *   variables: {
 *      dateFromTo: // value for 'dateFromTo'
 *   },
 * });
 */
export function useTopProductsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TopProductsQuery, TopProductsQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<TopProductsQuery, TopProductsQueryVariables>(TopProductsDocument, options);
}
export function useTopProductsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TopProductsQuery, TopProductsQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<TopProductsQuery, TopProductsQueryVariables>(TopProductsDocument, options);
}
export type TopProductsQueryHookResult = ReturnType<typeof useTopProductsQuery>;
export type TopProductsLazyQueryHookResult = ReturnType<typeof useTopProductsLazyQuery>;
export type TopProductsQueryResult = Apollo.QueryResult<TopProductsQuery, TopProductsQueryVariables>;
export function refetchTopProductsQuery(variables?: TopProductsQueryVariables) {
    return { query: TopProductsDocument, variables };
}
export const UnpopularProductsDocument = gql`
    query UnpopularProducts($dateFromTo: DateFromTo!) {
  unpopularProducts(dateFromTo: $dateFromTo) {
    id
    name
    quantity
    totalPriceSold
    netMargin
    foodCost
  }
}
    `;
export type UnpopularProductsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<UnpopularProductsQuery, UnpopularProductsQueryVariables>, 'query'> & ({ variables: UnpopularProductsQueryVariables; skip?: boolean } | { skip: boolean });

export const UnpopularProductsComponent = (props: UnpopularProductsComponentProps) => (
    <ApolloReactComponents.Query<UnpopularProductsQuery, UnpopularProductsQueryVariables> query={UnpopularProductsDocument} {...props} />
);


/**
 * __useUnpopularProductsQuery__
 *
 * To run a query within a React component, call `useUnpopularProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnpopularProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnpopularProductsQuery({
 *   variables: {
 *      dateFromTo: // value for 'dateFromTo'
 *   },
 * });
 */
export function useUnpopularProductsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<UnpopularProductsQuery, UnpopularProductsQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<UnpopularProductsQuery, UnpopularProductsQueryVariables>(UnpopularProductsDocument, options);
}
export function useUnpopularProductsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UnpopularProductsQuery, UnpopularProductsQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<UnpopularProductsQuery, UnpopularProductsQueryVariables>(UnpopularProductsDocument, options);
}
export type UnpopularProductsQueryHookResult = ReturnType<typeof useUnpopularProductsQuery>;
export type UnpopularProductsLazyQueryHookResult = ReturnType<typeof useUnpopularProductsLazyQuery>;
export type UnpopularProductsQueryResult = Apollo.QueryResult<UnpopularProductsQuery, UnpopularProductsQueryVariables>;
export function refetchUnpopularProductsQuery(variables?: UnpopularProductsQueryVariables) {
    return { query: UnpopularProductsDocument, variables };
}
export const TopCategoriesDocument = gql`
    query TopCategories($dateFromTo: DateFromTo!) {
  topCategories(dateFromTo: $dateFromTo) {
    id
    name
    totalPriceSold
    quantity
    color
    netMargin
    foodCost
    productWithNoRecipeCount
  }
}
    `;
export type TopCategoriesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<TopCategoriesQuery, TopCategoriesQueryVariables>, 'query'> & ({ variables: TopCategoriesQueryVariables; skip?: boolean } | { skip: boolean });

export const TopCategoriesComponent = (props: TopCategoriesComponentProps) => (
    <ApolloReactComponents.Query<TopCategoriesQuery, TopCategoriesQueryVariables> query={TopCategoriesDocument} {...props} />
);


/**
 * __useTopCategoriesQuery__
 *
 * To run a query within a React component, call `useTopCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTopCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTopCategoriesQuery({
 *   variables: {
 *      dateFromTo: // value for 'dateFromTo'
 *   },
 * });
 */
export function useTopCategoriesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TopCategoriesQuery, TopCategoriesQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<TopCategoriesQuery, TopCategoriesQueryVariables>(TopCategoriesDocument, options);
}
export function useTopCategoriesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TopCategoriesQuery, TopCategoriesQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<TopCategoriesQuery, TopCategoriesQueryVariables>(TopCategoriesDocument, options);
}
export type TopCategoriesQueryHookResult = ReturnType<typeof useTopCategoriesQuery>;
export type TopCategoriesLazyQueryHookResult = ReturnType<typeof useTopCategoriesLazyQuery>;
export type TopCategoriesQueryResult = Apollo.QueryResult<TopCategoriesQuery, TopCategoriesQueryVariables>;
export function refetchTopCategoriesQuery(variables?: TopCategoriesQueryVariables) {
    return { query: TopCategoriesDocument, variables };
}
export const UnpopularCategoriesDocument = gql`
    query UnpopularCategories($dateFromTo: DateFromTo!) {
  unpopularCategories(dateFromTo: $dateFromTo) {
    id
    name
    totalPriceSold
    quantity
    color
    netMargin
    foodCost
    productWithNoRecipeCount
  }
}
    `;
export type UnpopularCategoriesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<UnpopularCategoriesQuery, UnpopularCategoriesQueryVariables>, 'query'> & ({ variables: UnpopularCategoriesQueryVariables; skip?: boolean } | { skip: boolean });

export const UnpopularCategoriesComponent = (props: UnpopularCategoriesComponentProps) => (
    <ApolloReactComponents.Query<UnpopularCategoriesQuery, UnpopularCategoriesQueryVariables> query={UnpopularCategoriesDocument} {...props} />
);


/**
 * __useUnpopularCategoriesQuery__
 *
 * To run a query within a React component, call `useUnpopularCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnpopularCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnpopularCategoriesQuery({
 *   variables: {
 *      dateFromTo: // value for 'dateFromTo'
 *   },
 * });
 */
export function useUnpopularCategoriesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<UnpopularCategoriesQuery, UnpopularCategoriesQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<UnpopularCategoriesQuery, UnpopularCategoriesQueryVariables>(UnpopularCategoriesDocument, options);
}
export function useUnpopularCategoriesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UnpopularCategoriesQuery, UnpopularCategoriesQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<UnpopularCategoriesQuery, UnpopularCategoriesQueryVariables>(UnpopularCategoriesDocument, options);
}
export type UnpopularCategoriesQueryHookResult = ReturnType<typeof useUnpopularCategoriesQuery>;
export type UnpopularCategoriesLazyQueryHookResult = ReturnType<typeof useUnpopularCategoriesLazyQuery>;
export type UnpopularCategoriesQueryResult = Apollo.QueryResult<UnpopularCategoriesQuery, UnpopularCategoriesQueryVariables>;
export function refetchUnpopularCategoriesQuery(variables?: UnpopularCategoriesQueryVariables) {
    return { query: UnpopularCategoriesDocument, variables };
}
export const TopTableDocument = gql`
    query TopTable($dateFromTo: DateFromTo!) {
  topTable(dateFromTo: $dateFromTo) {
    id
    name
    orderQuantity
    totalPriceSold
  }
}
    `;
export type TopTableComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<TopTableQuery, TopTableQueryVariables>, 'query'> & ({ variables: TopTableQueryVariables; skip?: boolean } | { skip: boolean });

export const TopTableComponent = (props: TopTableComponentProps) => (
    <ApolloReactComponents.Query<TopTableQuery, TopTableQueryVariables> query={TopTableDocument} {...props} />
);


/**
 * __useTopTableQuery__
 *
 * To run a query within a React component, call `useTopTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useTopTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTopTableQuery({
 *   variables: {
 *      dateFromTo: // value for 'dateFromTo'
 *   },
 * });
 */
export function useTopTableQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TopTableQuery, TopTableQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<TopTableQuery, TopTableQueryVariables>(TopTableDocument, options);
}
export function useTopTableLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TopTableQuery, TopTableQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<TopTableQuery, TopTableQueryVariables>(TopTableDocument, options);
}
export type TopTableQueryHookResult = ReturnType<typeof useTopTableQuery>;
export type TopTableLazyQueryHookResult = ReturnType<typeof useTopTableLazyQuery>;
export type TopTableQueryResult = Apollo.QueryResult<TopTableQuery, TopTableQueryVariables>;
export function refetchTopTableQuery(variables?: TopTableQueryVariables) {
    return { query: TopTableDocument, variables };
}
export const PendingOrdersDocument = gql`
    query PendingOrders {
  pendingOrders {
    pendingTotalPrice
    orderQuantity
  }
}
    `;
export type PendingOrdersComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<PendingOrdersQuery, PendingOrdersQueryVariables>, 'query'>;

export const PendingOrdersComponent = (props: PendingOrdersComponentProps) => (
    <ApolloReactComponents.Query<PendingOrdersQuery, PendingOrdersQueryVariables> query={PendingOrdersDocument} {...props} />
);


/**
 * __usePendingOrdersQuery__
 *
 * To run a query within a React component, call `usePendingOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `usePendingOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePendingOrdersQuery({
 *   variables: {
 *   },
 * });
 */
export function usePendingOrdersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PendingOrdersQuery, PendingOrdersQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<PendingOrdersQuery, PendingOrdersQueryVariables>(PendingOrdersDocument, options);
}
export function usePendingOrdersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PendingOrdersQuery, PendingOrdersQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<PendingOrdersQuery, PendingOrdersQueryVariables>(PendingOrdersDocument, options);
}
export type PendingOrdersQueryHookResult = ReturnType<typeof usePendingOrdersQuery>;
export type PendingOrdersLazyQueryHookResult = ReturnType<typeof usePendingOrdersLazyQuery>;
export type PendingOrdersQueryResult = Apollo.QueryResult<PendingOrdersQuery, PendingOrdersQueryVariables>;
export function refetchPendingOrdersQuery(variables?: PendingOrdersQueryVariables) {
    return { query: PendingOrdersDocument, variables };
}
export const SalesChartDocument = gql`
    query SalesChart($dateFromTo: DateFromTo!) {
  salesChartData(dateFilter: $dateFromTo) {
    income
    date
    paymentMethod
  }
}
    `;
export type SalesChartComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<SalesChartQuery, SalesChartQueryVariables>, 'query'> & ({ variables: SalesChartQueryVariables; skip?: boolean } | { skip: boolean });

export const SalesChartComponent = (props: SalesChartComponentProps) => (
    <ApolloReactComponents.Query<SalesChartQuery, SalesChartQueryVariables> query={SalesChartDocument} {...props} />
);


/**
 * __useSalesChartQuery__
 *
 * To run a query within a React component, call `useSalesChartQuery` and pass it any options that fit your needs.
 * When your component renders, `useSalesChartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSalesChartQuery({
 *   variables: {
 *      dateFromTo: // value for 'dateFromTo'
 *   },
 * });
 */
export function useSalesChartQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SalesChartQuery, SalesChartQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<SalesChartQuery, SalesChartQueryVariables>(SalesChartDocument, options);
}
export function useSalesChartLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SalesChartQuery, SalesChartQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<SalesChartQuery, SalesChartQueryVariables>(SalesChartDocument, options);
}
export type SalesChartQueryHookResult = ReturnType<typeof useSalesChartQuery>;
export type SalesChartLazyQueryHookResult = ReturnType<typeof useSalesChartLazyQuery>;
export type SalesChartQueryResult = Apollo.QueryResult<SalesChartQuery, SalesChartQueryVariables>;
export function refetchSalesChartQuery(variables?: SalesChartQueryVariables) {
    return { query: SalesChartDocument, variables };
}
export const GrossIncomeByPaymentMethodDocument = gql`
    query GrossIncomeByPaymentMethod($dateFromTo: DateFromTo!) {
  venues {
    id
    dueDate
    debt
  }
  employeePermissions {
    warehouse
    backoffice
  }
  grossIncomeByPaymentMethod(dateFilter: $dateFromTo) {
    income
    paymentMethod
    paymentIntegrationPartner
  }
}
    `;
export type GrossIncomeByPaymentMethodComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GrossIncomeByPaymentMethodQuery, GrossIncomeByPaymentMethodQueryVariables>, 'query'> & ({ variables: GrossIncomeByPaymentMethodQueryVariables; skip?: boolean } | { skip: boolean });

export const GrossIncomeByPaymentMethodComponent = (props: GrossIncomeByPaymentMethodComponentProps) => (
    <ApolloReactComponents.Query<GrossIncomeByPaymentMethodQuery, GrossIncomeByPaymentMethodQueryVariables> query={GrossIncomeByPaymentMethodDocument} {...props} />
);


/**
 * __useGrossIncomeByPaymentMethodQuery__
 *
 * To run a query within a React component, call `useGrossIncomeByPaymentMethodQuery` and pass it any options that fit your needs.
 * When your component renders, `useGrossIncomeByPaymentMethodQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGrossIncomeByPaymentMethodQuery({
 *   variables: {
 *      dateFromTo: // value for 'dateFromTo'
 *   },
 * });
 */
export function useGrossIncomeByPaymentMethodQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GrossIncomeByPaymentMethodQuery, GrossIncomeByPaymentMethodQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<GrossIncomeByPaymentMethodQuery, GrossIncomeByPaymentMethodQueryVariables>(GrossIncomeByPaymentMethodDocument, options);
}
export function useGrossIncomeByPaymentMethodLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GrossIncomeByPaymentMethodQuery, GrossIncomeByPaymentMethodQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<GrossIncomeByPaymentMethodQuery, GrossIncomeByPaymentMethodQueryVariables>(GrossIncomeByPaymentMethodDocument, options);
}
export type GrossIncomeByPaymentMethodQueryHookResult = ReturnType<typeof useGrossIncomeByPaymentMethodQuery>;
export type GrossIncomeByPaymentMethodLazyQueryHookResult = ReturnType<typeof useGrossIncomeByPaymentMethodLazyQuery>;
export type GrossIncomeByPaymentMethodQueryResult = Apollo.QueryResult<GrossIncomeByPaymentMethodQuery, GrossIncomeByPaymentMethodQueryVariables>;
export function refetchGrossIncomeByPaymentMethodQuery(variables?: GrossIncomeByPaymentMethodQueryVariables) {
    return { query: GrossIncomeByPaymentMethodDocument, variables };
}
export const AverageOrderStatisticsDocument = gql`
    query averageOrderStatistics($dateFromTo: DateFromTo!) {
  averageOrderStatistics(dateFilter: $dateFromTo) {
    billCount
    itemsPerOrder
    averageBillAmount
    orderCount
  }
}
    `;
export type AverageOrderStatisticsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<AverageOrderStatisticsQuery, AverageOrderStatisticsQueryVariables>, 'query'> & ({ variables: AverageOrderStatisticsQueryVariables; skip?: boolean } | { skip: boolean });

export const AverageOrderStatisticsComponent = (props: AverageOrderStatisticsComponentProps) => (
    <ApolloReactComponents.Query<AverageOrderStatisticsQuery, AverageOrderStatisticsQueryVariables> query={AverageOrderStatisticsDocument} {...props} />
);


/**
 * __useAverageOrderStatisticsQuery__
 *
 * To run a query within a React component, call `useAverageOrderStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAverageOrderStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAverageOrderStatisticsQuery({
 *   variables: {
 *      dateFromTo: // value for 'dateFromTo'
 *   },
 * });
 */
export function useAverageOrderStatisticsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AverageOrderStatisticsQuery, AverageOrderStatisticsQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<AverageOrderStatisticsQuery, AverageOrderStatisticsQueryVariables>(AverageOrderStatisticsDocument, options);
}
export function useAverageOrderStatisticsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AverageOrderStatisticsQuery, AverageOrderStatisticsQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<AverageOrderStatisticsQuery, AverageOrderStatisticsQueryVariables>(AverageOrderStatisticsDocument, options);
}
export type AverageOrderStatisticsQueryHookResult = ReturnType<typeof useAverageOrderStatisticsQuery>;
export type AverageOrderStatisticsLazyQueryHookResult = ReturnType<typeof useAverageOrderStatisticsLazyQuery>;
export type AverageOrderStatisticsQueryResult = Apollo.QueryResult<AverageOrderStatisticsQuery, AverageOrderStatisticsQueryVariables>;
export function refetchAverageOrderStatisticsQuery(variables?: AverageOrderStatisticsQueryVariables) {
    return { query: AverageOrderStatisticsDocument, variables };
}
export const CancelationsDiscountsVoidedDocument = gql`
    query CancelationsDiscountsVoided($dateFromTo: DateFromTo!) {
  voidedBills(dateFromTo: $dateFromTo) {
    itemCount
    voidedValue
  }
  discountedOrderLines(dateFromTo: $dateFromTo) {
    itemCount
    discountedValue
  }
  canceledOrderLines(dateFromTo: $dateFromTo) {
    itemCount
    canceledValue
  }
}
    `;
export type CancelationsDiscountsVoidedComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<CancelationsDiscountsVoidedQuery, CancelationsDiscountsVoidedQueryVariables>, 'query'> & ({ variables: CancelationsDiscountsVoidedQueryVariables; skip?: boolean } | { skip: boolean });

export const CancelationsDiscountsVoidedComponent = (props: CancelationsDiscountsVoidedComponentProps) => (
    <ApolloReactComponents.Query<CancelationsDiscountsVoidedQuery, CancelationsDiscountsVoidedQueryVariables> query={CancelationsDiscountsVoidedDocument} {...props} />
);


/**
 * __useCancelationsDiscountsVoidedQuery__
 *
 * To run a query within a React component, call `useCancelationsDiscountsVoidedQuery` and pass it any options that fit your needs.
 * When your component renders, `useCancelationsDiscountsVoidedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCancelationsDiscountsVoidedQuery({
 *   variables: {
 *      dateFromTo: // value for 'dateFromTo'
 *   },
 * });
 */
export function useCancelationsDiscountsVoidedQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CancelationsDiscountsVoidedQuery, CancelationsDiscountsVoidedQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<CancelationsDiscountsVoidedQuery, CancelationsDiscountsVoidedQueryVariables>(CancelationsDiscountsVoidedDocument, options);
}
export function useCancelationsDiscountsVoidedLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CancelationsDiscountsVoidedQuery, CancelationsDiscountsVoidedQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<CancelationsDiscountsVoidedQuery, CancelationsDiscountsVoidedQueryVariables>(CancelationsDiscountsVoidedDocument, options);
}
export type CancelationsDiscountsVoidedQueryHookResult = ReturnType<typeof useCancelationsDiscountsVoidedQuery>;
export type CancelationsDiscountsVoidedLazyQueryHookResult = ReturnType<typeof useCancelationsDiscountsVoidedLazyQuery>;
export type CancelationsDiscountsVoidedQueryResult = Apollo.QueryResult<CancelationsDiscountsVoidedQuery, CancelationsDiscountsVoidedQueryVariables>;
export function refetchCancelationsDiscountsVoidedQuery(variables?: CancelationsDiscountsVoidedQueryVariables) {
    return { query: CancelationsDiscountsVoidedDocument, variables };
}
export const GetMoneyFlowReportDocument = gql`
    query GetMoneyFlowReport($dateFromTo: DateFromTo) {
  moneyFlowReport(dateFromTo: $dateFromTo)
}
    `;
export type GetMoneyFlowReportComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetMoneyFlowReportQuery, GetMoneyFlowReportQueryVariables>, 'query'>;

export const GetMoneyFlowReportComponent = (props: GetMoneyFlowReportComponentProps) => (
    <ApolloReactComponents.Query<GetMoneyFlowReportQuery, GetMoneyFlowReportQueryVariables> query={GetMoneyFlowReportDocument} {...props} />
);


/**
 * __useGetMoneyFlowReportQuery__
 *
 * To run a query within a React component, call `useGetMoneyFlowReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMoneyFlowReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMoneyFlowReportQuery({
 *   variables: {
 *      dateFromTo: // value for 'dateFromTo'
 *   },
 * });
 */
export function useGetMoneyFlowReportQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetMoneyFlowReportQuery, GetMoneyFlowReportQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<GetMoneyFlowReportQuery, GetMoneyFlowReportQueryVariables>(GetMoneyFlowReportDocument, options);
}
export function useGetMoneyFlowReportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMoneyFlowReportQuery, GetMoneyFlowReportQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<GetMoneyFlowReportQuery, GetMoneyFlowReportQueryVariables>(GetMoneyFlowReportDocument, options);
}
export type GetMoneyFlowReportQueryHookResult = ReturnType<typeof useGetMoneyFlowReportQuery>;
export type GetMoneyFlowReportLazyQueryHookResult = ReturnType<typeof useGetMoneyFlowReportLazyQuery>;
export type GetMoneyFlowReportQueryResult = Apollo.QueryResult<GetMoneyFlowReportQuery, GetMoneyFlowReportQueryVariables>;
export function refetchGetMoneyFlowReportQuery(variables?: GetMoneyFlowReportQueryVariables) {
    return { query: GetMoneyFlowReportDocument, variables };
}
export const PaginatedDeductionListsDocument = gql`
    query PaginatedDeductionLists($deductionDateUtc: Date, $deductionReason: DeductionReason, $isProcessed: Boolean, $limit: Int, $offset: Int, $warehouseId: ID!) {
  paginatedDeductionLists(deductionDateUtc: $deductionDateUtc, deductionReason: $deductionReason, isProcessed: $isProcessed, limit: $limit, offset: $offset, warehouseId: $warehouseId) @connection(key: "paginatedDeductionLists", filter: ["deductionDateUtc", "deductionReason", "isProcessed", "warehouseId"]) {
    items {
      id
      deductionReason
      deductionDateUtc
      deductionListItemsCount
      deductionListItemsTotalCost
      createdBy {
        employeeId
        firstName
        lastName
      }
    }
    count
  }
}
    `;
export type PaginatedDeductionListsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<PaginatedDeductionListsQuery, PaginatedDeductionListsQueryVariables>, 'query'> & ({ variables: PaginatedDeductionListsQueryVariables; skip?: boolean } | { skip: boolean });

export const PaginatedDeductionListsComponent = (props: PaginatedDeductionListsComponentProps) => (
    <ApolloReactComponents.Query<PaginatedDeductionListsQuery, PaginatedDeductionListsQueryVariables> query={PaginatedDeductionListsDocument} {...props} />
);


/**
 * __usePaginatedDeductionListsQuery__
 *
 * To run a query within a React component, call `usePaginatedDeductionListsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedDeductionListsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedDeductionListsQuery({
 *   variables: {
 *      deductionDateUtc: // value for 'deductionDateUtc'
 *      deductionReason: // value for 'deductionReason'
 *      isProcessed: // value for 'isProcessed'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      warehouseId: // value for 'warehouseId'
 *   },
 * });
 */
export function usePaginatedDeductionListsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PaginatedDeductionListsQuery, PaginatedDeductionListsQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<PaginatedDeductionListsQuery, PaginatedDeductionListsQueryVariables>(PaginatedDeductionListsDocument, options);
}
export function usePaginatedDeductionListsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PaginatedDeductionListsQuery, PaginatedDeductionListsQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<PaginatedDeductionListsQuery, PaginatedDeductionListsQueryVariables>(PaginatedDeductionListsDocument, options);
}
export type PaginatedDeductionListsQueryHookResult = ReturnType<typeof usePaginatedDeductionListsQuery>;
export type PaginatedDeductionListsLazyQueryHookResult = ReturnType<typeof usePaginatedDeductionListsLazyQuery>;
export type PaginatedDeductionListsQueryResult = Apollo.QueryResult<PaginatedDeductionListsQuery, PaginatedDeductionListsQueryVariables>;
export function refetchPaginatedDeductionListsQuery(variables?: PaginatedDeductionListsQueryVariables) {
    return { query: PaginatedDeductionListsDocument, variables };
}
export const PaginatedDeductionListItemsDocument = gql`
    query PaginatedDeductionListItems($deductionListId: ID!, $limit: Int, $offset: Int) {
  paginatedDeductionListItems(deductionListId: $deductionListId, limit: $limit, offset: $offset) @connection(key: "paginatedDeductionLists", filter: ["deductionListId", "limit", "offset"]) {
    items {
      id
      priceWithoutVat
      quantity
      stockCard {
        id
        name
      }
      unitType
    }
    count
  }
}
    `;
export type PaginatedDeductionListItemsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<PaginatedDeductionListItemsQuery, PaginatedDeductionListItemsQueryVariables>, 'query'> & ({ variables: PaginatedDeductionListItemsQueryVariables; skip?: boolean } | { skip: boolean });

export const PaginatedDeductionListItemsComponent = (props: PaginatedDeductionListItemsComponentProps) => (
    <ApolloReactComponents.Query<PaginatedDeductionListItemsQuery, PaginatedDeductionListItemsQueryVariables> query={PaginatedDeductionListItemsDocument} {...props} />
);


/**
 * __usePaginatedDeductionListItemsQuery__
 *
 * To run a query within a React component, call `usePaginatedDeductionListItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedDeductionListItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedDeductionListItemsQuery({
 *   variables: {
 *      deductionListId: // value for 'deductionListId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function usePaginatedDeductionListItemsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PaginatedDeductionListItemsQuery, PaginatedDeductionListItemsQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<PaginatedDeductionListItemsQuery, PaginatedDeductionListItemsQueryVariables>(PaginatedDeductionListItemsDocument, options);
}
export function usePaginatedDeductionListItemsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PaginatedDeductionListItemsQuery, PaginatedDeductionListItemsQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<PaginatedDeductionListItemsQuery, PaginatedDeductionListItemsQueryVariables>(PaginatedDeductionListItemsDocument, options);
}
export type PaginatedDeductionListItemsQueryHookResult = ReturnType<typeof usePaginatedDeductionListItemsQuery>;
export type PaginatedDeductionListItemsLazyQueryHookResult = ReturnType<typeof usePaginatedDeductionListItemsLazyQuery>;
export type PaginatedDeductionListItemsQueryResult = Apollo.QueryResult<PaginatedDeductionListItemsQuery, PaginatedDeductionListItemsQueryVariables>;
export function refetchPaginatedDeductionListItemsQuery(variables?: PaginatedDeductionListItemsQueryVariables) {
    return { query: PaginatedDeductionListItemsDocument, variables };
}
export const DeductionListDocument = gql`
    query DeductionList($id: ID!, $warehouseId: ID!) {
  deductionList(id: $id, warehouseId: $warehouseId) {
    id
    deductionDateUtc
    deductionListItemsCount
    deductionListItemsTotalCost
    deductionReason
    createdBy {
      employeeId
      firstName
      lastName
    }
  }
}
    `;
export type DeductionListComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<DeductionListQuery, DeductionListQueryVariables>, 'query'> & ({ variables: DeductionListQueryVariables; skip?: boolean } | { skip: boolean });

export const DeductionListComponent = (props: DeductionListComponentProps) => (
    <ApolloReactComponents.Query<DeductionListQuery, DeductionListQueryVariables> query={DeductionListDocument} {...props} />
);


/**
 * __useDeductionListQuery__
 *
 * To run a query within a React component, call `useDeductionListQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeductionListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeductionListQuery({
 *   variables: {
 *      id: // value for 'id'
 *      warehouseId: // value for 'warehouseId'
 *   },
 * });
 */
export function useDeductionListQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DeductionListQuery, DeductionListQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<DeductionListQuery, DeductionListQueryVariables>(DeductionListDocument, options);
}
export function useDeductionListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DeductionListQuery, DeductionListQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<DeductionListQuery, DeductionListQueryVariables>(DeductionListDocument, options);
}
export type DeductionListQueryHookResult = ReturnType<typeof useDeductionListQuery>;
export type DeductionListLazyQueryHookResult = ReturnType<typeof useDeductionListLazyQuery>;
export type DeductionListQueryResult = Apollo.QueryResult<DeductionListQuery, DeductionListQueryVariables>;
export function refetchDeductionListQuery(variables?: DeductionListQueryVariables) {
    return { query: DeductionListDocument, variables };
}
export const UploadInvoicesDocument = gql`
    mutation UploadInvoices($files: [Upload!]!, $warehouseId: ID!) {
  uploadInvoices(files: $files, warehouseId: $warehouseId)
}
    `;
export type UploadInvoicesMutationFn = Apollo.MutationFunction<UploadInvoicesMutation, UploadInvoicesMutationVariables>;
export type UploadInvoicesComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UploadInvoicesMutation, UploadInvoicesMutationVariables>, 'mutation'>;

export const UploadInvoicesComponent = (props: UploadInvoicesComponentProps) => (
    <ApolloReactComponents.Mutation<UploadInvoicesMutation, UploadInvoicesMutationVariables> mutation={UploadInvoicesDocument} {...props} />
);


/**
 * __useUploadInvoicesMutation__
 *
 * To run a mutation, you first call `useUploadInvoicesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadInvoicesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadInvoicesMutation, { data, loading, error }] = useUploadInvoicesMutation({
 *   variables: {
 *      files: // value for 'files'
 *      warehouseId: // value for 'warehouseId'
 *   },
 * });
 */
export function useUploadInvoicesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UploadInvoicesMutation, UploadInvoicesMutationVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<UploadInvoicesMutation, UploadInvoicesMutationVariables>(UploadInvoicesDocument, options);
}
export type UploadInvoicesMutationHookResult = ReturnType<typeof useUploadInvoicesMutation>;
export type UploadInvoicesMutationResult = Apollo.MutationResult<UploadInvoicesMutation>;
export type UploadInvoicesMutationOptions = Apollo.BaseMutationOptions<UploadInvoicesMutation, UploadInvoicesMutationVariables>;
export const DeleteRossumUploadDocument = gql`
    mutation DeleteRossumUpload($rossumUploadId: ID!) {
  deleteRossumUpload(rossumUploadId: $rossumUploadId)
}
    `;
export type DeleteRossumUploadMutationFn = Apollo.MutationFunction<DeleteRossumUploadMutation, DeleteRossumUploadMutationVariables>;
export type DeleteRossumUploadComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DeleteRossumUploadMutation, DeleteRossumUploadMutationVariables>, 'mutation'>;

export const DeleteRossumUploadComponent = (props: DeleteRossumUploadComponentProps) => (
    <ApolloReactComponents.Mutation<DeleteRossumUploadMutation, DeleteRossumUploadMutationVariables> mutation={DeleteRossumUploadDocument} {...props} />
);


/**
 * __useDeleteRossumUploadMutation__
 *
 * To run a mutation, you first call `useDeleteRossumUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRossumUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRossumUploadMutation, { data, loading, error }] = useDeleteRossumUploadMutation({
 *   variables: {
 *      rossumUploadId: // value for 'rossumUploadId'
 *   },
 * });
 */
export function useDeleteRossumUploadMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteRossumUploadMutation, DeleteRossumUploadMutationVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<DeleteRossumUploadMutation, DeleteRossumUploadMutationVariables>(DeleteRossumUploadDocument, options);
}
export type DeleteRossumUploadMutationHookResult = ReturnType<typeof useDeleteRossumUploadMutation>;
export type DeleteRossumUploadMutationResult = Apollo.MutationResult<DeleteRossumUploadMutation>;
export type DeleteRossumUploadMutationOptions = Apollo.BaseMutationOptions<DeleteRossumUploadMutation, DeleteRossumUploadMutationVariables>;
export const CompleteRossumUploadDocument = gql`
    mutation CompleteRossumUpload($rossumUploadId: ID!) {
  completeRossumUpload(rossumUploadId: $rossumUploadId) {
    id
    status
  }
}
    `;
export type CompleteRossumUploadMutationFn = Apollo.MutationFunction<CompleteRossumUploadMutation, CompleteRossumUploadMutationVariables>;
export type CompleteRossumUploadComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CompleteRossumUploadMutation, CompleteRossumUploadMutationVariables>, 'mutation'>;

export const CompleteRossumUploadComponent = (props: CompleteRossumUploadComponentProps) => (
    <ApolloReactComponents.Mutation<CompleteRossumUploadMutation, CompleteRossumUploadMutationVariables> mutation={CompleteRossumUploadDocument} {...props} />
);


/**
 * __useCompleteRossumUploadMutation__
 *
 * To run a mutation, you first call `useCompleteRossumUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteRossumUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeRossumUploadMutation, { data, loading, error }] = useCompleteRossumUploadMutation({
 *   variables: {
 *      rossumUploadId: // value for 'rossumUploadId'
 *   },
 * });
 */
export function useCompleteRossumUploadMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CompleteRossumUploadMutation, CompleteRossumUploadMutationVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<CompleteRossumUploadMutation, CompleteRossumUploadMutationVariables>(CompleteRossumUploadDocument, options);
}
export type CompleteRossumUploadMutationHookResult = ReturnType<typeof useCompleteRossumUploadMutation>;
export type CompleteRossumUploadMutationResult = Apollo.MutationResult<CompleteRossumUploadMutation>;
export type CompleteRossumUploadMutationOptions = Apollo.BaseMutationOptions<CompleteRossumUploadMutation, CompleteRossumUploadMutationVariables>;
export const CreateOrReplaceDeliveryOptionsDocument = gql`
    mutation CreateOrReplaceDeliveryOptions($deliveryOptions: [DeliveryOptionCreate!]!) {
  createOrReplaceDeliveryOptions(deliveryOptions: $deliveryOptions) {
    itemCode
    supplierId
    stockCardId
    conversionUnitType
    conversionMultiplier
  }
}
    `;
export type CreateOrReplaceDeliveryOptionsMutationFn = Apollo.MutationFunction<CreateOrReplaceDeliveryOptionsMutation, CreateOrReplaceDeliveryOptionsMutationVariables>;
export type CreateOrReplaceDeliveryOptionsComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateOrReplaceDeliveryOptionsMutation, CreateOrReplaceDeliveryOptionsMutationVariables>, 'mutation'>;

export const CreateOrReplaceDeliveryOptionsComponent = (props: CreateOrReplaceDeliveryOptionsComponentProps) => (
    <ApolloReactComponents.Mutation<CreateOrReplaceDeliveryOptionsMutation, CreateOrReplaceDeliveryOptionsMutationVariables> mutation={CreateOrReplaceDeliveryOptionsDocument} {...props} />
);


/**
 * __useCreateOrReplaceDeliveryOptionsMutation__
 *
 * To run a mutation, you first call `useCreateOrReplaceDeliveryOptionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrReplaceDeliveryOptionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrReplaceDeliveryOptionsMutation, { data, loading, error }] = useCreateOrReplaceDeliveryOptionsMutation({
 *   variables: {
 *      deliveryOptions: // value for 'deliveryOptions'
 *   },
 * });
 */
export function useCreateOrReplaceDeliveryOptionsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateOrReplaceDeliveryOptionsMutation, CreateOrReplaceDeliveryOptionsMutationVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<CreateOrReplaceDeliveryOptionsMutation, CreateOrReplaceDeliveryOptionsMutationVariables>(CreateOrReplaceDeliveryOptionsDocument, options);
}
export type CreateOrReplaceDeliveryOptionsMutationHookResult = ReturnType<typeof useCreateOrReplaceDeliveryOptionsMutation>;
export type CreateOrReplaceDeliveryOptionsMutationResult = Apollo.MutationResult<CreateOrReplaceDeliveryOptionsMutation>;
export type CreateOrReplaceDeliveryOptionsMutationOptions = Apollo.BaseMutationOptions<CreateOrReplaceDeliveryOptionsMutation, CreateOrReplaceDeliveryOptionsMutationVariables>;
export const CreateDeliveryListDocument = gql`
    mutation CreateDeliveryList($data: DeliveryListCreate!) {
  createDeliveryList(data: $data) {
    id
    invoiceNumber
  }
}
    `;
export type CreateDeliveryListMutationFn = Apollo.MutationFunction<CreateDeliveryListMutation, CreateDeliveryListMutationVariables>;
export type CreateDeliveryListComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateDeliveryListMutation, CreateDeliveryListMutationVariables>, 'mutation'>;

export const CreateDeliveryListComponent = (props: CreateDeliveryListComponentProps) => (
    <ApolloReactComponents.Mutation<CreateDeliveryListMutation, CreateDeliveryListMutationVariables> mutation={CreateDeliveryListDocument} {...props} />
);


/**
 * __useCreateDeliveryListMutation__
 *
 * To run a mutation, you first call `useCreateDeliveryListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDeliveryListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDeliveryListMutation, { data, loading, error }] = useCreateDeliveryListMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateDeliveryListMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateDeliveryListMutation, CreateDeliveryListMutationVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<CreateDeliveryListMutation, CreateDeliveryListMutationVariables>(CreateDeliveryListDocument, options);
}
export type CreateDeliveryListMutationHookResult = ReturnType<typeof useCreateDeliveryListMutation>;
export type CreateDeliveryListMutationResult = Apollo.MutationResult<CreateDeliveryListMutation>;
export type CreateDeliveryListMutationOptions = Apollo.BaseMutationOptions<CreateDeliveryListMutation, CreateDeliveryListMutationVariables>;
export const UpdateStockCardCategoryDocument = gql`
    mutation UpdateStockCardCategory($id: ID!, $data: StockCardCategoryUpdate!) {
  updateStockCardCategory(id: $id, data: $data) {
    id
    name
  }
}
    `;
export type UpdateStockCardCategoryMutationFn = Apollo.MutationFunction<UpdateStockCardCategoryMutation, UpdateStockCardCategoryMutationVariables>;
export type UpdateStockCardCategoryComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateStockCardCategoryMutation, UpdateStockCardCategoryMutationVariables>, 'mutation'>;

export const UpdateStockCardCategoryComponent = (props: UpdateStockCardCategoryComponentProps) => (
    <ApolloReactComponents.Mutation<UpdateStockCardCategoryMutation, UpdateStockCardCategoryMutationVariables> mutation={UpdateStockCardCategoryDocument} {...props} />
);


/**
 * __useUpdateStockCardCategoryMutation__
 *
 * To run a mutation, you first call `useUpdateStockCardCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStockCardCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStockCardCategoryMutation, { data, loading, error }] = useUpdateStockCardCategoryMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateStockCardCategoryMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateStockCardCategoryMutation, UpdateStockCardCategoryMutationVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<UpdateStockCardCategoryMutation, UpdateStockCardCategoryMutationVariables>(UpdateStockCardCategoryDocument, options);
}
export type UpdateStockCardCategoryMutationHookResult = ReturnType<typeof useUpdateStockCardCategoryMutation>;
export type UpdateStockCardCategoryMutationResult = Apollo.MutationResult<UpdateStockCardCategoryMutation>;
export type UpdateStockCardCategoryMutationOptions = Apollo.BaseMutationOptions<UpdateStockCardCategoryMutation, UpdateStockCardCategoryMutationVariables>;
export const RossumUploadsByWarehouseIdDocument = gql`
    query RossumUploadsByWarehouseId($warehouseId: ID!) {
  rossumUploadsByWarehouseId(warehouseId: $warehouseId) {
    id
    createdAtUtc
    filename
    rossumAnnotationUrl
    status
  }
}
    `;
export type RossumUploadsByWarehouseIdComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<RossumUploadsByWarehouseIdQuery, RossumUploadsByWarehouseIdQueryVariables>, 'query'> & ({ variables: RossumUploadsByWarehouseIdQueryVariables; skip?: boolean } | { skip: boolean });

export const RossumUploadsByWarehouseIdComponent = (props: RossumUploadsByWarehouseIdComponentProps) => (
    <ApolloReactComponents.Query<RossumUploadsByWarehouseIdQuery, RossumUploadsByWarehouseIdQueryVariables> query={RossumUploadsByWarehouseIdDocument} {...props} />
);


/**
 * __useRossumUploadsByWarehouseIdQuery__
 *
 * To run a query within a React component, call `useRossumUploadsByWarehouseIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useRossumUploadsByWarehouseIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRossumUploadsByWarehouseIdQuery({
 *   variables: {
 *      warehouseId: // value for 'warehouseId'
 *   },
 * });
 */
export function useRossumUploadsByWarehouseIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RossumUploadsByWarehouseIdQuery, RossumUploadsByWarehouseIdQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<RossumUploadsByWarehouseIdQuery, RossumUploadsByWarehouseIdQueryVariables>(RossumUploadsByWarehouseIdDocument, options);
}
export function useRossumUploadsByWarehouseIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RossumUploadsByWarehouseIdQuery, RossumUploadsByWarehouseIdQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<RossumUploadsByWarehouseIdQuery, RossumUploadsByWarehouseIdQueryVariables>(RossumUploadsByWarehouseIdDocument, options);
}
export type RossumUploadsByWarehouseIdQueryHookResult = ReturnType<typeof useRossumUploadsByWarehouseIdQuery>;
export type RossumUploadsByWarehouseIdLazyQueryHookResult = ReturnType<typeof useRossumUploadsByWarehouseIdLazyQuery>;
export type RossumUploadsByWarehouseIdQueryResult = Apollo.QueryResult<RossumUploadsByWarehouseIdQuery, RossumUploadsByWarehouseIdQueryVariables>;
export function refetchRossumUploadsByWarehouseIdQuery(variables?: RossumUploadsByWarehouseIdQueryVariables) {
    return { query: RossumUploadsByWarehouseIdDocument, variables };
}
export const RossumProcessedInvoiceByRossumUploadIdDocument = gql`
    query RossumProcessedInvoiceByRossumUploadId($rossumUploadId: ID!, $warehouseId: ID!) {
  rossumProcessedInvoiceByRossumUploadId(rossumUploadId: $rossumUploadId, warehouseId: $warehouseId) {
    invoiceNumber
    deliveryDate
    supplierId
    totalAmount
    processedListItems {
      id
      code
      description
      quantity
      vatRate
      unitPrice
      unitPriceWithoutVat
      totalBase
      totalAmount
      unitOfMeasure
      deliveryOption {
        stockCardId
        conversionUnitType
        conversionMultiplier
      }
    }
  }
}
    `;
export type RossumProcessedInvoiceByRossumUploadIdComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<RossumProcessedInvoiceByRossumUploadIdQuery, RossumProcessedInvoiceByRossumUploadIdQueryVariables>, 'query'> & ({ variables: RossumProcessedInvoiceByRossumUploadIdQueryVariables; skip?: boolean } | { skip: boolean });

export const RossumProcessedInvoiceByRossumUploadIdComponent = (props: RossumProcessedInvoiceByRossumUploadIdComponentProps) => (
    <ApolloReactComponents.Query<RossumProcessedInvoiceByRossumUploadIdQuery, RossumProcessedInvoiceByRossumUploadIdQueryVariables> query={RossumProcessedInvoiceByRossumUploadIdDocument} {...props} />
);


/**
 * __useRossumProcessedInvoiceByRossumUploadIdQuery__
 *
 * To run a query within a React component, call `useRossumProcessedInvoiceByRossumUploadIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useRossumProcessedInvoiceByRossumUploadIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRossumProcessedInvoiceByRossumUploadIdQuery({
 *   variables: {
 *      rossumUploadId: // value for 'rossumUploadId'
 *      warehouseId: // value for 'warehouseId'
 *   },
 * });
 */
export function useRossumProcessedInvoiceByRossumUploadIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RossumProcessedInvoiceByRossumUploadIdQuery, RossumProcessedInvoiceByRossumUploadIdQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<RossumProcessedInvoiceByRossumUploadIdQuery, RossumProcessedInvoiceByRossumUploadIdQueryVariables>(RossumProcessedInvoiceByRossumUploadIdDocument, options);
}
export function useRossumProcessedInvoiceByRossumUploadIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RossumProcessedInvoiceByRossumUploadIdQuery, RossumProcessedInvoiceByRossumUploadIdQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<RossumProcessedInvoiceByRossumUploadIdQuery, RossumProcessedInvoiceByRossumUploadIdQueryVariables>(RossumProcessedInvoiceByRossumUploadIdDocument, options);
}
export type RossumProcessedInvoiceByRossumUploadIdQueryHookResult = ReturnType<typeof useRossumProcessedInvoiceByRossumUploadIdQuery>;
export type RossumProcessedInvoiceByRossumUploadIdLazyQueryHookResult = ReturnType<typeof useRossumProcessedInvoiceByRossumUploadIdLazyQuery>;
export type RossumProcessedInvoiceByRossumUploadIdQueryResult = Apollo.QueryResult<RossumProcessedInvoiceByRossumUploadIdQuery, RossumProcessedInvoiceByRossumUploadIdQueryVariables>;
export function refetchRossumProcessedInvoiceByRossumUploadIdQuery(variables?: RossumProcessedInvoiceByRossumUploadIdQueryVariables) {
    return { query: RossumProcessedInvoiceByRossumUploadIdDocument, variables };
}
export const PaginatedDeliveryListsDocument = gql`
    query PaginatedDeliveryLists($offset: Int, $limit: Int, $warehouseId: ID!, $supplierId: ID, $invoiceNumber: String, $deliveryDateUtc: Date, $isProcessed: Boolean) {
  paginatedDeliveryLists(offset: $offset, limit: $limit, warehouseId: $warehouseId, supplierId: $supplierId, invoiceNumber: $invoiceNumber, deliveryDateUtc: $deliveryDateUtc, isProcessed: $isProcessed) @connection(key: "paginatedDeliveryLists", filter: ["warehouseId", "supplierId", "invoiceNumber", "deliveryDateUtc", "isProcessed"]) {
    items {
      id
      createdAtUtc
      updatedAtUtc
      createdById
      invoiceNumber
      deliveryDateUtc
      isProcessed
      deliveryListItemsCount
      deliveryListItemsTotalCost
      supplier {
        id
        legalName
      }
    }
    count
  }
}
    `;
export type PaginatedDeliveryListsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<PaginatedDeliveryListsQuery, PaginatedDeliveryListsQueryVariables>, 'query'> & ({ variables: PaginatedDeliveryListsQueryVariables; skip?: boolean } | { skip: boolean });

export const PaginatedDeliveryListsComponent = (props: PaginatedDeliveryListsComponentProps) => (
    <ApolloReactComponents.Query<PaginatedDeliveryListsQuery, PaginatedDeliveryListsQueryVariables> query={PaginatedDeliveryListsDocument} {...props} />
);


/**
 * __usePaginatedDeliveryListsQuery__
 *
 * To run a query within a React component, call `usePaginatedDeliveryListsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedDeliveryListsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedDeliveryListsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      warehouseId: // value for 'warehouseId'
 *      supplierId: // value for 'supplierId'
 *      invoiceNumber: // value for 'invoiceNumber'
 *      deliveryDateUtc: // value for 'deliveryDateUtc'
 *      isProcessed: // value for 'isProcessed'
 *   },
 * });
 */
export function usePaginatedDeliveryListsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PaginatedDeliveryListsQuery, PaginatedDeliveryListsQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<PaginatedDeliveryListsQuery, PaginatedDeliveryListsQueryVariables>(PaginatedDeliveryListsDocument, options);
}
export function usePaginatedDeliveryListsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PaginatedDeliveryListsQuery, PaginatedDeliveryListsQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<PaginatedDeliveryListsQuery, PaginatedDeliveryListsQueryVariables>(PaginatedDeliveryListsDocument, options);
}
export type PaginatedDeliveryListsQueryHookResult = ReturnType<typeof usePaginatedDeliveryListsQuery>;
export type PaginatedDeliveryListsLazyQueryHookResult = ReturnType<typeof usePaginatedDeliveryListsLazyQuery>;
export type PaginatedDeliveryListsQueryResult = Apollo.QueryResult<PaginatedDeliveryListsQuery, PaginatedDeliveryListsQueryVariables>;
export function refetchPaginatedDeliveryListsQuery(variables?: PaginatedDeliveryListsQueryVariables) {
    return { query: PaginatedDeliveryListsDocument, variables };
}
export const ExistingSuppliersDocument = gql`
    query ExistingSuppliers {
  existingSuppliers {
    ...SuppliersFragment
  }
}
    ${SuppliersFragmentDoc}`;
export type ExistingSuppliersComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ExistingSuppliersQuery, ExistingSuppliersQueryVariables>, 'query'>;

export const ExistingSuppliersComponent = (props: ExistingSuppliersComponentProps) => (
    <ApolloReactComponents.Query<ExistingSuppliersQuery, ExistingSuppliersQueryVariables> query={ExistingSuppliersDocument} {...props} />
);


/**
 * __useExistingSuppliersQuery__
 *
 * To run a query within a React component, call `useExistingSuppliersQuery` and pass it any options that fit your needs.
 * When your component renders, `useExistingSuppliersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExistingSuppliersQuery({
 *   variables: {
 *   },
 * });
 */
export function useExistingSuppliersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ExistingSuppliersQuery, ExistingSuppliersQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<ExistingSuppliersQuery, ExistingSuppliersQueryVariables>(ExistingSuppliersDocument, options);
}
export function useExistingSuppliersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ExistingSuppliersQuery, ExistingSuppliersQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<ExistingSuppliersQuery, ExistingSuppliersQueryVariables>(ExistingSuppliersDocument, options);
}
export type ExistingSuppliersQueryHookResult = ReturnType<typeof useExistingSuppliersQuery>;
export type ExistingSuppliersLazyQueryHookResult = ReturnType<typeof useExistingSuppliersLazyQuery>;
export type ExistingSuppliersQueryResult = Apollo.QueryResult<ExistingSuppliersQuery, ExistingSuppliersQueryVariables>;
export function refetchExistingSuppliersQuery(variables?: ExistingSuppliersQueryVariables) {
    return { query: ExistingSuppliersDocument, variables };
}
export const DeliveryListDocument = gql`
    query DeliveryList($id: ID!, $warehouseId: ID!) {
  deliveryList(id: $id, warehouseId: $warehouseId) {
    id
    createdAtUtc
    updatedAtUtc
    createdById
    invoiceNumber
    deliveryDateUtc
    isProcessed
    deliveryListItemsCount
    deliveryListItemsTotalCost
    supplier {
      id
      legalName
    }
    deliveryListItems {
      id
      quantity
      priceWithoutVat
      deliveryListId
      stockCard {
        id
        name
        storageUnit
        conversionUnit
        convertedAmount
      }
    }
  }
}
    `;
export type DeliveryListComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<DeliveryListQuery, DeliveryListQueryVariables>, 'query'> & ({ variables: DeliveryListQueryVariables; skip?: boolean } | { skip: boolean });

export const DeliveryListComponent = (props: DeliveryListComponentProps) => (
    <ApolloReactComponents.Query<DeliveryListQuery, DeliveryListQueryVariables> query={DeliveryListDocument} {...props} />
);


/**
 * __useDeliveryListQuery__
 *
 * To run a query within a React component, call `useDeliveryListQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeliveryListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeliveryListQuery({
 *   variables: {
 *      id: // value for 'id'
 *      warehouseId: // value for 'warehouseId'
 *   },
 * });
 */
export function useDeliveryListQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DeliveryListQuery, DeliveryListQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<DeliveryListQuery, DeliveryListQueryVariables>(DeliveryListDocument, options);
}
export function useDeliveryListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DeliveryListQuery, DeliveryListQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<DeliveryListQuery, DeliveryListQueryVariables>(DeliveryListDocument, options);
}
export type DeliveryListQueryHookResult = ReturnType<typeof useDeliveryListQuery>;
export type DeliveryListLazyQueryHookResult = ReturnType<typeof useDeliveryListLazyQuery>;
export type DeliveryListQueryResult = Apollo.QueryResult<DeliveryListQuery, DeliveryListQueryVariables>;
export function refetchDeliveryListQuery(variables?: DeliveryListQueryVariables) {
    return { query: DeliveryListDocument, variables };
}
export const StockCardCategoryDocument = gql`
    query StockCardCategory($id: ID!) {
  stockCardCategory(id: $id) {
    id
    name
  }
}
    `;
export type StockCardCategoryComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<StockCardCategoryQuery, StockCardCategoryQueryVariables>, 'query'> & ({ variables: StockCardCategoryQueryVariables; skip?: boolean } | { skip: boolean });

export const StockCardCategoryComponent = (props: StockCardCategoryComponentProps) => (
    <ApolloReactComponents.Query<StockCardCategoryQuery, StockCardCategoryQueryVariables> query={StockCardCategoryDocument} {...props} />
);


/**
 * __useStockCardCategoryQuery__
 *
 * To run a query within a React component, call `useStockCardCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useStockCardCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStockCardCategoryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStockCardCategoryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<StockCardCategoryQuery, StockCardCategoryQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<StockCardCategoryQuery, StockCardCategoryQueryVariables>(StockCardCategoryDocument, options);
}
export function useStockCardCategoryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<StockCardCategoryQuery, StockCardCategoryQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<StockCardCategoryQuery, StockCardCategoryQueryVariables>(StockCardCategoryDocument, options);
}
export type StockCardCategoryQueryHookResult = ReturnType<typeof useStockCardCategoryQuery>;
export type StockCardCategoryLazyQueryHookResult = ReturnType<typeof useStockCardCategoryLazyQuery>;
export type StockCardCategoryQueryResult = Apollo.QueryResult<StockCardCategoryQuery, StockCardCategoryQueryVariables>;
export function refetchStockCardCategoryQuery(variables?: StockCardCategoryQueryVariables) {
    return { query: StockCardCategoryDocument, variables };
}
export const DeliveryListStockCardsDocument = gql`
    query DeliveryListStockCards($warehouseIds: [ID!]!, $offset: Int, $limit: Int, $stockCardCategoryId: ID, $nameOrSku: String) {
  stockCards(warehouseIds: $warehouseIds, offset: $offset, limit: $limit, nameOrSku: $nameOrSku, stockCardCategoryId: $stockCardCategoryId) @connection(key: "stockCards", filter: ["warehouseIds", "stockCardCategoryId", "nameOrSku"]) {
    id
    name
    storageUnit
    conversionUnit
    convertedAmount
    sku
    taxId
    stockLevels {
      id
      priceWithoutVat
      warehouseId
    }
    tax {
      rate
    }
  }
}
    `;
export type DeliveryListStockCardsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<DeliveryListStockCardsQuery, DeliveryListStockCardsQueryVariables>, 'query'> & ({ variables: DeliveryListStockCardsQueryVariables; skip?: boolean } | { skip: boolean });

export const DeliveryListStockCardsComponent = (props: DeliveryListStockCardsComponentProps) => (
    <ApolloReactComponents.Query<DeliveryListStockCardsQuery, DeliveryListStockCardsQueryVariables> query={DeliveryListStockCardsDocument} {...props} />
);


/**
 * __useDeliveryListStockCardsQuery__
 *
 * To run a query within a React component, call `useDeliveryListStockCardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeliveryListStockCardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeliveryListStockCardsQuery({
 *   variables: {
 *      warehouseIds: // value for 'warehouseIds'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      stockCardCategoryId: // value for 'stockCardCategoryId'
 *      nameOrSku: // value for 'nameOrSku'
 *   },
 * });
 */
export function useDeliveryListStockCardsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DeliveryListStockCardsQuery, DeliveryListStockCardsQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<DeliveryListStockCardsQuery, DeliveryListStockCardsQueryVariables>(DeliveryListStockCardsDocument, options);
}
export function useDeliveryListStockCardsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DeliveryListStockCardsQuery, DeliveryListStockCardsQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<DeliveryListStockCardsQuery, DeliveryListStockCardsQueryVariables>(DeliveryListStockCardsDocument, options);
}
export type DeliveryListStockCardsQueryHookResult = ReturnType<typeof useDeliveryListStockCardsQuery>;
export type DeliveryListStockCardsLazyQueryHookResult = ReturnType<typeof useDeliveryListStockCardsLazyQuery>;
export type DeliveryListStockCardsQueryResult = Apollo.QueryResult<DeliveryListStockCardsQuery, DeliveryListStockCardsQueryVariables>;
export function refetchDeliveryListStockCardsQuery(variables?: DeliveryListStockCardsQueryVariables) {
    return { query: DeliveryListStockCardsDocument, variables };
}
export const DeliveryListSuppliersDocument = gql`
    query DeliveryListSuppliers($offset: Int, $limit: Int, $multiValueSearch: String) {
  suppliers(multiValueSearch: $multiValueSearch, offset: $offset, limit: $limit) {
    id
    legalName
  }
}
    `;
export type DeliveryListSuppliersComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<DeliveryListSuppliersQuery, DeliveryListSuppliersQueryVariables>, 'query'>;

export const DeliveryListSuppliersComponent = (props: DeliveryListSuppliersComponentProps) => (
    <ApolloReactComponents.Query<DeliveryListSuppliersQuery, DeliveryListSuppliersQueryVariables> query={DeliveryListSuppliersDocument} {...props} />
);


/**
 * __useDeliveryListSuppliersQuery__
 *
 * To run a query within a React component, call `useDeliveryListSuppliersQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeliveryListSuppliersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeliveryListSuppliersQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      multiValueSearch: // value for 'multiValueSearch'
 *   },
 * });
 */
export function useDeliveryListSuppliersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<DeliveryListSuppliersQuery, DeliveryListSuppliersQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<DeliveryListSuppliersQuery, DeliveryListSuppliersQueryVariables>(DeliveryListSuppliersDocument, options);
}
export function useDeliveryListSuppliersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DeliveryListSuppliersQuery, DeliveryListSuppliersQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<DeliveryListSuppliersQuery, DeliveryListSuppliersQueryVariables>(DeliveryListSuppliersDocument, options);
}
export type DeliveryListSuppliersQueryHookResult = ReturnType<typeof useDeliveryListSuppliersQuery>;
export type DeliveryListSuppliersLazyQueryHookResult = ReturnType<typeof useDeliveryListSuppliersLazyQuery>;
export type DeliveryListSuppliersQueryResult = Apollo.QueryResult<DeliveryListSuppliersQuery, DeliveryListSuppliersQueryVariables>;
export function refetchDeliveryListSuppliersQuery(variables?: DeliveryListSuppliersQueryVariables) {
    return { query: DeliveryListSuppliersDocument, variables };
}
export const InvoiceStatusUpdatesDocument = gql`
    subscription InvoiceStatusUpdates($warehouseId: ID!) {
  invoiceStatusUpdates(warehouseId: $warehouseId) {
    annotation
    status
  }
}
    `;
export type InvoiceStatusUpdatesComponentProps = Omit<ApolloReactComponents.SubscriptionComponentOptions<InvoiceStatusUpdatesSubscription, InvoiceStatusUpdatesSubscriptionVariables>, 'subscription'>;

export const InvoiceStatusUpdatesComponent = (props: InvoiceStatusUpdatesComponentProps) => (
    <ApolloReactComponents.Subscription<InvoiceStatusUpdatesSubscription, InvoiceStatusUpdatesSubscriptionVariables> subscription={InvoiceStatusUpdatesDocument} {...props} />
);


/**
 * __useInvoiceStatusUpdatesSubscription__
 *
 * To run a query within a React component, call `useInvoiceStatusUpdatesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceStatusUpdatesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceStatusUpdatesSubscription({
 *   variables: {
 *      warehouseId: // value for 'warehouseId'
 *   },
 * });
 */
export function useInvoiceStatusUpdatesSubscription(baseOptions: ApolloReactHooks.SubscriptionHookOptions<InvoiceStatusUpdatesSubscription, InvoiceStatusUpdatesSubscriptionVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useSubscription<InvoiceStatusUpdatesSubscription, InvoiceStatusUpdatesSubscriptionVariables>(InvoiceStatusUpdatesDocument, options);
}
export type InvoiceStatusUpdatesSubscriptionHookResult = ReturnType<typeof useInvoiceStatusUpdatesSubscription>;
export type InvoiceStatusUpdatesSubscriptionResult = Apollo.SubscriptionResult<InvoiceStatusUpdatesSubscription>;
export const CreateDiscountDocument = gql`
    mutation CreateDiscount($rate: Float!, $name: String!, $description: String) {
  createDiscount(data: {rate: $rate, name: $name, description: $description}) {
    id
    rate
    name
    description
  }
}
    `;
export type CreateDiscountMutationFn = Apollo.MutationFunction<CreateDiscountMutation, CreateDiscountMutationVariables>;
export type CreateDiscountComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateDiscountMutation, CreateDiscountMutationVariables>, 'mutation'>;

export const CreateDiscountComponent = (props: CreateDiscountComponentProps) => (
    <ApolloReactComponents.Mutation<CreateDiscountMutation, CreateDiscountMutationVariables> mutation={CreateDiscountDocument} {...props} />
);


/**
 * __useCreateDiscountMutation__
 *
 * To run a mutation, you first call `useCreateDiscountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDiscountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDiscountMutation, { data, loading, error }] = useCreateDiscountMutation({
 *   variables: {
 *      rate: // value for 'rate'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useCreateDiscountMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateDiscountMutation, CreateDiscountMutationVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<CreateDiscountMutation, CreateDiscountMutationVariables>(CreateDiscountDocument, options);
}
export type CreateDiscountMutationHookResult = ReturnType<typeof useCreateDiscountMutation>;
export type CreateDiscountMutationResult = Apollo.MutationResult<CreateDiscountMutation>;
export type CreateDiscountMutationOptions = Apollo.BaseMutationOptions<CreateDiscountMutation, CreateDiscountMutationVariables>;
export const UpdateDiscountDocument = gql`
    mutation UpdateDiscount($id: String!, $rate: Float, $name: String, $description: String) {
  updateDiscount(data: {id: $id, rate: $rate, name: $name, description: $description}) {
    id
    rate
    name
    description
  }
}
    `;
export type UpdateDiscountMutationFn = Apollo.MutationFunction<UpdateDiscountMutation, UpdateDiscountMutationVariables>;
export type UpdateDiscountComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateDiscountMutation, UpdateDiscountMutationVariables>, 'mutation'>;

export const UpdateDiscountComponent = (props: UpdateDiscountComponentProps) => (
    <ApolloReactComponents.Mutation<UpdateDiscountMutation, UpdateDiscountMutationVariables> mutation={UpdateDiscountDocument} {...props} />
);


/**
 * __useUpdateDiscountMutation__
 *
 * To run a mutation, you first call `useUpdateDiscountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDiscountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDiscountMutation, { data, loading, error }] = useUpdateDiscountMutation({
 *   variables: {
 *      id: // value for 'id'
 *      rate: // value for 'rate'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useUpdateDiscountMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateDiscountMutation, UpdateDiscountMutationVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<UpdateDiscountMutation, UpdateDiscountMutationVariables>(UpdateDiscountDocument, options);
}
export type UpdateDiscountMutationHookResult = ReturnType<typeof useUpdateDiscountMutation>;
export type UpdateDiscountMutationResult = Apollo.MutationResult<UpdateDiscountMutation>;
export type UpdateDiscountMutationOptions = Apollo.BaseMutationOptions<UpdateDiscountMutation, UpdateDiscountMutationVariables>;
export const RemoveDiscountDocument = gql`
    mutation RemoveDiscount($id: String!) {
  removeDiscount(id: $id)
}
    `;
export type RemoveDiscountMutationFn = Apollo.MutationFunction<RemoveDiscountMutation, RemoveDiscountMutationVariables>;
export type RemoveDiscountComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<RemoveDiscountMutation, RemoveDiscountMutationVariables>, 'mutation'>;

export const RemoveDiscountComponent = (props: RemoveDiscountComponentProps) => (
    <ApolloReactComponents.Mutation<RemoveDiscountMutation, RemoveDiscountMutationVariables> mutation={RemoveDiscountDocument} {...props} />
);


/**
 * __useRemoveDiscountMutation__
 *
 * To run a mutation, you first call `useRemoveDiscountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveDiscountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeDiscountMutation, { data, loading, error }] = useRemoveDiscountMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveDiscountMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveDiscountMutation, RemoveDiscountMutationVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<RemoveDiscountMutation, RemoveDiscountMutationVariables>(RemoveDiscountDocument, options);
}
export type RemoveDiscountMutationHookResult = ReturnType<typeof useRemoveDiscountMutation>;
export type RemoveDiscountMutationResult = Apollo.MutationResult<RemoveDiscountMutation>;
export type RemoveDiscountMutationOptions = Apollo.BaseMutationOptions<RemoveDiscountMutation, RemoveDiscountMutationVariables>;
export const GetDiscountsDocument = gql`
    query GetDiscounts {
  discounts {
    id
    name
    description
    rate
  }
}
    `;
export type GetDiscountsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetDiscountsQuery, GetDiscountsQueryVariables>, 'query'>;

export const GetDiscountsComponent = (props: GetDiscountsComponentProps) => (
    <ApolloReactComponents.Query<GetDiscountsQuery, GetDiscountsQueryVariables> query={GetDiscountsDocument} {...props} />
);


/**
 * __useGetDiscountsQuery__
 *
 * To run a query within a React component, call `useGetDiscountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDiscountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDiscountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDiscountsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetDiscountsQuery, GetDiscountsQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<GetDiscountsQuery, GetDiscountsQueryVariables>(GetDiscountsDocument, options);
}
export function useGetDiscountsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDiscountsQuery, GetDiscountsQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<GetDiscountsQuery, GetDiscountsQueryVariables>(GetDiscountsDocument, options);
}
export type GetDiscountsQueryHookResult = ReturnType<typeof useGetDiscountsQuery>;
export type GetDiscountsLazyQueryHookResult = ReturnType<typeof useGetDiscountsLazyQuery>;
export type GetDiscountsQueryResult = Apollo.QueryResult<GetDiscountsQuery, GetDiscountsQueryVariables>;
export function refetchGetDiscountsQuery(variables?: GetDiscountsQueryVariables) {
    return { query: GetDiscountsDocument, variables };
}
export const GetDiscountDocument = gql`
    query GetDiscount($id: String!) {
  discount(id: $id) {
    id
    name
    description
    rate
  }
}
    `;
export type GetDiscountComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetDiscountQuery, GetDiscountQueryVariables>, 'query'> & ({ variables: GetDiscountQueryVariables; skip?: boolean } | { skip: boolean });

export const GetDiscountComponent = (props: GetDiscountComponentProps) => (
    <ApolloReactComponents.Query<GetDiscountQuery, GetDiscountQueryVariables> query={GetDiscountDocument} {...props} />
);


/**
 * __useGetDiscountQuery__
 *
 * To run a query within a React component, call `useGetDiscountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDiscountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDiscountQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDiscountQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetDiscountQuery, GetDiscountQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<GetDiscountQuery, GetDiscountQueryVariables>(GetDiscountDocument, options);
}
export function useGetDiscountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDiscountQuery, GetDiscountQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<GetDiscountQuery, GetDiscountQueryVariables>(GetDiscountDocument, options);
}
export type GetDiscountQueryHookResult = ReturnType<typeof useGetDiscountQuery>;
export type GetDiscountLazyQueryHookResult = ReturnType<typeof useGetDiscountLazyQuery>;
export type GetDiscountQueryResult = Apollo.QueryResult<GetDiscountQuery, GetDiscountQueryVariables>;
export function refetchGetDiscountQuery(variables?: GetDiscountQueryVariables) {
    return { query: GetDiscountDocument, variables };
}
export const RegisterEmployeeDocument = gql`
    mutation registerEmployee($venueIds: [ID!]!, $defaultVenueId: ID!, $firstName: String!, $lastName: String!, $email: String!, $pin: String, $password: String!, $imageUrl: String, $role: Role) {
  registerEmployee(data: {venueIds: $venueIds, defaultVenueId: $defaultVenueId, firstName: $firstName, lastName: $lastName, email: $email, pin: $pin, password: $password, imageUrl: $imageUrl, role: $role}) {
    id
    pin
    role
    account {
      id
      firstName
      lastName
      email
    }
    venues {
      id
      name
    }
    currentVenue {
      id
      name
    }
  }
}
    `;
export type RegisterEmployeeMutationFn = Apollo.MutationFunction<RegisterEmployeeMutation, RegisterEmployeeMutationVariables>;
export type RegisterEmployeeComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<RegisterEmployeeMutation, RegisterEmployeeMutationVariables>, 'mutation'>;

export const RegisterEmployeeComponent = (props: RegisterEmployeeComponentProps) => (
    <ApolloReactComponents.Mutation<RegisterEmployeeMutation, RegisterEmployeeMutationVariables> mutation={RegisterEmployeeDocument} {...props} />
);


/**
 * __useRegisterEmployeeMutation__
 *
 * To run a mutation, you first call `useRegisterEmployeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterEmployeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerEmployeeMutation, { data, loading, error }] = useRegisterEmployeeMutation({
 *   variables: {
 *      venueIds: // value for 'venueIds'
 *      defaultVenueId: // value for 'defaultVenueId'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      email: // value for 'email'
 *      pin: // value for 'pin'
 *      password: // value for 'password'
 *      imageUrl: // value for 'imageUrl'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useRegisterEmployeeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RegisterEmployeeMutation, RegisterEmployeeMutationVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<RegisterEmployeeMutation, RegisterEmployeeMutationVariables>(RegisterEmployeeDocument, options);
}
export type RegisterEmployeeMutationHookResult = ReturnType<typeof useRegisterEmployeeMutation>;
export type RegisterEmployeeMutationResult = Apollo.MutationResult<RegisterEmployeeMutation>;
export type RegisterEmployeeMutationOptions = Apollo.BaseMutationOptions<RegisterEmployeeMutation, RegisterEmployeeMutationVariables>;
export const UpdateEmployeeDocument = gql`
    mutation updateEmployee($id: String!, $venueIds: [ID!], $defaultVenueId: ID, $pin: String, $email: String, $password: String, $firstName: String, $lastName: String, $role: Role) {
  updateEmployee(id: $id, data: {pin: $pin, password: $password, firstName: $firstName, lastName: $lastName, email: $email, role: $role, venueIds: $venueIds, defaultVenueId: $defaultVenueId}) {
    id
    pin
    role
    account {
      id
      firstName
      lastName
      email
    }
    venues {
      id
      name
    }
    currentVenue {
      id
      name
    }
  }
}
    `;
export type UpdateEmployeeMutationFn = Apollo.MutationFunction<UpdateEmployeeMutation, UpdateEmployeeMutationVariables>;
export type UpdateEmployeeComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateEmployeeMutation, UpdateEmployeeMutationVariables>, 'mutation'>;

export const UpdateEmployeeComponent = (props: UpdateEmployeeComponentProps) => (
    <ApolloReactComponents.Mutation<UpdateEmployeeMutation, UpdateEmployeeMutationVariables> mutation={UpdateEmployeeDocument} {...props} />
);


/**
 * __useUpdateEmployeeMutation__
 *
 * To run a mutation, you first call `useUpdateEmployeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmployeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmployeeMutation, { data, loading, error }] = useUpdateEmployeeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      venueIds: // value for 'venueIds'
 *      defaultVenueId: // value for 'defaultVenueId'
 *      pin: // value for 'pin'
 *      email: // value for 'email'
 *      password: // value for 'password'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useUpdateEmployeeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateEmployeeMutation, UpdateEmployeeMutationVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<UpdateEmployeeMutation, UpdateEmployeeMutationVariables>(UpdateEmployeeDocument, options);
}
export type UpdateEmployeeMutationHookResult = ReturnType<typeof useUpdateEmployeeMutation>;
export type UpdateEmployeeMutationResult = Apollo.MutationResult<UpdateEmployeeMutation>;
export type UpdateEmployeeMutationOptions = Apollo.BaseMutationOptions<UpdateEmployeeMutation, UpdateEmployeeMutationVariables>;
export const DeleteEmployeeDocument = gql`
    mutation deleteEmployee($id: String!) {
  deleteEmployee(id: $id)
}
    `;
export type DeleteEmployeeMutationFn = Apollo.MutationFunction<DeleteEmployeeMutation, DeleteEmployeeMutationVariables>;
export type DeleteEmployeeComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DeleteEmployeeMutation, DeleteEmployeeMutationVariables>, 'mutation'>;

export const DeleteEmployeeComponent = (props: DeleteEmployeeComponentProps) => (
    <ApolloReactComponents.Mutation<DeleteEmployeeMutation, DeleteEmployeeMutationVariables> mutation={DeleteEmployeeDocument} {...props} />
);


/**
 * __useDeleteEmployeeMutation__
 *
 * To run a mutation, you first call `useDeleteEmployeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEmployeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEmployeeMutation, { data, loading, error }] = useDeleteEmployeeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteEmployeeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteEmployeeMutation, DeleteEmployeeMutationVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<DeleteEmployeeMutation, DeleteEmployeeMutationVariables>(DeleteEmployeeDocument, options);
}
export type DeleteEmployeeMutationHookResult = ReturnType<typeof useDeleteEmployeeMutation>;
export type DeleteEmployeeMutationResult = Apollo.MutationResult<DeleteEmployeeMutation>;
export type DeleteEmployeeMutationOptions = Apollo.BaseMutationOptions<DeleteEmployeeMutation, DeleteEmployeeMutationVariables>;
export const EmployeesDocument = gql`
    query Employees {
  employees {
    id
    pin
    role
    account {
      id
      firstName
      lastName
      email
    }
    venues {
      id
      name
    }
    currentVenue {
      id
      name
    }
  }
}
    `;
export type EmployeesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<EmployeesQuery, EmployeesQueryVariables>, 'query'>;

export const EmployeesComponent = (props: EmployeesComponentProps) => (
    <ApolloReactComponents.Query<EmployeesQuery, EmployeesQueryVariables> query={EmployeesDocument} {...props} />
);


/**
 * __useEmployeesQuery__
 *
 * To run a query within a React component, call `useEmployeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeesQuery({
 *   variables: {
 *   },
 * });
 */
export function useEmployeesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<EmployeesQuery, EmployeesQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<EmployeesQuery, EmployeesQueryVariables>(EmployeesDocument, options);
}
export function useEmployeesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EmployeesQuery, EmployeesQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<EmployeesQuery, EmployeesQueryVariables>(EmployeesDocument, options);
}
export type EmployeesQueryHookResult = ReturnType<typeof useEmployeesQuery>;
export type EmployeesLazyQueryHookResult = ReturnType<typeof useEmployeesLazyQuery>;
export type EmployeesQueryResult = Apollo.QueryResult<EmployeesQuery, EmployeesQueryVariables>;
export function refetchEmployeesQuery(variables?: EmployeesQueryVariables) {
    return { query: EmployeesDocument, variables };
}
export const GetEmployeeDocument = gql`
    query GetEmployee($id: String!) {
  employee(id: $id) {
    id
    pin
    role
    account {
      id
      firstName
      lastName
      email
    }
    venues {
      id
      name
    }
    currentVenue {
      id
      name
    }
  }
  venues {
    ...VenuesFragment
  }
}
    ${VenuesFragmentDoc}`;
export type GetEmployeeComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetEmployeeQuery, GetEmployeeQueryVariables>, 'query'> & ({ variables: GetEmployeeQueryVariables; skip?: boolean } | { skip: boolean });

export const GetEmployeeComponent = (props: GetEmployeeComponentProps) => (
    <ApolloReactComponents.Query<GetEmployeeQuery, GetEmployeeQueryVariables> query={GetEmployeeDocument} {...props} />
);


/**
 * __useGetEmployeeQuery__
 *
 * To run a query within a React component, call `useGetEmployeeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEmployeeQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetEmployeeQuery, GetEmployeeQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<GetEmployeeQuery, GetEmployeeQueryVariables>(GetEmployeeDocument, options);
}
export function useGetEmployeeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEmployeeQuery, GetEmployeeQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<GetEmployeeQuery, GetEmployeeQueryVariables>(GetEmployeeDocument, options);
}
export type GetEmployeeQueryHookResult = ReturnType<typeof useGetEmployeeQuery>;
export type GetEmployeeLazyQueryHookResult = ReturnType<typeof useGetEmployeeLazyQuery>;
export type GetEmployeeQueryResult = Apollo.QueryResult<GetEmployeeQuery, GetEmployeeQueryVariables>;
export function refetchGetEmployeeQuery(variables?: GetEmployeeQueryVariables) {
    return { query: GetEmployeeDocument, variables };
}
export const CreateEmployeeFormQueryDocument = gql`
    query CreateEmployeeFormQuery {
  venues {
    ...VenuesFragment
  }
}
    ${VenuesFragmentDoc}`;
export type CreateEmployeeFormQueryComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<CreateEmployeeFormQuery, CreateEmployeeFormQueryVariables>, 'query'>;

export const CreateEmployeeFormQueryComponent = (props: CreateEmployeeFormQueryComponentProps) => (
    <ApolloReactComponents.Query<CreateEmployeeFormQuery, CreateEmployeeFormQueryVariables> query={CreateEmployeeFormQueryDocument} {...props} />
);


/**
 * __useCreateEmployeeFormQuery__
 *
 * To run a query within a React component, call `useCreateEmployeeFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreateEmployeeFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreateEmployeeFormQuery({
 *   variables: {
 *   },
 * });
 */
export function useCreateEmployeeFormQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CreateEmployeeFormQuery, CreateEmployeeFormQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<CreateEmployeeFormQuery, CreateEmployeeFormQueryVariables>(CreateEmployeeFormQueryDocument, options);
}
export function useCreateEmployeeFormQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CreateEmployeeFormQuery, CreateEmployeeFormQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<CreateEmployeeFormQuery, CreateEmployeeFormQueryVariables>(CreateEmployeeFormQueryDocument, options);
}
export type CreateEmployeeFormQueryHookResult = ReturnType<typeof useCreateEmployeeFormQuery>;
export type CreateEmployeeFormQueryLazyQueryHookResult = ReturnType<typeof useCreateEmployeeFormQueryLazyQuery>;
export type CreateEmployeeFormQueryQueryResult = Apollo.QueryResult<CreateEmployeeFormQuery, CreateEmployeeFormQueryVariables>;
export function refetchCreateEmployeeFormQuery(variables?: CreateEmployeeFormQueryVariables) {
    return { query: CreateEmployeeFormQueryDocument, variables };
}
export const LoginEmployeeDocument = gql`
    mutation LoginEmployee($email: String!, $password: String!) {
  loginEmployee(data: {email: $email, password: $password})
}
    `;
export type LoginEmployeeMutationFn = Apollo.MutationFunction<LoginEmployeeMutation, LoginEmployeeMutationVariables>;
export type LoginEmployeeComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<LoginEmployeeMutation, LoginEmployeeMutationVariables>, 'mutation'>;

export const LoginEmployeeComponent = (props: LoginEmployeeComponentProps) => (
    <ApolloReactComponents.Mutation<LoginEmployeeMutation, LoginEmployeeMutationVariables> mutation={LoginEmployeeDocument} {...props} />
);


/**
 * __useLoginEmployeeMutation__
 *
 * To run a mutation, you first call `useLoginEmployeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginEmployeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginEmployeeMutation, { data, loading, error }] = useLoginEmployeeMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useLoginEmployeeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<LoginEmployeeMutation, LoginEmployeeMutationVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<LoginEmployeeMutation, LoginEmployeeMutationVariables>(LoginEmployeeDocument, options);
}
export type LoginEmployeeMutationHookResult = ReturnType<typeof useLoginEmployeeMutation>;
export type LoginEmployeeMutationResult = Apollo.MutationResult<LoginEmployeeMutation>;
export type LoginEmployeeMutationOptions = Apollo.BaseMutationOptions<LoginEmployeeMutation, LoginEmployeeMutationVariables>;
export const GetAccountsDocument = gql`
    query GetAccounts {
  accounts {
    id
    firstName
    lastName
    email
  }
}
    `;
export type GetAccountsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetAccountsQuery, GetAccountsQueryVariables>, 'query'>;

export const GetAccountsComponent = (props: GetAccountsComponentProps) => (
    <ApolloReactComponents.Query<GetAccountsQuery, GetAccountsQueryVariables> query={GetAccountsDocument} {...props} />
);


/**
 * __useGetAccountsQuery__
 *
 * To run a query within a React component, call `useGetAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAccountsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAccountsQuery, GetAccountsQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<GetAccountsQuery, GetAccountsQueryVariables>(GetAccountsDocument, options);
}
export function useGetAccountsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAccountsQuery, GetAccountsQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<GetAccountsQuery, GetAccountsQueryVariables>(GetAccountsDocument, options);
}
export type GetAccountsQueryHookResult = ReturnType<typeof useGetAccountsQuery>;
export type GetAccountsLazyQueryHookResult = ReturnType<typeof useGetAccountsLazyQuery>;
export type GetAccountsQueryResult = Apollo.QueryResult<GetAccountsQuery, GetAccountsQueryVariables>;
export function refetchGetAccountsQuery(variables?: GetAccountsQueryVariables) {
    return { query: GetAccountsDocument, variables };
}
export const GetAccountDocument = gql`
    query GetAccount($id: String!) {
  account(id: $id) {
    id
    firstName
    lastName
    email
  }
}
    `;
export type GetAccountComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetAccountQuery, GetAccountQueryVariables>, 'query'> & ({ variables: GetAccountQueryVariables; skip?: boolean } | { skip: boolean });

export const GetAccountComponent = (props: GetAccountComponentProps) => (
    <ApolloReactComponents.Query<GetAccountQuery, GetAccountQueryVariables> query={GetAccountDocument} {...props} />
);


/**
 * __useGetAccountQuery__
 *
 * To run a query within a React component, call `useGetAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAccountQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetAccountQuery, GetAccountQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<GetAccountQuery, GetAccountQueryVariables>(GetAccountDocument, options);
}
export function useGetAccountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAccountQuery, GetAccountQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<GetAccountQuery, GetAccountQueryVariables>(GetAccountDocument, options);
}
export type GetAccountQueryHookResult = ReturnType<typeof useGetAccountQuery>;
export type GetAccountLazyQueryHookResult = ReturnType<typeof useGetAccountLazyQuery>;
export type GetAccountQueryResult = Apollo.QueryResult<GetAccountQuery, GetAccountQueryVariables>;
export function refetchGetAccountQuery(variables?: GetAccountQueryVariables) {
    return { query: GetAccountDocument, variables };
}
export const OrdersDocument = gql`
    query Orders($offset: Int, $limit: Int, $filters: OrderFilters) {
  orders(offset: $offset, limit: $limit, filters: $filters) {
    id
    createdUtc
    orderState
    name
    orderNumber
    bills {
      id
      billState
      total
      total
      dicountedTotalValue
      roundedPrice
    }
    openedBy {
      account {
        id
        firstName
        lastName
        imageUrl
      }
    }
    orderLines {
      id
      price
      orderLineState
      billId
      tax {
        id
        rate
      }
      quantity
      product {
        id
        name
        priceSell
        tax {
          id
          rate
        }
      }
    }
    place {
      id
      name
    }
  }
}
    `;
export type OrdersComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<OrdersQuery, OrdersQueryVariables>, 'query'>;

export const OrdersComponent = (props: OrdersComponentProps) => (
    <ApolloReactComponents.Query<OrdersQuery, OrdersQueryVariables> query={OrdersDocument} {...props} />
);


/**
 * __useOrdersQuery__
 *
 * To run a query within a React component, call `useOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrdersQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useOrdersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<OrdersQuery, OrdersQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<OrdersQuery, OrdersQueryVariables>(OrdersDocument, options);
}
export function useOrdersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrdersQuery, OrdersQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<OrdersQuery, OrdersQueryVariables>(OrdersDocument, options);
}
export type OrdersQueryHookResult = ReturnType<typeof useOrdersQuery>;
export type OrdersLazyQueryHookResult = ReturnType<typeof useOrdersLazyQuery>;
export type OrdersQueryResult = Apollo.QueryResult<OrdersQuery, OrdersQueryVariables>;
export function refetchOrdersQuery(variables?: OrdersQueryVariables) {
    return { query: OrdersDocument, variables };
}
export const OrderDocument = gql`
    query Order($id: String!) {
  order(id: $id) {
    id
    createdUtc
    orderState
    name
    orderNumber
    openedBy {
      account {
        id
        firstName
        lastName
        imageUrl
      }
    }
    closedBy {
      account {
        id
        firstName
        lastName
        imageUrl
      }
    }
    orderLines {
      id
      price
      unitPrice
      quantity
      discountedPrice
      discountedUnitPrice
      orderLineState
      tax {
        id
        rate
      }
      product {
        id
        name
        tax {
          id
          rate
        }
      }
      billId
    }
    bills {
      id
      issuedUtc
      billNumber
      total
      dicountedTotalValue
      roundedPrice
      billState
    }
    place {
      id
      name
    }
  }
}
    `;
export type OrderComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<OrderQuery, OrderQueryVariables>, 'query'> & ({ variables: OrderQueryVariables; skip?: boolean } | { skip: boolean });

export const OrderComponent = (props: OrderComponentProps) => (
    <ApolloReactComponents.Query<OrderQuery, OrderQueryVariables> query={OrderDocument} {...props} />
);


/**
 * __useOrderQuery__
 *
 * To run a query within a React component, call `useOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOrderQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OrderQuery, OrderQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<OrderQuery, OrderQueryVariables>(OrderDocument, options);
}
export function useOrderLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrderQuery, OrderQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<OrderQuery, OrderQueryVariables>(OrderDocument, options);
}
export type OrderQueryHookResult = ReturnType<typeof useOrderQuery>;
export type OrderLazyQueryHookResult = ReturnType<typeof useOrderLazyQuery>;
export type OrderQueryResult = Apollo.QueryResult<OrderQuery, OrderQueryVariables>;
export function refetchOrderQuery(variables?: OrderQueryVariables) {
    return { query: OrderDocument, variables };
}
export const GetOrderFiltersOptionsDocument = gql`
    query GetOrderFiltersOptions {
  sections {
    ...SectionsOptionFragment
  }
  employees {
    ...EmployeeOptionFragment
  }
}
    ${SectionsOptionFragmentDoc}
${EmployeeOptionFragmentDoc}`;
export type GetOrderFiltersOptionsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetOrderFiltersOptionsQuery, GetOrderFiltersOptionsQueryVariables>, 'query'>;

export const GetOrderFiltersOptionsComponent = (props: GetOrderFiltersOptionsComponentProps) => (
    <ApolloReactComponents.Query<GetOrderFiltersOptionsQuery, GetOrderFiltersOptionsQueryVariables> query={GetOrderFiltersOptionsDocument} {...props} />
);


/**
 * __useGetOrderFiltersOptionsQuery__
 *
 * To run a query within a React component, call `useGetOrderFiltersOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderFiltersOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderFiltersOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOrderFiltersOptionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetOrderFiltersOptionsQuery, GetOrderFiltersOptionsQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<GetOrderFiltersOptionsQuery, GetOrderFiltersOptionsQueryVariables>(GetOrderFiltersOptionsDocument, options);
}
export function useGetOrderFiltersOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetOrderFiltersOptionsQuery, GetOrderFiltersOptionsQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<GetOrderFiltersOptionsQuery, GetOrderFiltersOptionsQueryVariables>(GetOrderFiltersOptionsDocument, options);
}
export type GetOrderFiltersOptionsQueryHookResult = ReturnType<typeof useGetOrderFiltersOptionsQuery>;
export type GetOrderFiltersOptionsLazyQueryHookResult = ReturnType<typeof useGetOrderFiltersOptionsLazyQuery>;
export type GetOrderFiltersOptionsQueryResult = Apollo.QueryResult<GetOrderFiltersOptionsQuery, GetOrderFiltersOptionsQueryVariables>;
export function refetchGetOrderFiltersOptionsQuery(variables?: GetOrderFiltersOptionsQueryVariables) {
    return { query: GetOrderFiltersOptionsDocument, variables };
}
export const TimelineDocument = gql`
    query Timeline($orderId: String!) {
  timeline(orderId: $orderId)
}
    `;
export type TimelineComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<TimelineQuery, TimelineQueryVariables>, 'query'> & ({ variables: TimelineQueryVariables; skip?: boolean } | { skip: boolean });

export const TimelineComponent = (props: TimelineComponentProps) => (
    <ApolloReactComponents.Query<TimelineQuery, TimelineQueryVariables> query={TimelineDocument} {...props} />
);


/**
 * __useTimelineQuery__
 *
 * To run a query within a React component, call `useTimelineQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimelineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimelineQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useTimelineQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TimelineQuery, TimelineQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<TimelineQuery, TimelineQueryVariables>(TimelineDocument, options);
}
export function useTimelineLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TimelineQuery, TimelineQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<TimelineQuery, TimelineQueryVariables>(TimelineDocument, options);
}
export type TimelineQueryHookResult = ReturnType<typeof useTimelineQuery>;
export type TimelineLazyQueryHookResult = ReturnType<typeof useTimelineLazyQuery>;
export type TimelineQueryResult = Apollo.QueryResult<TimelineQuery, TimelineQueryVariables>;
export function refetchTimelineQuery(variables?: TimelineQueryVariables) {
    return { query: TimelineDocument, variables };
}
export const RemoveProductDocument = gql`
    mutation removeProduct($id: String!) {
  removeProduct(id: $id)
}
    `;
export type RemoveProductMutationFn = Apollo.MutationFunction<RemoveProductMutation, RemoveProductMutationVariables>;
export type RemoveProductComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<RemoveProductMutation, RemoveProductMutationVariables>, 'mutation'>;

export const RemoveProductComponent = (props: RemoveProductComponentProps) => (
    <ApolloReactComponents.Mutation<RemoveProductMutation, RemoveProductMutationVariables> mutation={RemoveProductDocument} {...props} />
);


/**
 * __useRemoveProductMutation__
 *
 * To run a mutation, you first call `useRemoveProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeProductMutation, { data, loading, error }] = useRemoveProductMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveProductMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveProductMutation, RemoveProductMutationVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<RemoveProductMutation, RemoveProductMutationVariables>(RemoveProductDocument, options);
}
export type RemoveProductMutationHookResult = ReturnType<typeof useRemoveProductMutation>;
export type RemoveProductMutationResult = Apollo.MutationResult<RemoveProductMutation>;
export type RemoveProductMutationOptions = Apollo.BaseMutationOptions<RemoveProductMutation, RemoveProductMutationVariables>;
export const CreateProductAndRecipeDocument = gql`
    mutation CreateProductAndRecipe($product: ProductCreate!, $recipe: RecipeCreateWithProduct) {
  createProductAndRecipe(product: $product, recipe: $recipe) {
    id
    name
    priceSell
    priceBuy
    showInPos
    priceBuyCurrency {
      currencyCode
    }
    pohodaStockItemId
    categoryId
    taxId
    toGoTaxId
    printingDevices {
      id
      name
      customName
    }
  }
}
    `;
export type CreateProductAndRecipeMutationFn = Apollo.MutationFunction<CreateProductAndRecipeMutation, CreateProductAndRecipeMutationVariables>;
export type CreateProductAndRecipeComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateProductAndRecipeMutation, CreateProductAndRecipeMutationVariables>, 'mutation'>;

export const CreateProductAndRecipeComponent = (props: CreateProductAndRecipeComponentProps) => (
    <ApolloReactComponents.Mutation<CreateProductAndRecipeMutation, CreateProductAndRecipeMutationVariables> mutation={CreateProductAndRecipeDocument} {...props} />
);


/**
 * __useCreateProductAndRecipeMutation__
 *
 * To run a mutation, you first call `useCreateProductAndRecipeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProductAndRecipeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProductAndRecipeMutation, { data, loading, error }] = useCreateProductAndRecipeMutation({
 *   variables: {
 *      product: // value for 'product'
 *      recipe: // value for 'recipe'
 *   },
 * });
 */
export function useCreateProductAndRecipeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateProductAndRecipeMutation, CreateProductAndRecipeMutationVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<CreateProductAndRecipeMutation, CreateProductAndRecipeMutationVariables>(CreateProductAndRecipeDocument, options);
}
export type CreateProductAndRecipeMutationHookResult = ReturnType<typeof useCreateProductAndRecipeMutation>;
export type CreateProductAndRecipeMutationResult = Apollo.MutationResult<CreateProductAndRecipeMutation>;
export type CreateProductAndRecipeMutationOptions = Apollo.BaseMutationOptions<CreateProductAndRecipeMutation, CreateProductAndRecipeMutationVariables>;
export const UpdateProductAndRecipeDocument = gql`
    mutation UpdateProductAndRecipe($id: String!, $product: ProductUpdate!, $recipe: RecipeUpdateWithProduct) {
  updateProductAndRecipe(id: $id, product: $product, recipe: $recipe) {
    id
    name
    priceSell
    priceBuy
    showInPos
    priceBuyCurrency {
      currencyCode
    }
    pohodaStockItemId
    categoryId
    taxId
    toGoTaxId
    printingDevices {
      id
      name
      customName
    }
  }
}
    `;
export type UpdateProductAndRecipeMutationFn = Apollo.MutationFunction<UpdateProductAndRecipeMutation, UpdateProductAndRecipeMutationVariables>;
export type UpdateProductAndRecipeComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateProductAndRecipeMutation, UpdateProductAndRecipeMutationVariables>, 'mutation'>;

export const UpdateProductAndRecipeComponent = (props: UpdateProductAndRecipeComponentProps) => (
    <ApolloReactComponents.Mutation<UpdateProductAndRecipeMutation, UpdateProductAndRecipeMutationVariables> mutation={UpdateProductAndRecipeDocument} {...props} />
);


/**
 * __useUpdateProductAndRecipeMutation__
 *
 * To run a mutation, you first call `useUpdateProductAndRecipeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductAndRecipeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductAndRecipeMutation, { data, loading, error }] = useUpdateProductAndRecipeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      product: // value for 'product'
 *      recipe: // value for 'recipe'
 *   },
 * });
 */
export function useUpdateProductAndRecipeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateProductAndRecipeMutation, UpdateProductAndRecipeMutationVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<UpdateProductAndRecipeMutation, UpdateProductAndRecipeMutationVariables>(UpdateProductAndRecipeDocument, options);
}
export type UpdateProductAndRecipeMutationHookResult = ReturnType<typeof useUpdateProductAndRecipeMutation>;
export type UpdateProductAndRecipeMutationResult = Apollo.MutationResult<UpdateProductAndRecipeMutation>;
export type UpdateProductAndRecipeMutationOptions = Apollo.BaseMutationOptions<UpdateProductAndRecipeMutation, UpdateProductAndRecipeMutationVariables>;
export const GetPaginatedProductsDocument = gql`
    query GetPaginatedProducts($pagination: Pagination, $name: String, $categories: [ID!], $markupSort: SortOrder, $foodCostSort: SortOrder) {
  paginatedProducts(pagination: $pagination, name: $name, categories: $categories, markupSort: $markupSort, foodCostSort: $foodCostSort) @connection(key: "paginatedProducts", filter: ["categories", "name", "markupSort", "foodCostSort"]) {
    items {
      id
      name
      priceSell
      pohodaStockItemId
      markup
      foodCost
      tax {
        id
        rate
      }
      category {
        id
        name
        categoryId
      }
    }
    count
  }
  taxes {
    ...TaxesFragment
  }
}
    ${TaxesFragmentDoc}`;
export type GetPaginatedProductsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetPaginatedProductsQuery, GetPaginatedProductsQueryVariables>, 'query'>;

export const GetPaginatedProductsComponent = (props: GetPaginatedProductsComponentProps) => (
    <ApolloReactComponents.Query<GetPaginatedProductsQuery, GetPaginatedProductsQueryVariables> query={GetPaginatedProductsDocument} {...props} />
);


/**
 * __useGetPaginatedProductsQuery__
 *
 * To run a query within a React component, call `useGetPaginatedProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaginatedProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaginatedProductsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      name: // value for 'name'
 *      categories: // value for 'categories'
 *      markupSort: // value for 'markupSort'
 *      foodCostSort: // value for 'foodCostSort'
 *   },
 * });
 */
export function useGetPaginatedProductsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPaginatedProductsQuery, GetPaginatedProductsQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<GetPaginatedProductsQuery, GetPaginatedProductsQueryVariables>(GetPaginatedProductsDocument, options);
}
export function useGetPaginatedProductsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPaginatedProductsQuery, GetPaginatedProductsQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<GetPaginatedProductsQuery, GetPaginatedProductsQueryVariables>(GetPaginatedProductsDocument, options);
}
export type GetPaginatedProductsQueryHookResult = ReturnType<typeof useGetPaginatedProductsQuery>;
export type GetPaginatedProductsLazyQueryHookResult = ReturnType<typeof useGetPaginatedProductsLazyQuery>;
export type GetPaginatedProductsQueryResult = Apollo.QueryResult<GetPaginatedProductsQuery, GetPaginatedProductsQueryVariables>;
export function refetchGetPaginatedProductsQuery(variables?: GetPaginatedProductsQueryVariables) {
    return { query: GetPaginatedProductsDocument, variables };
}
export const GetProductDocument = gql`
    query GetProduct($id: String!) {
  product(id: $id) {
    id
    name
    priceSell
    priceBuy
    showInPos
    description
    priceBuyCurrency {
      currencyCode
    }
    pohodaStockItemId
    categoryId
    taxId
    toGoTaxId
    printingDevices {
      id
      name
      customName
    }
    connectedStockCard {
      id
      warehouseId
      stockCardId
      stockCard {
        id
        name
        storageUnit
        conversionUnit
        warehouses {
          id
          name
        }
      }
    }
    recipe {
      id
      recipeLines {
        id
        warehouseId
        unitType
        waste
        quantity
        stockCard {
          id
          name
          storageUnit
          conversionUnit
          warehouses {
            id
            name
          }
        }
      }
    }
  }
  categories {
    ...CategoriesFragment
    categoryId
    color
  }
  taxes {
    ...TaxesFragment
  }
  warehouses {
    ...WarehousesFragment
  }
  devices {
    id
    name
    customName
  }
}
    ${CategoriesFragmentDoc}
${TaxesFragmentDoc}
${WarehousesFragmentDoc}`;
export type GetProductComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetProductQuery, GetProductQueryVariables>, 'query'> & ({ variables: GetProductQueryVariables; skip?: boolean } | { skip: boolean });

export const GetProductComponent = (props: GetProductComponentProps) => (
    <ApolloReactComponents.Query<GetProductQuery, GetProductQueryVariables> query={GetProductDocument} {...props} />
);


/**
 * __useGetProductQuery__
 *
 * To run a query within a React component, call `useGetProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProductQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetProductQuery, GetProductQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<GetProductQuery, GetProductQueryVariables>(GetProductDocument, options);
}
export function useGetProductLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetProductQuery, GetProductQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<GetProductQuery, GetProductQueryVariables>(GetProductDocument, options);
}
export type GetProductQueryHookResult = ReturnType<typeof useGetProductQuery>;
export type GetProductLazyQueryHookResult = ReturnType<typeof useGetProductLazyQuery>;
export type GetProductQueryResult = Apollo.QueryResult<GetProductQuery, GetProductQueryVariables>;
export function refetchGetProductQuery(variables?: GetProductQueryVariables) {
    return { query: GetProductDocument, variables };
}
export const ProductFormQueryDocument = gql`
    query ProductFormQuery {
  categories {
    ...CategoriesFragment
    categoryId
    color
  }
  taxes {
    ...TaxesFragment
  }
  devices {
    id
    name
    customName
  }
  warehouses {
    ...WarehousesFragment
  }
}
    ${CategoriesFragmentDoc}
${TaxesFragmentDoc}
${WarehousesFragmentDoc}`;
export type ProductFormQueryComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ProductFormQuery, ProductFormQueryVariables>, 'query'>;

export const ProductFormQueryComponent = (props: ProductFormQueryComponentProps) => (
    <ApolloReactComponents.Query<ProductFormQuery, ProductFormQueryVariables> query={ProductFormQueryDocument} {...props} />
);


/**
 * __useProductFormQuery__
 *
 * To run a query within a React component, call `useProductFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductFormQuery({
 *   variables: {
 *   },
 * });
 */
export function useProductFormQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ProductFormQuery, ProductFormQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<ProductFormQuery, ProductFormQueryVariables>(ProductFormQueryDocument, options);
}
export function useProductFormQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProductFormQuery, ProductFormQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<ProductFormQuery, ProductFormQueryVariables>(ProductFormQueryDocument, options);
}
export type ProductFormQueryHookResult = ReturnType<typeof useProductFormQuery>;
export type ProductFormQueryLazyQueryHookResult = ReturnType<typeof useProductFormQueryLazyQuery>;
export type ProductFormQueryQueryResult = Apollo.QueryResult<ProductFormQuery, ProductFormQueryVariables>;
export function refetchProductFormQuery(variables?: ProductFormQueryVariables) {
    return { query: ProductFormQueryDocument, variables };
}
export const Get_Category_OptionsDocument = gql`
    query GET_CATEGORY_OPTIONS {
  categories {
    ...CategoriesFragment
  }
}
    ${CategoriesFragmentDoc}`;
export type Get_Category_OptionsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Get_Category_OptionsQuery, Get_Category_OptionsQueryVariables>, 'query'>;

export const Get_Category_OptionsComponent = (props: Get_Category_OptionsComponentProps) => (
    <ApolloReactComponents.Query<Get_Category_OptionsQuery, Get_Category_OptionsQueryVariables> query={Get_Category_OptionsDocument} {...props} />
);


/**
 * __useGet_Category_OptionsQuery__
 *
 * To run a query within a React component, call `useGet_Category_OptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGet_Category_OptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGet_Category_OptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGet_Category_OptionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Get_Category_OptionsQuery, Get_Category_OptionsQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<Get_Category_OptionsQuery, Get_Category_OptionsQueryVariables>(Get_Category_OptionsDocument, options);
}
export function useGet_Category_OptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Get_Category_OptionsQuery, Get_Category_OptionsQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<Get_Category_OptionsQuery, Get_Category_OptionsQueryVariables>(Get_Category_OptionsDocument, options);
}
export type Get_Category_OptionsQueryHookResult = ReturnType<typeof useGet_Category_OptionsQuery>;
export type Get_Category_OptionsLazyQueryHookResult = ReturnType<typeof useGet_Category_OptionsLazyQuery>;
export type Get_Category_OptionsQueryResult = Apollo.QueryResult<Get_Category_OptionsQuery, Get_Category_OptionsQueryVariables>;
export function refetchGet_Category_OptionsQuery(variables?: Get_Category_OptionsQueryVariables) {
    return { query: Get_Category_OptionsDocument, variables };
}
export const GetCategoryDocument = gql`
    query GetCategory($id: String!) {
  category(id: $id) {
    id
    name
  }
}
    `;
export type GetCategoryComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetCategoryQuery, GetCategoryQueryVariables>, 'query'> & ({ variables: GetCategoryQueryVariables; skip?: boolean } | { skip: boolean });

export const GetCategoryComponent = (props: GetCategoryComponentProps) => (
    <ApolloReactComponents.Query<GetCategoryQuery, GetCategoryQueryVariables> query={GetCategoryDocument} {...props} />
);


/**
 * __useGetCategoryQuery__
 *
 * To run a query within a React component, call `useGetCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategoryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCategoryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetCategoryQuery, GetCategoryQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<GetCategoryQuery, GetCategoryQueryVariables>(GetCategoryDocument, options);
}
export function useGetCategoryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCategoryQuery, GetCategoryQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<GetCategoryQuery, GetCategoryQueryVariables>(GetCategoryDocument, options);
}
export type GetCategoryQueryHookResult = ReturnType<typeof useGetCategoryQuery>;
export type GetCategoryLazyQueryHookResult = ReturnType<typeof useGetCategoryLazyQuery>;
export type GetCategoryQueryResult = Apollo.QueryResult<GetCategoryQuery, GetCategoryQueryVariables>;
export function refetchGetCategoryQuery(variables?: GetCategoryQueryVariables) {
    return { query: GetCategoryDocument, variables };
}
export const GetExpensesDocument = gql`
    query getExpenses($from: Date!, $to: Date!) {
  productCosts(from: $from, to: $to) {
    withoutVat
    withVat
  }
  deductionAmounts(from: $from, to: $to) {
    withoutVat {
      waste
      writeOff
      total
    }
    withVat {
      waste
      writeOff
      total
    }
  }
  currentVenueInventoryCounts(from: $from, to: $to) {
    id
    endDate
    deltas {
      withVat
      withoutVat
    }
  }
}
    `;
export type GetExpensesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetExpensesQuery, GetExpensesQueryVariables>, 'query'> & ({ variables: GetExpensesQueryVariables; skip?: boolean } | { skip: boolean });

export const GetExpensesComponent = (props: GetExpensesComponentProps) => (
    <ApolloReactComponents.Query<GetExpensesQuery, GetExpensesQueryVariables> query={GetExpensesDocument} {...props} />
);


/**
 * __useGetExpensesQuery__
 *
 * To run a query within a React component, call `useGetExpensesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExpensesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExpensesQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useGetExpensesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetExpensesQuery, GetExpensesQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<GetExpensesQuery, GetExpensesQueryVariables>(GetExpensesDocument, options);
}
export function useGetExpensesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetExpensesQuery, GetExpensesQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<GetExpensesQuery, GetExpensesQueryVariables>(GetExpensesDocument, options);
}
export type GetExpensesQueryHookResult = ReturnType<typeof useGetExpensesQuery>;
export type GetExpensesLazyQueryHookResult = ReturnType<typeof useGetExpensesLazyQuery>;
export type GetExpensesQueryResult = Apollo.QueryResult<GetExpensesQuery, GetExpensesQueryVariables>;
export function refetchGetExpensesQuery(variables?: GetExpensesQueryVariables) {
    return { query: GetExpensesDocument, variables };
}
export const CreateCustomPaymentMethodDocument = gql`
    mutation CreateCustomPaymentMethod($data: CreateCustomPaymentMethodInput!) {
  createCustomPaymentMethod(data: $data) {
    id
    name
    isActive
  }
}
    `;
export type CreateCustomPaymentMethodMutationFn = Apollo.MutationFunction<CreateCustomPaymentMethodMutation, CreateCustomPaymentMethodMutationVariables>;
export type CreateCustomPaymentMethodComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateCustomPaymentMethodMutation, CreateCustomPaymentMethodMutationVariables>, 'mutation'>;

export const CreateCustomPaymentMethodComponent = (props: CreateCustomPaymentMethodComponentProps) => (
    <ApolloReactComponents.Mutation<CreateCustomPaymentMethodMutation, CreateCustomPaymentMethodMutationVariables> mutation={CreateCustomPaymentMethodDocument} {...props} />
);


/**
 * __useCreateCustomPaymentMethodMutation__
 *
 * To run a mutation, you first call `useCreateCustomPaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomPaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomPaymentMethodMutation, { data, loading, error }] = useCreateCustomPaymentMethodMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateCustomPaymentMethodMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateCustomPaymentMethodMutation, CreateCustomPaymentMethodMutationVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<CreateCustomPaymentMethodMutation, CreateCustomPaymentMethodMutationVariables>(CreateCustomPaymentMethodDocument, options);
}
export type CreateCustomPaymentMethodMutationHookResult = ReturnType<typeof useCreateCustomPaymentMethodMutation>;
export type CreateCustomPaymentMethodMutationResult = Apollo.MutationResult<CreateCustomPaymentMethodMutation>;
export type CreateCustomPaymentMethodMutationOptions = Apollo.BaseMutationOptions<CreateCustomPaymentMethodMutation, CreateCustomPaymentMethodMutationVariables>;
export const UpdateCustomPaymentMethodDocument = gql`
    mutation UpdateCustomPaymentMethod($id: ID!, $data: UpdateCustomPaymentMethodInput!) {
  updateCustomPaymentMethod(id: $id, data: $data) {
    id
    name
    isActive
  }
}
    `;
export type UpdateCustomPaymentMethodMutationFn = Apollo.MutationFunction<UpdateCustomPaymentMethodMutation, UpdateCustomPaymentMethodMutationVariables>;
export type UpdateCustomPaymentMethodComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateCustomPaymentMethodMutation, UpdateCustomPaymentMethodMutationVariables>, 'mutation'>;

export const UpdateCustomPaymentMethodComponent = (props: UpdateCustomPaymentMethodComponentProps) => (
    <ApolloReactComponents.Mutation<UpdateCustomPaymentMethodMutation, UpdateCustomPaymentMethodMutationVariables> mutation={UpdateCustomPaymentMethodDocument} {...props} />
);


/**
 * __useUpdateCustomPaymentMethodMutation__
 *
 * To run a mutation, you first call `useUpdateCustomPaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomPaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomPaymentMethodMutation, { data, loading, error }] = useUpdateCustomPaymentMethodMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateCustomPaymentMethodMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateCustomPaymentMethodMutation, UpdateCustomPaymentMethodMutationVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<UpdateCustomPaymentMethodMutation, UpdateCustomPaymentMethodMutationVariables>(UpdateCustomPaymentMethodDocument, options);
}
export type UpdateCustomPaymentMethodMutationHookResult = ReturnType<typeof useUpdateCustomPaymentMethodMutation>;
export type UpdateCustomPaymentMethodMutationResult = Apollo.MutationResult<UpdateCustomPaymentMethodMutation>;
export type UpdateCustomPaymentMethodMutationOptions = Apollo.BaseMutationOptions<UpdateCustomPaymentMethodMutation, UpdateCustomPaymentMethodMutationVariables>;
export const RemoveCustomPaymentMethodDocument = gql`
    mutation RemoveCustomPaymentMethod($id: ID!) {
  removeCustomPaymentMethod(id: $id)
}
    `;
export type RemoveCustomPaymentMethodMutationFn = Apollo.MutationFunction<RemoveCustomPaymentMethodMutation, RemoveCustomPaymentMethodMutationVariables>;
export type RemoveCustomPaymentMethodComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<RemoveCustomPaymentMethodMutation, RemoveCustomPaymentMethodMutationVariables>, 'mutation'>;

export const RemoveCustomPaymentMethodComponent = (props: RemoveCustomPaymentMethodComponentProps) => (
    <ApolloReactComponents.Mutation<RemoveCustomPaymentMethodMutation, RemoveCustomPaymentMethodMutationVariables> mutation={RemoveCustomPaymentMethodDocument} {...props} />
);


/**
 * __useRemoveCustomPaymentMethodMutation__
 *
 * To run a mutation, you first call `useRemoveCustomPaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCustomPaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCustomPaymentMethodMutation, { data, loading, error }] = useRemoveCustomPaymentMethodMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveCustomPaymentMethodMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveCustomPaymentMethodMutation, RemoveCustomPaymentMethodMutationVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<RemoveCustomPaymentMethodMutation, RemoveCustomPaymentMethodMutationVariables>(RemoveCustomPaymentMethodDocument, options);
}
export type RemoveCustomPaymentMethodMutationHookResult = ReturnType<typeof useRemoveCustomPaymentMethodMutation>;
export type RemoveCustomPaymentMethodMutationResult = Apollo.MutationResult<RemoveCustomPaymentMethodMutation>;
export type RemoveCustomPaymentMethodMutationOptions = Apollo.BaseMutationOptions<RemoveCustomPaymentMethodMutation, RemoveCustomPaymentMethodMutationVariables>;
export const GetCurrentVenueCustomPaymentMethodsDocument = gql`
    query GetCurrentVenueCustomPaymentMethods($onlyActive: Boolean) {
  currentVenueCustomPaymentMethods(onlyActive: $onlyActive) {
    id
    name
    isActive
    paymentIntegrationId
  }
}
    `;
export type GetCurrentVenueCustomPaymentMethodsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetCurrentVenueCustomPaymentMethodsQuery, GetCurrentVenueCustomPaymentMethodsQueryVariables>, 'query'>;

export const GetCurrentVenueCustomPaymentMethodsComponent = (props: GetCurrentVenueCustomPaymentMethodsComponentProps) => (
    <ApolloReactComponents.Query<GetCurrentVenueCustomPaymentMethodsQuery, GetCurrentVenueCustomPaymentMethodsQueryVariables> query={GetCurrentVenueCustomPaymentMethodsDocument} {...props} />
);


/**
 * __useGetCurrentVenueCustomPaymentMethodsQuery__
 *
 * To run a query within a React component, call `useGetCurrentVenueCustomPaymentMethodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentVenueCustomPaymentMethodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentVenueCustomPaymentMethodsQuery({
 *   variables: {
 *      onlyActive: // value for 'onlyActive'
 *   },
 * });
 */
export function useGetCurrentVenueCustomPaymentMethodsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCurrentVenueCustomPaymentMethodsQuery, GetCurrentVenueCustomPaymentMethodsQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<GetCurrentVenueCustomPaymentMethodsQuery, GetCurrentVenueCustomPaymentMethodsQueryVariables>(GetCurrentVenueCustomPaymentMethodsDocument, options);
}
export function useGetCurrentVenueCustomPaymentMethodsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCurrentVenueCustomPaymentMethodsQuery, GetCurrentVenueCustomPaymentMethodsQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<GetCurrentVenueCustomPaymentMethodsQuery, GetCurrentVenueCustomPaymentMethodsQueryVariables>(GetCurrentVenueCustomPaymentMethodsDocument, options);
}
export type GetCurrentVenueCustomPaymentMethodsQueryHookResult = ReturnType<typeof useGetCurrentVenueCustomPaymentMethodsQuery>;
export type GetCurrentVenueCustomPaymentMethodsLazyQueryHookResult = ReturnType<typeof useGetCurrentVenueCustomPaymentMethodsLazyQuery>;
export type GetCurrentVenueCustomPaymentMethodsQueryResult = Apollo.QueryResult<GetCurrentVenueCustomPaymentMethodsQuery, GetCurrentVenueCustomPaymentMethodsQueryVariables>;
export function refetchGetCurrentVenueCustomPaymentMethodsQuery(variables?: GetCurrentVenueCustomPaymentMethodsQueryVariables) {
    return { query: GetCurrentVenueCustomPaymentMethodsDocument, variables };
}
export const GetCurrentVenueCustomPaymentMethodDocument = gql`
    query GetCurrentVenueCustomPaymentMethod($id: ID!) {
  currentVenueCustomPaymentMethod(id: $id) {
    id
    name
    isActive
  }
}
    `;
export type GetCurrentVenueCustomPaymentMethodComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetCurrentVenueCustomPaymentMethodQuery, GetCurrentVenueCustomPaymentMethodQueryVariables>, 'query'> & ({ variables: GetCurrentVenueCustomPaymentMethodQueryVariables; skip?: boolean } | { skip: boolean });

export const GetCurrentVenueCustomPaymentMethodComponent = (props: GetCurrentVenueCustomPaymentMethodComponentProps) => (
    <ApolloReactComponents.Query<GetCurrentVenueCustomPaymentMethodQuery, GetCurrentVenueCustomPaymentMethodQueryVariables> query={GetCurrentVenueCustomPaymentMethodDocument} {...props} />
);


/**
 * __useGetCurrentVenueCustomPaymentMethodQuery__
 *
 * To run a query within a React component, call `useGetCurrentVenueCustomPaymentMethodQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentVenueCustomPaymentMethodQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentVenueCustomPaymentMethodQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCurrentVenueCustomPaymentMethodQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetCurrentVenueCustomPaymentMethodQuery, GetCurrentVenueCustomPaymentMethodQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<GetCurrentVenueCustomPaymentMethodQuery, GetCurrentVenueCustomPaymentMethodQueryVariables>(GetCurrentVenueCustomPaymentMethodDocument, options);
}
export function useGetCurrentVenueCustomPaymentMethodLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCurrentVenueCustomPaymentMethodQuery, GetCurrentVenueCustomPaymentMethodQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<GetCurrentVenueCustomPaymentMethodQuery, GetCurrentVenueCustomPaymentMethodQueryVariables>(GetCurrentVenueCustomPaymentMethodDocument, options);
}
export type GetCurrentVenueCustomPaymentMethodQueryHookResult = ReturnType<typeof useGetCurrentVenueCustomPaymentMethodQuery>;
export type GetCurrentVenueCustomPaymentMethodLazyQueryHookResult = ReturnType<typeof useGetCurrentVenueCustomPaymentMethodLazyQuery>;
export type GetCurrentVenueCustomPaymentMethodQueryResult = Apollo.QueryResult<GetCurrentVenueCustomPaymentMethodQuery, GetCurrentVenueCustomPaymentMethodQueryVariables>;
export function refetchGetCurrentVenueCustomPaymentMethodQuery(variables?: GetCurrentVenueCustomPaymentMethodQueryVariables) {
    return { query: GetCurrentVenueCustomPaymentMethodDocument, variables };
}
export const GetGenericFiltersOptionsDocument = gql`
    query GetGenericFiltersOptions {
  sections {
    ...SectionsOptionFragment
  }
  employees {
    ...EmployeeOptionFragment
  }
}
    ${SectionsOptionFragmentDoc}
${EmployeeOptionFragmentDoc}`;
export type GetGenericFiltersOptionsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetGenericFiltersOptionsQuery, GetGenericFiltersOptionsQueryVariables>, 'query'>;

export const GetGenericFiltersOptionsComponent = (props: GetGenericFiltersOptionsComponentProps) => (
    <ApolloReactComponents.Query<GetGenericFiltersOptionsQuery, GetGenericFiltersOptionsQueryVariables> query={GetGenericFiltersOptionsDocument} {...props} />
);


/**
 * __useGetGenericFiltersOptionsQuery__
 *
 * To run a query within a React component, call `useGetGenericFiltersOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGenericFiltersOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGenericFiltersOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetGenericFiltersOptionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetGenericFiltersOptionsQuery, GetGenericFiltersOptionsQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<GetGenericFiltersOptionsQuery, GetGenericFiltersOptionsQueryVariables>(GetGenericFiltersOptionsDocument, options);
}
export function useGetGenericFiltersOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetGenericFiltersOptionsQuery, GetGenericFiltersOptionsQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<GetGenericFiltersOptionsQuery, GetGenericFiltersOptionsQueryVariables>(GetGenericFiltersOptionsDocument, options);
}
export type GetGenericFiltersOptionsQueryHookResult = ReturnType<typeof useGetGenericFiltersOptionsQuery>;
export type GetGenericFiltersOptionsLazyQueryHookResult = ReturnType<typeof useGetGenericFiltersOptionsLazyQuery>;
export type GetGenericFiltersOptionsQueryResult = Apollo.QueryResult<GetGenericFiltersOptionsQuery, GetGenericFiltersOptionsQueryVariables>;
export function refetchGetGenericFiltersOptionsQuery(variables?: GetGenericFiltersOptionsQueryVariables) {
    return { query: GetGenericFiltersOptionsDocument, variables };
}
export const GetPaginatedProductStatisticsDocument = gql`
    query GetPaginatedProductStatistics($offset: Int, $limit: Int, $productName: String, $dateFromTo: DateFromTo, $quantitySortOrder: SortOrder, $revenueSortOrder: SortOrder, $markupSort: SortOrder, $foodCostSort: SortOrder) {
  productStatistics(offset: $offset, limit: $limit, productName: $productName, dateFromTo: $dateFromTo, quantitySortOrder: $quantitySortOrder, revenueSortOrder: $revenueSortOrder, markupSort: $markupSort, foodCostSort: $foodCostSort) {
    items {
      id
      quantity
      revenue
      productName
      foodCost
      markup
      netRevenue
      primeCost
    }
    count
  }
}
    `;
export type GetPaginatedProductStatisticsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetPaginatedProductStatisticsQuery, GetPaginatedProductStatisticsQueryVariables>, 'query'>;

export const GetPaginatedProductStatisticsComponent = (props: GetPaginatedProductStatisticsComponentProps) => (
    <ApolloReactComponents.Query<GetPaginatedProductStatisticsQuery, GetPaginatedProductStatisticsQueryVariables> query={GetPaginatedProductStatisticsDocument} {...props} />
);


/**
 * __useGetPaginatedProductStatisticsQuery__
 *
 * To run a query within a React component, call `useGetPaginatedProductStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaginatedProductStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaginatedProductStatisticsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      productName: // value for 'productName'
 *      dateFromTo: // value for 'dateFromTo'
 *      quantitySortOrder: // value for 'quantitySortOrder'
 *      revenueSortOrder: // value for 'revenueSortOrder'
 *      markupSort: // value for 'markupSort'
 *      foodCostSort: // value for 'foodCostSort'
 *   },
 * });
 */
export function useGetPaginatedProductStatisticsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPaginatedProductStatisticsQuery, GetPaginatedProductStatisticsQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<GetPaginatedProductStatisticsQuery, GetPaginatedProductStatisticsQueryVariables>(GetPaginatedProductStatisticsDocument, options);
}
export function useGetPaginatedProductStatisticsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPaginatedProductStatisticsQuery, GetPaginatedProductStatisticsQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<GetPaginatedProductStatisticsQuery, GetPaginatedProductStatisticsQueryVariables>(GetPaginatedProductStatisticsDocument, options);
}
export type GetPaginatedProductStatisticsQueryHookResult = ReturnType<typeof useGetPaginatedProductStatisticsQuery>;
export type GetPaginatedProductStatisticsLazyQueryHookResult = ReturnType<typeof useGetPaginatedProductStatisticsLazyQuery>;
export type GetPaginatedProductStatisticsQueryResult = Apollo.QueryResult<GetPaginatedProductStatisticsQuery, GetPaginatedProductStatisticsQueryVariables>;
export function refetchGetPaginatedProductStatisticsQuery(variables?: GetPaginatedProductStatisticsQueryVariables) {
    return { query: GetPaginatedProductStatisticsDocument, variables };
}
export const GetProductsReportDocument = gql`
    query GetProductsReport($dateFromTo: DateFromTo) {
  productsReport(dateFromTo: $dateFromTo)
}
    `;
export type GetProductsReportComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetProductsReportQuery, GetProductsReportQueryVariables>, 'query'>;

export const GetProductsReportComponent = (props: GetProductsReportComponentProps) => (
    <ApolloReactComponents.Query<GetProductsReportQuery, GetProductsReportQueryVariables> query={GetProductsReportDocument} {...props} />
);


/**
 * __useGetProductsReportQuery__
 *
 * To run a query within a React component, call `useGetProductsReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductsReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductsReportQuery({
 *   variables: {
 *      dateFromTo: // value for 'dateFromTo'
 *   },
 * });
 */
export function useGetProductsReportQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetProductsReportQuery, GetProductsReportQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<GetProductsReportQuery, GetProductsReportQueryVariables>(GetProductsReportDocument, options);
}
export function useGetProductsReportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetProductsReportQuery, GetProductsReportQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<GetProductsReportQuery, GetProductsReportQueryVariables>(GetProductsReportDocument, options);
}
export type GetProductsReportQueryHookResult = ReturnType<typeof useGetProductsReportQuery>;
export type GetProductsReportLazyQueryHookResult = ReturnType<typeof useGetProductsReportLazyQuery>;
export type GetProductsReportQueryResult = Apollo.QueryResult<GetProductsReportQuery, GetProductsReportQueryVariables>;
export function refetchGetProductsReportQuery(variables?: GetProductsReportQueryVariables) {
    return { query: GetProductsReportDocument, variables };
}
export const PohodaIssueSlipDocument = gql`
    query PohodaIssueSlip($dateFromTo: DateFromTo) {
  pohodaIssueSlip(dateFromTo: $dateFromTo)
}
    `;
export type PohodaIssueSlipComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<PohodaIssueSlipQuery, PohodaIssueSlipQueryVariables>, 'query'>;

export const PohodaIssueSlipComponent = (props: PohodaIssueSlipComponentProps) => (
    <ApolloReactComponents.Query<PohodaIssueSlipQuery, PohodaIssueSlipQueryVariables> query={PohodaIssueSlipDocument} {...props} />
);


/**
 * __usePohodaIssueSlipQuery__
 *
 * To run a query within a React component, call `usePohodaIssueSlipQuery` and pass it any options that fit your needs.
 * When your component renders, `usePohodaIssueSlipQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePohodaIssueSlipQuery({
 *   variables: {
 *      dateFromTo: // value for 'dateFromTo'
 *   },
 * });
 */
export function usePohodaIssueSlipQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PohodaIssueSlipQuery, PohodaIssueSlipQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<PohodaIssueSlipQuery, PohodaIssueSlipQueryVariables>(PohodaIssueSlipDocument, options);
}
export function usePohodaIssueSlipLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PohodaIssueSlipQuery, PohodaIssueSlipQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<PohodaIssueSlipQuery, PohodaIssueSlipQueryVariables>(PohodaIssueSlipDocument, options);
}
export type PohodaIssueSlipQueryHookResult = ReturnType<typeof usePohodaIssueSlipQuery>;
export type PohodaIssueSlipLazyQueryHookResult = ReturnType<typeof usePohodaIssueSlipLazyQuery>;
export type PohodaIssueSlipQueryResult = Apollo.QueryResult<PohodaIssueSlipQuery, PohodaIssueSlipQueryVariables>;
export function refetchPohodaIssueSlipQuery(variables?: PohodaIssueSlipQueryVariables) {
    return { query: PohodaIssueSlipDocument, variables };
}
export const CategoriesStatisticsDocument = gql`
    query CategoriesStatistics($dateFromTo: DateFromTo) {
  categoriesStatistics(dateFromTo: $dateFromTo) {
    id
    categoryId
    name
    quantity
    grossRevenue
    netRevenue
    color
    foodCost
    netMargin
    productWithNoRecipeCount
    primeCost
  }
}
    `;
export type CategoriesStatisticsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<CategoriesStatisticsQuery, CategoriesStatisticsQueryVariables>, 'query'>;

export const CategoriesStatisticsComponent = (props: CategoriesStatisticsComponentProps) => (
    <ApolloReactComponents.Query<CategoriesStatisticsQuery, CategoriesStatisticsQueryVariables> query={CategoriesStatisticsDocument} {...props} />
);


/**
 * __useCategoriesStatisticsQuery__
 *
 * To run a query within a React component, call `useCategoriesStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoriesStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoriesStatisticsQuery({
 *   variables: {
 *      dateFromTo: // value for 'dateFromTo'
 *   },
 * });
 */
export function useCategoriesStatisticsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CategoriesStatisticsQuery, CategoriesStatisticsQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<CategoriesStatisticsQuery, CategoriesStatisticsQueryVariables>(CategoriesStatisticsDocument, options);
}
export function useCategoriesStatisticsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CategoriesStatisticsQuery, CategoriesStatisticsQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<CategoriesStatisticsQuery, CategoriesStatisticsQueryVariables>(CategoriesStatisticsDocument, options);
}
export type CategoriesStatisticsQueryHookResult = ReturnType<typeof useCategoriesStatisticsQuery>;
export type CategoriesStatisticsLazyQueryHookResult = ReturnType<typeof useCategoriesStatisticsLazyQuery>;
export type CategoriesStatisticsQueryResult = Apollo.QueryResult<CategoriesStatisticsQuery, CategoriesStatisticsQueryVariables>;
export function refetchCategoriesStatisticsQuery(variables?: CategoriesStatisticsQueryVariables) {
    return { query: CategoriesStatisticsDocument, variables };
}
export const TableStatisticsDocument = gql`
    query TableStatistics($dateFromTo: DateFromTo) {
  tableStatistics(dateFromTo: $dateFromTo) {
    id
    placeName
    sectionName
    sectionId
    billCount
    grossRevenue
  }
}
    `;
export type TableStatisticsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<TableStatisticsQuery, TableStatisticsQueryVariables>, 'query'>;

export const TableStatisticsComponent = (props: TableStatisticsComponentProps) => (
    <ApolloReactComponents.Query<TableStatisticsQuery, TableStatisticsQueryVariables> query={TableStatisticsDocument} {...props} />
);


/**
 * __useTableStatisticsQuery__
 *
 * To run a query within a React component, call `useTableStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTableStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTableStatisticsQuery({
 *   variables: {
 *      dateFromTo: // value for 'dateFromTo'
 *   },
 * });
 */
export function useTableStatisticsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TableStatisticsQuery, TableStatisticsQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<TableStatisticsQuery, TableStatisticsQueryVariables>(TableStatisticsDocument, options);
}
export function useTableStatisticsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TableStatisticsQuery, TableStatisticsQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<TableStatisticsQuery, TableStatisticsQueryVariables>(TableStatisticsDocument, options);
}
export type TableStatisticsQueryHookResult = ReturnType<typeof useTableStatisticsQuery>;
export type TableStatisticsLazyQueryHookResult = ReturnType<typeof useTableStatisticsLazyQuery>;
export type TableStatisticsQueryResult = Apollo.QueryResult<TableStatisticsQuery, TableStatisticsQueryVariables>;
export function refetchTableStatisticsQuery(variables?: TableStatisticsQueryVariables) {
    return { query: TableStatisticsDocument, variables };
}
export const CreateSupplierDocument = gql`
    mutation CreateSupplier($data: SupplierCreate!) {
  createSupplier(data: $data) {
    id
    legalName
  }
}
    `;
export type CreateSupplierMutationFn = Apollo.MutationFunction<CreateSupplierMutation, CreateSupplierMutationVariables>;
export type CreateSupplierComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateSupplierMutation, CreateSupplierMutationVariables>, 'mutation'>;

export const CreateSupplierComponent = (props: CreateSupplierComponentProps) => (
    <ApolloReactComponents.Mutation<CreateSupplierMutation, CreateSupplierMutationVariables> mutation={CreateSupplierDocument} {...props} />
);


/**
 * __useCreateSupplierMutation__
 *
 * To run a mutation, you first call `useCreateSupplierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSupplierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSupplierMutation, { data, loading, error }] = useCreateSupplierMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateSupplierMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateSupplierMutation, CreateSupplierMutationVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<CreateSupplierMutation, CreateSupplierMutationVariables>(CreateSupplierDocument, options);
}
export type CreateSupplierMutationHookResult = ReturnType<typeof useCreateSupplierMutation>;
export type CreateSupplierMutationResult = Apollo.MutationResult<CreateSupplierMutation>;
export type CreateSupplierMutationOptions = Apollo.BaseMutationOptions<CreateSupplierMutation, CreateSupplierMutationVariables>;
export const UpdatePlaceCoordinatesDocument = gql`
    mutation UpdatePlaceCoordinates($id: String!, $x: Float!, $y: Float!) {
  updatePlace(id: $id, data: {coordinateX: $x, coordinateY: $y}) {
    id
    coordinateX
    coordinateY
  }
}
    `;
export type UpdatePlaceCoordinatesMutationFn = Apollo.MutationFunction<UpdatePlaceCoordinatesMutation, UpdatePlaceCoordinatesMutationVariables>;
export type UpdatePlaceCoordinatesComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdatePlaceCoordinatesMutation, UpdatePlaceCoordinatesMutationVariables>, 'mutation'>;

export const UpdatePlaceCoordinatesComponent = (props: UpdatePlaceCoordinatesComponentProps) => (
    <ApolloReactComponents.Mutation<UpdatePlaceCoordinatesMutation, UpdatePlaceCoordinatesMutationVariables> mutation={UpdatePlaceCoordinatesDocument} {...props} />
);


/**
 * __useUpdatePlaceCoordinatesMutation__
 *
 * To run a mutation, you first call `useUpdatePlaceCoordinatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePlaceCoordinatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePlaceCoordinatesMutation, { data, loading, error }] = useUpdatePlaceCoordinatesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      x: // value for 'x'
 *      y: // value for 'y'
 *   },
 * });
 */
export function useUpdatePlaceCoordinatesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdatePlaceCoordinatesMutation, UpdatePlaceCoordinatesMutationVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<UpdatePlaceCoordinatesMutation, UpdatePlaceCoordinatesMutationVariables>(UpdatePlaceCoordinatesDocument, options);
}
export type UpdatePlaceCoordinatesMutationHookResult = ReturnType<typeof useUpdatePlaceCoordinatesMutation>;
export type UpdatePlaceCoordinatesMutationResult = Apollo.MutationResult<UpdatePlaceCoordinatesMutation>;
export type UpdatePlaceCoordinatesMutationOptions = Apollo.BaseMutationOptions<UpdatePlaceCoordinatesMutation, UpdatePlaceCoordinatesMutationVariables>;
export const CreatePlaceDocument = gql`
    mutation CreatePlace($name: String!, $coordinateX: Float!, $coordinateY: Float!, $sectionId: ID!) {
  createPlace(data: {name: $name, coordinateX: $coordinateX, coordinateY: $coordinateY, sectionId: $sectionId}) {
    id
    coordinateX
    coordinateY
    name
  }
}
    `;
export type CreatePlaceMutationFn = Apollo.MutationFunction<CreatePlaceMutation, CreatePlaceMutationVariables>;
export type CreatePlaceComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreatePlaceMutation, CreatePlaceMutationVariables>, 'mutation'>;

export const CreatePlaceComponent = (props: CreatePlaceComponentProps) => (
    <ApolloReactComponents.Mutation<CreatePlaceMutation, CreatePlaceMutationVariables> mutation={CreatePlaceDocument} {...props} />
);


/**
 * __useCreatePlaceMutation__
 *
 * To run a mutation, you first call `useCreatePlaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePlaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPlaceMutation, { data, loading, error }] = useCreatePlaceMutation({
 *   variables: {
 *      name: // value for 'name'
 *      coordinateX: // value for 'coordinateX'
 *      coordinateY: // value for 'coordinateY'
 *      sectionId: // value for 'sectionId'
 *   },
 * });
 */
export function useCreatePlaceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreatePlaceMutation, CreatePlaceMutationVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<CreatePlaceMutation, CreatePlaceMutationVariables>(CreatePlaceDocument, options);
}
export type CreatePlaceMutationHookResult = ReturnType<typeof useCreatePlaceMutation>;
export type CreatePlaceMutationResult = Apollo.MutationResult<CreatePlaceMutation>;
export type CreatePlaceMutationOptions = Apollo.BaseMutationOptions<CreatePlaceMutation, CreatePlaceMutationVariables>;
export const RemovePlaceDocument = gql`
    mutation RemovePlace($id: String!) {
  removePlace(id: $id)
}
    `;
export type RemovePlaceMutationFn = Apollo.MutationFunction<RemovePlaceMutation, RemovePlaceMutationVariables>;
export type RemovePlaceComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<RemovePlaceMutation, RemovePlaceMutationVariables>, 'mutation'>;

export const RemovePlaceComponent = (props: RemovePlaceComponentProps) => (
    <ApolloReactComponents.Mutation<RemovePlaceMutation, RemovePlaceMutationVariables> mutation={RemovePlaceDocument} {...props} />
);


/**
 * __useRemovePlaceMutation__
 *
 * To run a mutation, you first call `useRemovePlaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePlaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePlaceMutation, { data, loading, error }] = useRemovePlaceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemovePlaceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemovePlaceMutation, RemovePlaceMutationVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<RemovePlaceMutation, RemovePlaceMutationVariables>(RemovePlaceDocument, options);
}
export type RemovePlaceMutationHookResult = ReturnType<typeof useRemovePlaceMutation>;
export type RemovePlaceMutationResult = Apollo.MutationResult<RemovePlaceMutation>;
export type RemovePlaceMutationOptions = Apollo.BaseMutationOptions<RemovePlaceMutation, RemovePlaceMutationVariables>;
export const UpdatePlaceNameDocument = gql`
    mutation UpdatePlaceName($id: String!, $name: String!, $isToGo: Boolean!) {
  updatePlace(id: $id, data: {name: $name, isToGo: $isToGo}) {
    id
    name
    isToGo
  }
}
    `;
export type UpdatePlaceNameMutationFn = Apollo.MutationFunction<UpdatePlaceNameMutation, UpdatePlaceNameMutationVariables>;
export type UpdatePlaceNameComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdatePlaceNameMutation, UpdatePlaceNameMutationVariables>, 'mutation'>;

export const UpdatePlaceNameComponent = (props: UpdatePlaceNameComponentProps) => (
    <ApolloReactComponents.Mutation<UpdatePlaceNameMutation, UpdatePlaceNameMutationVariables> mutation={UpdatePlaceNameDocument} {...props} />
);


/**
 * __useUpdatePlaceNameMutation__
 *
 * To run a mutation, you first call `useUpdatePlaceNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePlaceNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePlaceNameMutation, { data, loading, error }] = useUpdatePlaceNameMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      isToGo: // value for 'isToGo'
 *   },
 * });
 */
export function useUpdatePlaceNameMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdatePlaceNameMutation, UpdatePlaceNameMutationVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<UpdatePlaceNameMutation, UpdatePlaceNameMutationVariables>(UpdatePlaceNameDocument, options);
}
export type UpdatePlaceNameMutationHookResult = ReturnType<typeof useUpdatePlaceNameMutation>;
export type UpdatePlaceNameMutationResult = Apollo.MutationResult<UpdatePlaceNameMutation>;
export type UpdatePlaceNameMutationOptions = Apollo.BaseMutationOptions<UpdatePlaceNameMutation, UpdatePlaceNameMutationVariables>;
export const UpdateSectionNameDocument = gql`
    mutation UpdateSectionName($id: String!, $name: String!) {
  updateSectionName(id: $id, data: {name: $name}) {
    id
    name
  }
}
    `;
export type UpdateSectionNameMutationFn = Apollo.MutationFunction<UpdateSectionNameMutation, UpdateSectionNameMutationVariables>;
export type UpdateSectionNameComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateSectionNameMutation, UpdateSectionNameMutationVariables>, 'mutation'>;

export const UpdateSectionNameComponent = (props: UpdateSectionNameComponentProps) => (
    <ApolloReactComponents.Mutation<UpdateSectionNameMutation, UpdateSectionNameMutationVariables> mutation={UpdateSectionNameDocument} {...props} />
);


/**
 * __useUpdateSectionNameMutation__
 *
 * To run a mutation, you first call `useUpdateSectionNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSectionNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSectionNameMutation, { data, loading, error }] = useUpdateSectionNameMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateSectionNameMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateSectionNameMutation, UpdateSectionNameMutationVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<UpdateSectionNameMutation, UpdateSectionNameMutationVariables>(UpdateSectionNameDocument, options);
}
export type UpdateSectionNameMutationHookResult = ReturnType<typeof useUpdateSectionNameMutation>;
export type UpdateSectionNameMutationResult = Apollo.MutationResult<UpdateSectionNameMutation>;
export type UpdateSectionNameMutationOptions = Apollo.BaseMutationOptions<UpdateSectionNameMutation, UpdateSectionNameMutationVariables>;
export const UpdateSectionOrderDocument = gql`
    mutation UpdateSectionOrder($orderedSections: [SectionWithOrder!]!) {
  updateSectionsOrdering(data: {orderedSections: $orderedSections}) {
    id
    ordering
  }
}
    `;
export type UpdateSectionOrderMutationFn = Apollo.MutationFunction<UpdateSectionOrderMutation, UpdateSectionOrderMutationVariables>;
export type UpdateSectionOrderComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateSectionOrderMutation, UpdateSectionOrderMutationVariables>, 'mutation'>;

export const UpdateSectionOrderComponent = (props: UpdateSectionOrderComponentProps) => (
    <ApolloReactComponents.Mutation<UpdateSectionOrderMutation, UpdateSectionOrderMutationVariables> mutation={UpdateSectionOrderDocument} {...props} />
);


/**
 * __useUpdateSectionOrderMutation__
 *
 * To run a mutation, you first call `useUpdateSectionOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSectionOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSectionOrderMutation, { data, loading, error }] = useUpdateSectionOrderMutation({
 *   variables: {
 *      orderedSections: // value for 'orderedSections'
 *   },
 * });
 */
export function useUpdateSectionOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateSectionOrderMutation, UpdateSectionOrderMutationVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<UpdateSectionOrderMutation, UpdateSectionOrderMutationVariables>(UpdateSectionOrderDocument, options);
}
export type UpdateSectionOrderMutationHookResult = ReturnType<typeof useUpdateSectionOrderMutation>;
export type UpdateSectionOrderMutationResult = Apollo.MutationResult<UpdateSectionOrderMutation>;
export type UpdateSectionOrderMutationOptions = Apollo.BaseMutationOptions<UpdateSectionOrderMutation, UpdateSectionOrderMutationVariables>;
export const CreateSectionDocument = gql`
    mutation CreateSection {
  createSection {
    id
    name
    createdAt
    ordering
  }
}
    `;
export type CreateSectionMutationFn = Apollo.MutationFunction<CreateSectionMutation, CreateSectionMutationVariables>;
export type CreateSectionComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateSectionMutation, CreateSectionMutationVariables>, 'mutation'>;

export const CreateSectionComponent = (props: CreateSectionComponentProps) => (
    <ApolloReactComponents.Mutation<CreateSectionMutation, CreateSectionMutationVariables> mutation={CreateSectionDocument} {...props} />
);


/**
 * __useCreateSectionMutation__
 *
 * To run a mutation, you first call `useCreateSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSectionMutation, { data, loading, error }] = useCreateSectionMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreateSectionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateSectionMutation, CreateSectionMutationVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<CreateSectionMutation, CreateSectionMutationVariables>(CreateSectionDocument, options);
}
export type CreateSectionMutationHookResult = ReturnType<typeof useCreateSectionMutation>;
export type CreateSectionMutationResult = Apollo.MutationResult<CreateSectionMutation>;
export type CreateSectionMutationOptions = Apollo.BaseMutationOptions<CreateSectionMutation, CreateSectionMutationVariables>;
export const DeleteSectionDocument = gql`
    mutation DeleteSection($id: String!) {
  removeSection(id: $id)
}
    `;
export type DeleteSectionMutationFn = Apollo.MutationFunction<DeleteSectionMutation, DeleteSectionMutationVariables>;
export type DeleteSectionComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DeleteSectionMutation, DeleteSectionMutationVariables>, 'mutation'>;

export const DeleteSectionComponent = (props: DeleteSectionComponentProps) => (
    <ApolloReactComponents.Mutation<DeleteSectionMutation, DeleteSectionMutationVariables> mutation={DeleteSectionDocument} {...props} />
);


/**
 * __useDeleteSectionMutation__
 *
 * To run a mutation, you first call `useDeleteSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSectionMutation, { data, loading, error }] = useDeleteSectionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSectionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteSectionMutation, DeleteSectionMutationVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<DeleteSectionMutation, DeleteSectionMutationVariables>(DeleteSectionDocument, options);
}
export type DeleteSectionMutationHookResult = ReturnType<typeof useDeleteSectionMutation>;
export type DeleteSectionMutationResult = Apollo.MutationResult<DeleteSectionMutation>;
export type DeleteSectionMutationOptions = Apollo.BaseMutationOptions<DeleteSectionMutation, DeleteSectionMutationVariables>;
export const SectionsDocument = gql`
    query Sections {
  sections {
    id
    name
    createdAt
    ordering
    places {
      id
      name
      isToGo
      coordinateX
      coordinateY
    }
  }
}
    `;
export type SectionsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<SectionsQuery, SectionsQueryVariables>, 'query'>;

export const SectionsComponent = (props: SectionsComponentProps) => (
    <ApolloReactComponents.Query<SectionsQuery, SectionsQueryVariables> query={SectionsDocument} {...props} />
);


/**
 * __useSectionsQuery__
 *
 * To run a query within a React component, call `useSectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSectionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSectionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SectionsQuery, SectionsQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<SectionsQuery, SectionsQueryVariables>(SectionsDocument, options);
}
export function useSectionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SectionsQuery, SectionsQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<SectionsQuery, SectionsQueryVariables>(SectionsDocument, options);
}
export type SectionsQueryHookResult = ReturnType<typeof useSectionsQuery>;
export type SectionsLazyQueryHookResult = ReturnType<typeof useSectionsLazyQuery>;
export type SectionsQueryResult = Apollo.QueryResult<SectionsQuery, SectionsQueryVariables>;
export function refetchSectionsQuery(variables?: SectionsQueryVariables) {
    return { query: SectionsDocument, variables };
}
export const SectionsFragmentDocument = gql`
    query SectionsFragment {
  sections {
    ...SectionsFragment
    createdAt
    ordering
  }
}
    ${SectionsFragmentDoc}`;
export type SectionsFragmentComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<SectionsFragmentQuery, SectionsFragmentQueryVariables>, 'query'>;

export const SectionsFragmentComponent = (props: SectionsFragmentComponentProps) => (
    <ApolloReactComponents.Query<SectionsFragmentQuery, SectionsFragmentQueryVariables> query={SectionsFragmentDocument} {...props} />
);


/**
 * __useSectionsFragmentQuery__
 *
 * To run a query within a React component, call `useSectionsFragmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useSectionsFragmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSectionsFragmentQuery({
 *   variables: {
 *   },
 * });
 */
export function useSectionsFragmentQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SectionsFragmentQuery, SectionsFragmentQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<SectionsFragmentQuery, SectionsFragmentQueryVariables>(SectionsFragmentDocument, options);
}
export function useSectionsFragmentLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SectionsFragmentQuery, SectionsFragmentQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<SectionsFragmentQuery, SectionsFragmentQueryVariables>(SectionsFragmentDocument, options);
}
export type SectionsFragmentQueryHookResult = ReturnType<typeof useSectionsFragmentQuery>;
export type SectionsFragmentLazyQueryHookResult = ReturnType<typeof useSectionsFragmentLazyQuery>;
export type SectionsFragmentQueryResult = Apollo.QueryResult<SectionsFragmentQuery, SectionsFragmentQueryVariables>;
export function refetchSectionsFragmentQuery(variables?: SectionsFragmentQueryVariables) {
    return { query: SectionsFragmentDocument, variables };
}
export const CreateWarehouseDocument = gql`
    mutation CreateWarehouse($name: String!, $venueIds: [ID!]!) {
  createWarehouse(data: {name: $name, venueIds: $venueIds}) {
    id
    name
    venueIds
  }
}
    `;
export type CreateWarehouseMutationFn = Apollo.MutationFunction<CreateWarehouseMutation, CreateWarehouseMutationVariables>;
export type CreateWarehouseComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateWarehouseMutation, CreateWarehouseMutationVariables>, 'mutation'>;

export const CreateWarehouseComponent = (props: CreateWarehouseComponentProps) => (
    <ApolloReactComponents.Mutation<CreateWarehouseMutation, CreateWarehouseMutationVariables> mutation={CreateWarehouseDocument} {...props} />
);


/**
 * __useCreateWarehouseMutation__
 *
 * To run a mutation, you first call `useCreateWarehouseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWarehouseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWarehouseMutation, { data, loading, error }] = useCreateWarehouseMutation({
 *   variables: {
 *      name: // value for 'name'
 *      venueIds: // value for 'venueIds'
 *   },
 * });
 */
export function useCreateWarehouseMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateWarehouseMutation, CreateWarehouseMutationVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<CreateWarehouseMutation, CreateWarehouseMutationVariables>(CreateWarehouseDocument, options);
}
export type CreateWarehouseMutationHookResult = ReturnType<typeof useCreateWarehouseMutation>;
export type CreateWarehouseMutationResult = Apollo.MutationResult<CreateWarehouseMutation>;
export type CreateWarehouseMutationOptions = Apollo.BaseMutationOptions<CreateWarehouseMutation, CreateWarehouseMutationVariables>;
export const UpdateWarehouseDocument = gql`
    mutation UpdateWarehouse($id: ID!, $name: String, $venueIds: [ID!]) {
  updateWarehouse(id: $id, data: {name: $name, venueIds: $venueIds}) {
    id
    name
    venueIds
  }
}
    `;
export type UpdateWarehouseMutationFn = Apollo.MutationFunction<UpdateWarehouseMutation, UpdateWarehouseMutationVariables>;
export type UpdateWarehouseComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateWarehouseMutation, UpdateWarehouseMutationVariables>, 'mutation'>;

export const UpdateWarehouseComponent = (props: UpdateWarehouseComponentProps) => (
    <ApolloReactComponents.Mutation<UpdateWarehouseMutation, UpdateWarehouseMutationVariables> mutation={UpdateWarehouseDocument} {...props} />
);


/**
 * __useUpdateWarehouseMutation__
 *
 * To run a mutation, you first call `useUpdateWarehouseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWarehouseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWarehouseMutation, { data, loading, error }] = useUpdateWarehouseMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      venueIds: // value for 'venueIds'
 *   },
 * });
 */
export function useUpdateWarehouseMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateWarehouseMutation, UpdateWarehouseMutationVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<UpdateWarehouseMutation, UpdateWarehouseMutationVariables>(UpdateWarehouseDocument, options);
}
export type UpdateWarehouseMutationHookResult = ReturnType<typeof useUpdateWarehouseMutation>;
export type UpdateWarehouseMutationResult = Apollo.MutationResult<UpdateWarehouseMutation>;
export type UpdateWarehouseMutationOptions = Apollo.BaseMutationOptions<UpdateWarehouseMutation, UpdateWarehouseMutationVariables>;
export const CreateWarehouseCardDocument = gql`
    mutation CreateWarehouseCard($data: StockCardCreate!, $priceUpdateArgs: StockCardPriceUpdateInput) {
  createStockCard(data: $data, priceUpdateArgs: $priceUpdateArgs) {
    id
    name
    storageUnit
    conversionUnit
    convertedAmount
    warehouses {
      id
      name
    }
    stockCardCategory {
      id
      name
    }
    tax {
      rate
    }
  }
}
    `;
export type CreateWarehouseCardMutationFn = Apollo.MutationFunction<CreateWarehouseCardMutation, CreateWarehouseCardMutationVariables>;
export type CreateWarehouseCardComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateWarehouseCardMutation, CreateWarehouseCardMutationVariables>, 'mutation'>;

export const CreateWarehouseCardComponent = (props: CreateWarehouseCardComponentProps) => (
    <ApolloReactComponents.Mutation<CreateWarehouseCardMutation, CreateWarehouseCardMutationVariables> mutation={CreateWarehouseCardDocument} {...props} />
);


/**
 * __useCreateWarehouseCardMutation__
 *
 * To run a mutation, you first call `useCreateWarehouseCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWarehouseCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWarehouseCardMutation, { data, loading, error }] = useCreateWarehouseCardMutation({
 *   variables: {
 *      data: // value for 'data'
 *      priceUpdateArgs: // value for 'priceUpdateArgs'
 *   },
 * });
 */
export function useCreateWarehouseCardMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateWarehouseCardMutation, CreateWarehouseCardMutationVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<CreateWarehouseCardMutation, CreateWarehouseCardMutationVariables>(CreateWarehouseCardDocument, options);
}
export type CreateWarehouseCardMutationHookResult = ReturnType<typeof useCreateWarehouseCardMutation>;
export type CreateWarehouseCardMutationResult = Apollo.MutationResult<CreateWarehouseCardMutation>;
export type CreateWarehouseCardMutationOptions = Apollo.BaseMutationOptions<CreateWarehouseCardMutation, CreateWarehouseCardMutationVariables>;
export const UpdateWarehouseCardDocument = gql`
    mutation UpdateWarehouseCard($id: ID!, $data: StockCardUpdate!, $priceUpdateArgs: StockCardPriceUpdateInput) {
  updateStockCard(id: $id, data: $data, priceUpdateArgs: $priceUpdateArgs) {
    id
    name
    storageUnit
    conversionUnit
    convertedAmount
    stockCardCategory {
      id
      name
    }
  }
}
    `;
export type UpdateWarehouseCardMutationFn = Apollo.MutationFunction<UpdateWarehouseCardMutation, UpdateWarehouseCardMutationVariables>;
export type UpdateWarehouseCardComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateWarehouseCardMutation, UpdateWarehouseCardMutationVariables>, 'mutation'>;

export const UpdateWarehouseCardComponent = (props: UpdateWarehouseCardComponentProps) => (
    <ApolloReactComponents.Mutation<UpdateWarehouseCardMutation, UpdateWarehouseCardMutationVariables> mutation={UpdateWarehouseCardDocument} {...props} />
);


/**
 * __useUpdateWarehouseCardMutation__
 *
 * To run a mutation, you first call `useUpdateWarehouseCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWarehouseCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWarehouseCardMutation, { data, loading, error }] = useUpdateWarehouseCardMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *      priceUpdateArgs: // value for 'priceUpdateArgs'
 *   },
 * });
 */
export function useUpdateWarehouseCardMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateWarehouseCardMutation, UpdateWarehouseCardMutationVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<UpdateWarehouseCardMutation, UpdateWarehouseCardMutationVariables>(UpdateWarehouseCardDocument, options);
}
export type UpdateWarehouseCardMutationHookResult = ReturnType<typeof useUpdateWarehouseCardMutation>;
export type UpdateWarehouseCardMutationResult = Apollo.MutationResult<UpdateWarehouseCardMutation>;
export type UpdateWarehouseCardMutationOptions = Apollo.BaseMutationOptions<UpdateWarehouseCardMutation, UpdateWarehouseCardMutationVariables>;
export const RemoveStockCardDocument = gql`
    mutation RemoveStockCard($id: ID!, $warehouseIds: [ID!]!) {
  removeStockCard(id: $id, warehouseIds: $warehouseIds)
}
    `;
export type RemoveStockCardMutationFn = Apollo.MutationFunction<RemoveStockCardMutation, RemoveStockCardMutationVariables>;
export type RemoveStockCardComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<RemoveStockCardMutation, RemoveStockCardMutationVariables>, 'mutation'>;

export const RemoveStockCardComponent = (props: RemoveStockCardComponentProps) => (
    <ApolloReactComponents.Mutation<RemoveStockCardMutation, RemoveStockCardMutationVariables> mutation={RemoveStockCardDocument} {...props} />
);


/**
 * __useRemoveStockCardMutation__
 *
 * To run a mutation, you first call `useRemoveStockCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveStockCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeStockCardMutation, { data, loading, error }] = useRemoveStockCardMutation({
 *   variables: {
 *      id: // value for 'id'
 *      warehouseIds: // value for 'warehouseIds'
 *   },
 * });
 */
export function useRemoveStockCardMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveStockCardMutation, RemoveStockCardMutationVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<RemoveStockCardMutation, RemoveStockCardMutationVariables>(RemoveStockCardDocument, options);
}
export type RemoveStockCardMutationHookResult = ReturnType<typeof useRemoveStockCardMutation>;
export type RemoveStockCardMutationResult = Apollo.MutationResult<RemoveStockCardMutation>;
export type RemoveStockCardMutationOptions = Apollo.BaseMutationOptions<RemoveStockCardMutation, RemoveStockCardMutationVariables>;
export const CreateInventoryCountDocument = gql`
    mutation CreateInventoryCount($warehouseId: ID!) {
  createInventoryCount(warehouseId: $warehouseId) {
    id
    inventoryCountItems {
      id
      expectedCount
      stockCard {
        id
        name
        storageUnit
        conversionUnit
      }
    }
  }
}
    `;
export type CreateInventoryCountMutationFn = Apollo.MutationFunction<CreateInventoryCountMutation, CreateInventoryCountMutationVariables>;
export type CreateInventoryCountComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateInventoryCountMutation, CreateInventoryCountMutationVariables>, 'mutation'>;

export const CreateInventoryCountComponent = (props: CreateInventoryCountComponentProps) => (
    <ApolloReactComponents.Mutation<CreateInventoryCountMutation, CreateInventoryCountMutationVariables> mutation={CreateInventoryCountDocument} {...props} />
);


/**
 * __useCreateInventoryCountMutation__
 *
 * To run a mutation, you first call `useCreateInventoryCountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInventoryCountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInventoryCountMutation, { data, loading, error }] = useCreateInventoryCountMutation({
 *   variables: {
 *      warehouseId: // value for 'warehouseId'
 *   },
 * });
 */
export function useCreateInventoryCountMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateInventoryCountMutation, CreateInventoryCountMutationVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<CreateInventoryCountMutation, CreateInventoryCountMutationVariables>(CreateInventoryCountDocument, options);
}
export type CreateInventoryCountMutationHookResult = ReturnType<typeof useCreateInventoryCountMutation>;
export type CreateInventoryCountMutationResult = Apollo.MutationResult<CreateInventoryCountMutation>;
export type CreateInventoryCountMutationOptions = Apollo.BaseMutationOptions<CreateInventoryCountMutation, CreateInventoryCountMutationVariables>;
export const UpdateInventoryCountItemDocument = gql`
    mutation UpdateInventoryCountItem($data: InventoryCountItemUpdate!, $warehouseId: ID!, $inventoryCountId: ID!, $id: ID!) {
  updateInventoryCountItem(data: $data, warehouseId: $warehouseId, inventoryCountId: $inventoryCountId, id: $id) {
    id
    realCount
    expectedCount
  }
}
    `;
export type UpdateInventoryCountItemMutationFn = Apollo.MutationFunction<UpdateInventoryCountItemMutation, UpdateInventoryCountItemMutationVariables>;
export type UpdateInventoryCountItemComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateInventoryCountItemMutation, UpdateInventoryCountItemMutationVariables>, 'mutation'>;

export const UpdateInventoryCountItemComponent = (props: UpdateInventoryCountItemComponentProps) => (
    <ApolloReactComponents.Mutation<UpdateInventoryCountItemMutation, UpdateInventoryCountItemMutationVariables> mutation={UpdateInventoryCountItemDocument} {...props} />
);


/**
 * __useUpdateInventoryCountItemMutation__
 *
 * To run a mutation, you first call `useUpdateInventoryCountItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInventoryCountItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInventoryCountItemMutation, { data, loading, error }] = useUpdateInventoryCountItemMutation({
 *   variables: {
 *      data: // value for 'data'
 *      warehouseId: // value for 'warehouseId'
 *      inventoryCountId: // value for 'inventoryCountId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateInventoryCountItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateInventoryCountItemMutation, UpdateInventoryCountItemMutationVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<UpdateInventoryCountItemMutation, UpdateInventoryCountItemMutationVariables>(UpdateInventoryCountItemDocument, options);
}
export type UpdateInventoryCountItemMutationHookResult = ReturnType<typeof useUpdateInventoryCountItemMutation>;
export type UpdateInventoryCountItemMutationResult = Apollo.MutationResult<UpdateInventoryCountItemMutation>;
export type UpdateInventoryCountItemMutationOptions = Apollo.BaseMutationOptions<UpdateInventoryCountItemMutation, UpdateInventoryCountItemMutationVariables>;
export const FinishInventoryCountDocument = gql`
    mutation FinishInventoryCount($id: ID!, $warehouseId: ID!) {
  finishInventoryCount(id: $id, warehouseId: $warehouseId) {
    id
    realValuation
    endDate
  }
}
    `;
export type FinishInventoryCountMutationFn = Apollo.MutationFunction<FinishInventoryCountMutation, FinishInventoryCountMutationVariables>;
export type FinishInventoryCountComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<FinishInventoryCountMutation, FinishInventoryCountMutationVariables>, 'mutation'>;

export const FinishInventoryCountComponent = (props: FinishInventoryCountComponentProps) => (
    <ApolloReactComponents.Mutation<FinishInventoryCountMutation, FinishInventoryCountMutationVariables> mutation={FinishInventoryCountDocument} {...props} />
);


/**
 * __useFinishInventoryCountMutation__
 *
 * To run a mutation, you first call `useFinishInventoryCountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinishInventoryCountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finishInventoryCountMutation, { data, loading, error }] = useFinishInventoryCountMutation({
 *   variables: {
 *      id: // value for 'id'
 *      warehouseId: // value for 'warehouseId'
 *   },
 * });
 */
export function useFinishInventoryCountMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<FinishInventoryCountMutation, FinishInventoryCountMutationVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<FinishInventoryCountMutation, FinishInventoryCountMutationVariables>(FinishInventoryCountDocument, options);
}
export type FinishInventoryCountMutationHookResult = ReturnType<typeof useFinishInventoryCountMutation>;
export type FinishInventoryCountMutationResult = Apollo.MutationResult<FinishInventoryCountMutation>;
export type FinishInventoryCountMutationOptions = Apollo.BaseMutationOptions<FinishInventoryCountMutation, FinishInventoryCountMutationVariables>;
export const CreateDeductionListDocument = gql`
    mutation CreateDeductionList($data: DeductionListCreate!) {
  createDeductionList(data: $data) {
    id
  }
}
    `;
export type CreateDeductionListMutationFn = Apollo.MutationFunction<CreateDeductionListMutation, CreateDeductionListMutationVariables>;
export type CreateDeductionListComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateDeductionListMutation, CreateDeductionListMutationVariables>, 'mutation'>;

export const CreateDeductionListComponent = (props: CreateDeductionListComponentProps) => (
    <ApolloReactComponents.Mutation<CreateDeductionListMutation, CreateDeductionListMutationVariables> mutation={CreateDeductionListDocument} {...props} />
);


/**
 * __useCreateDeductionListMutation__
 *
 * To run a mutation, you first call `useCreateDeductionListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDeductionListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDeductionListMutation, { data, loading, error }] = useCreateDeductionListMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateDeductionListMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateDeductionListMutation, CreateDeductionListMutationVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<CreateDeductionListMutation, CreateDeductionListMutationVariables>(CreateDeductionListDocument, options);
}
export type CreateDeductionListMutationHookResult = ReturnType<typeof useCreateDeductionListMutation>;
export type CreateDeductionListMutationResult = Apollo.MutationResult<CreateDeductionListMutation>;
export type CreateDeductionListMutationOptions = Apollo.BaseMutationOptions<CreateDeductionListMutation, CreateDeductionListMutationVariables>;
export const WarehousesDocument = gql`
    query Warehouses($onlyCurrentVenue: Boolean = true) {
  warehouses(onlyCurrentVenue: $onlyCurrentVenue) {
    ...WarehousesFragment
  }
}
    ${WarehousesFragmentDoc}`;
export type WarehousesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<WarehousesQuery, WarehousesQueryVariables>, 'query'>;

export const WarehousesComponent = (props: WarehousesComponentProps) => (
    <ApolloReactComponents.Query<WarehousesQuery, WarehousesQueryVariables> query={WarehousesDocument} {...props} />
);


/**
 * __useWarehousesQuery__
 *
 * To run a query within a React component, call `useWarehousesQuery` and pass it any options that fit your needs.
 * When your component renders, `useWarehousesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWarehousesQuery({
 *   variables: {
 *      onlyCurrentVenue: // value for 'onlyCurrentVenue'
 *   },
 * });
 */
export function useWarehousesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<WarehousesQuery, WarehousesQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<WarehousesQuery, WarehousesQueryVariables>(WarehousesDocument, options);
}
export function useWarehousesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WarehousesQuery, WarehousesQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<WarehousesQuery, WarehousesQueryVariables>(WarehousesDocument, options);
}
export type WarehousesQueryHookResult = ReturnType<typeof useWarehousesQuery>;
export type WarehousesLazyQueryHookResult = ReturnType<typeof useWarehousesLazyQuery>;
export type WarehousesQueryResult = Apollo.QueryResult<WarehousesQuery, WarehousesQueryVariables>;
export function refetchWarehousesQuery(variables?: WarehousesQueryVariables) {
    return { query: WarehousesDocument, variables };
}
export const WarehouseDocument = gql`
    query Warehouse($id: ID!) {
  warehouse(id: $id) {
    id
    name
    venueIds
  }
}
    `;
export type WarehouseComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<WarehouseQuery, WarehouseQueryVariables>, 'query'> & ({ variables: WarehouseQueryVariables; skip?: boolean } | { skip: boolean });

export const WarehouseComponent = (props: WarehouseComponentProps) => (
    <ApolloReactComponents.Query<WarehouseQuery, WarehouseQueryVariables> query={WarehouseDocument} {...props} />
);


/**
 * __useWarehouseQuery__
 *
 * To run a query within a React component, call `useWarehouseQuery` and pass it any options that fit your needs.
 * When your component renders, `useWarehouseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWarehouseQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useWarehouseQuery(baseOptions: ApolloReactHooks.QueryHookOptions<WarehouseQuery, WarehouseQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<WarehouseQuery, WarehouseQueryVariables>(WarehouseDocument, options);
}
export function useWarehouseLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WarehouseQuery, WarehouseQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<WarehouseQuery, WarehouseQueryVariables>(WarehouseDocument, options);
}
export type WarehouseQueryHookResult = ReturnType<typeof useWarehouseQuery>;
export type WarehouseLazyQueryHookResult = ReturnType<typeof useWarehouseLazyQuery>;
export type WarehouseQueryResult = Apollo.QueryResult<WarehouseQuery, WarehouseQueryVariables>;
export function refetchWarehouseQuery(variables?: WarehouseQueryVariables) {
    return { query: WarehouseDocument, variables };
}
export const StockCardsDocument = gql`
    query StockCards($warehouseIds: [ID!]!, $offset: Int, $limit: Int, $stockCardCategoryId: ID, $nameOrSku: String, $stockCardsIds: [ID!], $storageUnit: UnitType, $stockCardNameSortOrder: SortOrder, $stockCardQuantitySortOrder: SortOrder) {
  stockCards(warehouseIds: $warehouseIds, offset: $offset, limit: $limit, stockCardCategoryId: $stockCardCategoryId, nameOrSku: $nameOrSku, stockCardsIds: $stockCardsIds, storageUnit: $storageUnit, stockCardNameSortOrder: $stockCardNameSortOrder, stockCardQuantitySortOrder: $stockCardQuantitySortOrder) @connection(key: "stockCards", filter: ["stockCardsIds", "warehouseIds", "stockCardCategoryId", "nameOrSku", "storageUnit", "stockCardNameSortOrder", "stockCardQuantitySortOrder"]) {
    id
    name
    storageUnit
    conversionUnit
    convertedAmount
    sku
    taxId
    warehouses {
      id
    }
    stockCardCategory {
      id
      name
    }
    stockLevels {
      id
      quantity
      warehouseId
      priceWithoutVat
    }
    tax {
      rate
    }
  }
}
    `;
export type StockCardsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<StockCardsQuery, StockCardsQueryVariables>, 'query'> & ({ variables: StockCardsQueryVariables; skip?: boolean } | { skip: boolean });

export const StockCardsComponent = (props: StockCardsComponentProps) => (
    <ApolloReactComponents.Query<StockCardsQuery, StockCardsQueryVariables> query={StockCardsDocument} {...props} />
);


/**
 * __useStockCardsQuery__
 *
 * To run a query within a React component, call `useStockCardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStockCardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStockCardsQuery({
 *   variables: {
 *      warehouseIds: // value for 'warehouseIds'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      stockCardCategoryId: // value for 'stockCardCategoryId'
 *      nameOrSku: // value for 'nameOrSku'
 *      stockCardsIds: // value for 'stockCardsIds'
 *      storageUnit: // value for 'storageUnit'
 *      stockCardNameSortOrder: // value for 'stockCardNameSortOrder'
 *      stockCardQuantitySortOrder: // value for 'stockCardQuantitySortOrder'
 *   },
 * });
 */
export function useStockCardsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<StockCardsQuery, StockCardsQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<StockCardsQuery, StockCardsQueryVariables>(StockCardsDocument, options);
}
export function useStockCardsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<StockCardsQuery, StockCardsQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<StockCardsQuery, StockCardsQueryVariables>(StockCardsDocument, options);
}
export type StockCardsQueryHookResult = ReturnType<typeof useStockCardsQuery>;
export type StockCardsLazyQueryHookResult = ReturnType<typeof useStockCardsLazyQuery>;
export type StockCardsQueryResult = Apollo.QueryResult<StockCardsQuery, StockCardsQueryVariables>;
export function refetchStockCardsQuery(variables?: StockCardsQueryVariables) {
    return { query: StockCardsDocument, variables };
}
export const PaginatedStockCardsDocument = gql`
    query PaginatedStockCards($warehouseIds: [ID!]!, $offset: Int, $limit: Int, $stockCardCategoryId: ID, $nameOrSku: String, $stockCardsIds: [ID!], $storageUnit: UnitType, $stockCardNameSortOrder: SortOrder, $stockCardQuantitySortOrder: SortOrder) {
  paginatedStockCards(warehouseIds: $warehouseIds, offset: $offset, limit: $limit, stockCardCategoryId: $stockCardCategoryId, nameOrSku: $nameOrSku, stockCardsIds: $stockCardsIds, storageUnit: $storageUnit, stockCardNameSortOrder: $stockCardNameSortOrder, stockCardQuantitySortOrder: $stockCardQuantitySortOrder) @connection(key: "paginatedStockCards", filter: ["stockCardsIds", "warehouseIds", "stockCardCategoryId", "nameOrSku", "storageUnit", "stockCardNameSortOrder", "stockCardQuantitySortOrder"]) {
    items {
      id
      name
      storageUnit
      conversionUnit
      convertedAmount
      sku
      taxId
      warehouses {
        id
      }
      stockCardCategory {
        id
        name
      }
      stockLevels {
        id
        quantity
        warehouseId
        priceWithoutVat
      }
    }
    count
  }
  stockCardCategories {
    id
    name
  }
}
    `;
export type PaginatedStockCardsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<PaginatedStockCardsQuery, PaginatedStockCardsQueryVariables>, 'query'> & ({ variables: PaginatedStockCardsQueryVariables; skip?: boolean } | { skip: boolean });

export const PaginatedStockCardsComponent = (props: PaginatedStockCardsComponentProps) => (
    <ApolloReactComponents.Query<PaginatedStockCardsQuery, PaginatedStockCardsQueryVariables> query={PaginatedStockCardsDocument} {...props} />
);


/**
 * __usePaginatedStockCardsQuery__
 *
 * To run a query within a React component, call `usePaginatedStockCardsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedStockCardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedStockCardsQuery({
 *   variables: {
 *      warehouseIds: // value for 'warehouseIds'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      stockCardCategoryId: // value for 'stockCardCategoryId'
 *      nameOrSku: // value for 'nameOrSku'
 *      stockCardsIds: // value for 'stockCardsIds'
 *      storageUnit: // value for 'storageUnit'
 *      stockCardNameSortOrder: // value for 'stockCardNameSortOrder'
 *      stockCardQuantitySortOrder: // value for 'stockCardQuantitySortOrder'
 *   },
 * });
 */
export function usePaginatedStockCardsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PaginatedStockCardsQuery, PaginatedStockCardsQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<PaginatedStockCardsQuery, PaginatedStockCardsQueryVariables>(PaginatedStockCardsDocument, options);
}
export function usePaginatedStockCardsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PaginatedStockCardsQuery, PaginatedStockCardsQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<PaginatedStockCardsQuery, PaginatedStockCardsQueryVariables>(PaginatedStockCardsDocument, options);
}
export type PaginatedStockCardsQueryHookResult = ReturnType<typeof usePaginatedStockCardsQuery>;
export type PaginatedStockCardsLazyQueryHookResult = ReturnType<typeof usePaginatedStockCardsLazyQuery>;
export type PaginatedStockCardsQueryResult = Apollo.QueryResult<PaginatedStockCardsQuery, PaginatedStockCardsQueryVariables>;
export function refetchPaginatedStockCardsQuery(variables?: PaginatedStockCardsQueryVariables) {
    return { query: PaginatedStockCardsDocument, variables };
}
export const WarehouseCardFormQueryDocument = gql`
    query WarehouseCardFormQuery($onlyCurrentVenue: Boolean = false) {
  warehouses(onlyCurrentVenue: $onlyCurrentVenue) {
    id
    name
  }
  stockCardCategories {
    id
    name
  }
  taxes {
    ...TaxesFragment
  }
}
    ${TaxesFragmentDoc}`;
export type WarehouseCardFormQueryComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<WarehouseCardFormQuery, WarehouseCardFormQueryVariables>, 'query'>;

export const WarehouseCardFormQueryComponent = (props: WarehouseCardFormQueryComponentProps) => (
    <ApolloReactComponents.Query<WarehouseCardFormQuery, WarehouseCardFormQueryVariables> query={WarehouseCardFormQueryDocument} {...props} />
);


/**
 * __useWarehouseCardFormQuery__
 *
 * To run a query within a React component, call `useWarehouseCardFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useWarehouseCardFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWarehouseCardFormQuery({
 *   variables: {
 *      onlyCurrentVenue: // value for 'onlyCurrentVenue'
 *   },
 * });
 */
export function useWarehouseCardFormQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<WarehouseCardFormQuery, WarehouseCardFormQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<WarehouseCardFormQuery, WarehouseCardFormQueryVariables>(WarehouseCardFormQueryDocument, options);
}
export function useWarehouseCardFormQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WarehouseCardFormQuery, WarehouseCardFormQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<WarehouseCardFormQuery, WarehouseCardFormQueryVariables>(WarehouseCardFormQueryDocument, options);
}
export type WarehouseCardFormQueryHookResult = ReturnType<typeof useWarehouseCardFormQuery>;
export type WarehouseCardFormQueryLazyQueryHookResult = ReturnType<typeof useWarehouseCardFormQueryLazyQuery>;
export type WarehouseCardFormQueryQueryResult = Apollo.QueryResult<WarehouseCardFormQuery, WarehouseCardFormQueryVariables>;
export function refetchWarehouseCardFormQuery(variables?: WarehouseCardFormQueryVariables) {
    return { query: WarehouseCardFormQueryDocument, variables };
}
export const StockCardDocument = gql`
    query StockCard($id: ID!, $currentVenueOnly: Boolean) {
  stockCard(id: $id) {
    id
    name
    sku
    storageUnit
    conversionUnit
    convertedAmount
    taxId
    warehouses(currentVenueOnly: $currentVenueOnly) {
      id
      name
    }
    stockCardCategory {
      id
    }
    stockLevels {
      id
      warehouseId
      priceWithoutVat
    }
  }
}
    `;
export type StockCardComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<StockCardQuery, StockCardQueryVariables>, 'query'> & ({ variables: StockCardQueryVariables; skip?: boolean } | { skip: boolean });

export const StockCardComponent = (props: StockCardComponentProps) => (
    <ApolloReactComponents.Query<StockCardQuery, StockCardQueryVariables> query={StockCardDocument} {...props} />
);


/**
 * __useStockCardQuery__
 *
 * To run a query within a React component, call `useStockCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useStockCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStockCardQuery({
 *   variables: {
 *      id: // value for 'id'
 *      currentVenueOnly: // value for 'currentVenueOnly'
 *   },
 * });
 */
export function useStockCardQuery(baseOptions: ApolloReactHooks.QueryHookOptions<StockCardQuery, StockCardQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<StockCardQuery, StockCardQueryVariables>(StockCardDocument, options);
}
export function useStockCardLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<StockCardQuery, StockCardQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<StockCardQuery, StockCardQueryVariables>(StockCardDocument, options);
}
export type StockCardQueryHookResult = ReturnType<typeof useStockCardQuery>;
export type StockCardLazyQueryHookResult = ReturnType<typeof useStockCardLazyQuery>;
export type StockCardQueryResult = Apollo.QueryResult<StockCardQuery, StockCardQueryVariables>;
export function refetchStockCardQuery(variables?: StockCardQueryVariables) {
    return { query: StockCardDocument, variables };
}
export const InventoryCountsDocument = gql`
    query InventoryCounts($warehouseId: ID!) {
  inventoryCounts(warehouseId: $warehouseId) {
    id
    startDate
    expectedValuation
    realValuation
    endDate
    deltas {
      withoutVat
    }
    shortageSurplus {
      surplus {
        withoutVat
      }
      shortage {
        withoutVat
      }
    }
  }
}
    `;
export type InventoryCountsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<InventoryCountsQuery, InventoryCountsQueryVariables>, 'query'> & ({ variables: InventoryCountsQueryVariables; skip?: boolean } | { skip: boolean });

export const InventoryCountsComponent = (props: InventoryCountsComponentProps) => (
    <ApolloReactComponents.Query<InventoryCountsQuery, InventoryCountsQueryVariables> query={InventoryCountsDocument} {...props} />
);


/**
 * __useInventoryCountsQuery__
 *
 * To run a query within a React component, call `useInventoryCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInventoryCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInventoryCountsQuery({
 *   variables: {
 *      warehouseId: // value for 'warehouseId'
 *   },
 * });
 */
export function useInventoryCountsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<InventoryCountsQuery, InventoryCountsQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<InventoryCountsQuery, InventoryCountsQueryVariables>(InventoryCountsDocument, options);
}
export function useInventoryCountsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<InventoryCountsQuery, InventoryCountsQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<InventoryCountsQuery, InventoryCountsQueryVariables>(InventoryCountsDocument, options);
}
export type InventoryCountsQueryHookResult = ReturnType<typeof useInventoryCountsQuery>;
export type InventoryCountsLazyQueryHookResult = ReturnType<typeof useInventoryCountsLazyQuery>;
export type InventoryCountsQueryResult = Apollo.QueryResult<InventoryCountsQuery, InventoryCountsQueryVariables>;
export function refetchInventoryCountsQuery(variables?: InventoryCountsQueryVariables) {
    return { query: InventoryCountsDocument, variables };
}
export const CurrentInventoryCountDocument = gql`
    query CurrentInventoryCount($warehouseId: ID!) {
  currentInventoryCount(warehouseId: $warehouseId) {
    id
    inventoryCountItems {
      id
      expectedCount
      realCount
      stockCard {
        id
        name
        storageUnit
        conversionUnit
        stockCardCategoryId
        stockCardCategory {
          name
        }
      }
    }
  }
  stockCardCategories {
    id
    name
  }
}
    `;
export type CurrentInventoryCountComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<CurrentInventoryCountQuery, CurrentInventoryCountQueryVariables>, 'query'> & ({ variables: CurrentInventoryCountQueryVariables; skip?: boolean } | { skip: boolean });

export const CurrentInventoryCountComponent = (props: CurrentInventoryCountComponentProps) => (
    <ApolloReactComponents.Query<CurrentInventoryCountQuery, CurrentInventoryCountQueryVariables> query={CurrentInventoryCountDocument} {...props} />
);


/**
 * __useCurrentInventoryCountQuery__
 *
 * To run a query within a React component, call `useCurrentInventoryCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentInventoryCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentInventoryCountQuery({
 *   variables: {
 *      warehouseId: // value for 'warehouseId'
 *   },
 * });
 */
export function useCurrentInventoryCountQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CurrentInventoryCountQuery, CurrentInventoryCountQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<CurrentInventoryCountQuery, CurrentInventoryCountQueryVariables>(CurrentInventoryCountDocument, options);
}
export function useCurrentInventoryCountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CurrentInventoryCountQuery, CurrentInventoryCountQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<CurrentInventoryCountQuery, CurrentInventoryCountQueryVariables>(CurrentInventoryCountDocument, options);
}
export type CurrentInventoryCountQueryHookResult = ReturnType<typeof useCurrentInventoryCountQuery>;
export type CurrentInventoryCountLazyQueryHookResult = ReturnType<typeof useCurrentInventoryCountLazyQuery>;
export type CurrentInventoryCountQueryResult = Apollo.QueryResult<CurrentInventoryCountQuery, CurrentInventoryCountQueryVariables>;
export function refetchCurrentInventoryCountQuery(variables?: CurrentInventoryCountQueryVariables) {
    return { query: CurrentInventoryCountDocument, variables };
}
export const InventoryCountDocument = gql`
    query InventoryCount($id: ID!, $warehouseId: ID!) {
  inventoryCount(warehouseId: $warehouseId, id: $id) {
    id
    startDate
    endDate
    expectedValuation
    realValuation
    notMatchingCounts
    notCalculatedCounts
    deltas {
      withoutVat
    }
    shortageSurplus {
      surplus {
        withoutVat
      }
      shortage {
        withoutVat
      }
    }
  }
}
    `;
export type InventoryCountComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<InventoryCountQuery, InventoryCountQueryVariables>, 'query'> & ({ variables: InventoryCountQueryVariables; skip?: boolean } | { skip: boolean });

export const InventoryCountComponent = (props: InventoryCountComponentProps) => (
    <ApolloReactComponents.Query<InventoryCountQuery, InventoryCountQueryVariables> query={InventoryCountDocument} {...props} />
);


/**
 * __useInventoryCountQuery__
 *
 * To run a query within a React component, call `useInventoryCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useInventoryCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInventoryCountQuery({
 *   variables: {
 *      id: // value for 'id'
 *      warehouseId: // value for 'warehouseId'
 *   },
 * });
 */
export function useInventoryCountQuery(baseOptions: ApolloReactHooks.QueryHookOptions<InventoryCountQuery, InventoryCountQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<InventoryCountQuery, InventoryCountQueryVariables>(InventoryCountDocument, options);
}
export function useInventoryCountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<InventoryCountQuery, InventoryCountQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<InventoryCountQuery, InventoryCountQueryVariables>(InventoryCountDocument, options);
}
export type InventoryCountQueryHookResult = ReturnType<typeof useInventoryCountQuery>;
export type InventoryCountLazyQueryHookResult = ReturnType<typeof useInventoryCountLazyQuery>;
export type InventoryCountQueryResult = Apollo.QueryResult<InventoryCountQuery, InventoryCountQueryVariables>;
export function refetchInventoryCountQuery(variables?: InventoryCountQueryVariables) {
    return { query: InventoryCountDocument, variables };
}
export const PaginatedInventoryCountItemsDocument = gql`
    query PaginatedInventoryCountItems($offset: Int, $limit: Int, $inventoryCountId: ID!, $stockCardCategoryId: ID, $unmatchedOnly: Boolean, $notCountedOnly: Boolean, $moreThanExpectedOnly: Boolean, $lessThanExpectedOnly: Boolean, $stockCardNameOrSku: String) {
  paginatedInventoryCountItems(offset: $offset, limit: $limit, inventoryCountId: $inventoryCountId, stockCardCategoryId: $stockCardCategoryId, unmatchedOnly: $unmatchedOnly, notCountedOnly: $notCountedOnly, moreThanExpectedOnly: $moreThanExpectedOnly, lessThanExpectedOnly: $lessThanExpectedOnly, stockCardNameOrSku: $stockCardNameOrSku) @connection(key: "paginatedInventoryCountItems", filter: ["inventoryCountId", "stockCardCategoryId", "unmatchedOnly", "notCountedOnly", "moreThanExpectedOnly", "lessThanExpectedOnly", "stockCardNameOrSku"]) {
    items {
      id
      updatedById
      expectedCount
      realCount
      pricePerUnitWithoutVAT
      stockCard {
        id
        name
        storageUnit
        conversionUnit
        convertedAmount
        stockCardCategory {
          id
          name
        }
      }
    }
    count
  }
}
    `;
export type PaginatedInventoryCountItemsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<PaginatedInventoryCountItemsQuery, PaginatedInventoryCountItemsQueryVariables>, 'query'> & ({ variables: PaginatedInventoryCountItemsQueryVariables; skip?: boolean } | { skip: boolean });

export const PaginatedInventoryCountItemsComponent = (props: PaginatedInventoryCountItemsComponentProps) => (
    <ApolloReactComponents.Query<PaginatedInventoryCountItemsQuery, PaginatedInventoryCountItemsQueryVariables> query={PaginatedInventoryCountItemsDocument} {...props} />
);


/**
 * __usePaginatedInventoryCountItemsQuery__
 *
 * To run a query within a React component, call `usePaginatedInventoryCountItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedInventoryCountItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedInventoryCountItemsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      inventoryCountId: // value for 'inventoryCountId'
 *      stockCardCategoryId: // value for 'stockCardCategoryId'
 *      unmatchedOnly: // value for 'unmatchedOnly'
 *      notCountedOnly: // value for 'notCountedOnly'
 *      moreThanExpectedOnly: // value for 'moreThanExpectedOnly'
 *      lessThanExpectedOnly: // value for 'lessThanExpectedOnly'
 *      stockCardNameOrSku: // value for 'stockCardNameOrSku'
 *   },
 * });
 */
export function usePaginatedInventoryCountItemsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PaginatedInventoryCountItemsQuery, PaginatedInventoryCountItemsQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<PaginatedInventoryCountItemsQuery, PaginatedInventoryCountItemsQueryVariables>(PaginatedInventoryCountItemsDocument, options);
}
export function usePaginatedInventoryCountItemsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PaginatedInventoryCountItemsQuery, PaginatedInventoryCountItemsQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<PaginatedInventoryCountItemsQuery, PaginatedInventoryCountItemsQueryVariables>(PaginatedInventoryCountItemsDocument, options);
}
export type PaginatedInventoryCountItemsQueryHookResult = ReturnType<typeof usePaginatedInventoryCountItemsQuery>;
export type PaginatedInventoryCountItemsLazyQueryHookResult = ReturnType<typeof usePaginatedInventoryCountItemsLazyQuery>;
export type PaginatedInventoryCountItemsQueryResult = Apollo.QueryResult<PaginatedInventoryCountItemsQuery, PaginatedInventoryCountItemsQueryVariables>;
export function refetchPaginatedInventoryCountItemsQuery(variables?: PaginatedInventoryCountItemsQueryVariables) {
    return { query: PaginatedInventoryCountItemsDocument, variables };
}
export const StockCardsSearchDocument = gql`
    query StockCardsSearch($warehouseIds: [ID!]!, $offset: Int, $limit: Int, $stockCardCategoryId: ID, $nameOrSku: String, $storageUnit: UnitType) {
  stockCards(warehouseIds: $warehouseIds, offset: $offset, limit: $limit, nameOrSku: $nameOrSku, stockCardCategoryId: $stockCardCategoryId, storageUnit: $storageUnit) @connection(key: "stockCards", filter: ["warehouseIds", "stockCardCategoryId", "nameOrSku", "storageUnit"]) {
    id
    name
    storageUnit
    conversionUnit
    warehouses {
      id
      name
    }
    stockCardCategory {
      id
      name
    }
  }
}
    `;
export type StockCardsSearchComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<StockCardsSearchQuery, StockCardsSearchQueryVariables>, 'query'> & ({ variables: StockCardsSearchQueryVariables; skip?: boolean } | { skip: boolean });

export const StockCardsSearchComponent = (props: StockCardsSearchComponentProps) => (
    <ApolloReactComponents.Query<StockCardsSearchQuery, StockCardsSearchQueryVariables> query={StockCardsSearchDocument} {...props} />
);


/**
 * __useStockCardsSearchQuery__
 *
 * To run a query within a React component, call `useStockCardsSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useStockCardsSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStockCardsSearchQuery({
 *   variables: {
 *      warehouseIds: // value for 'warehouseIds'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      stockCardCategoryId: // value for 'stockCardCategoryId'
 *      nameOrSku: // value for 'nameOrSku'
 *      storageUnit: // value for 'storageUnit'
 *   },
 * });
 */
export function useStockCardsSearchQuery(baseOptions: ApolloReactHooks.QueryHookOptions<StockCardsSearchQuery, StockCardsSearchQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<StockCardsSearchQuery, StockCardsSearchQueryVariables>(StockCardsSearchDocument, options);
}
export function useStockCardsSearchLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<StockCardsSearchQuery, StockCardsSearchQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<StockCardsSearchQuery, StockCardsSearchQueryVariables>(StockCardsSearchDocument, options);
}
export type StockCardsSearchQueryHookResult = ReturnType<typeof useStockCardsSearchQuery>;
export type StockCardsSearchLazyQueryHookResult = ReturnType<typeof useStockCardsSearchLazyQuery>;
export type StockCardsSearchQueryResult = Apollo.QueryResult<StockCardsSearchQuery, StockCardsSearchQueryVariables>;
export function refetchStockCardsSearchQuery(variables?: StockCardsSearchQueryVariables) {
    return { query: StockCardsSearchDocument, variables };
}
export const CreateStockCardCategoryDocument = gql`
    mutation CreateStockCardCategory($data: StockCardCategoryCreate!) {
  createStockCardCategory(data: $data) {
    id
    name
  }
}
    `;
export type CreateStockCardCategoryMutationFn = Apollo.MutationFunction<CreateStockCardCategoryMutation, CreateStockCardCategoryMutationVariables>;
export type CreateStockCardCategoryComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateStockCardCategoryMutation, CreateStockCardCategoryMutationVariables>, 'mutation'>;

export const CreateStockCardCategoryComponent = (props: CreateStockCardCategoryComponentProps) => (
    <ApolloReactComponents.Mutation<CreateStockCardCategoryMutation, CreateStockCardCategoryMutationVariables> mutation={CreateStockCardCategoryDocument} {...props} />
);


/**
 * __useCreateStockCardCategoryMutation__
 *
 * To run a mutation, you first call `useCreateStockCardCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStockCardCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStockCardCategoryMutation, { data, loading, error }] = useCreateStockCardCategoryMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateStockCardCategoryMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateStockCardCategoryMutation, CreateStockCardCategoryMutationVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<CreateStockCardCategoryMutation, CreateStockCardCategoryMutationVariables>(CreateStockCardCategoryDocument, options);
}
export type CreateStockCardCategoryMutationHookResult = ReturnType<typeof useCreateStockCardCategoryMutation>;
export type CreateStockCardCategoryMutationResult = Apollo.MutationResult<CreateStockCardCategoryMutation>;
export type CreateStockCardCategoryMutationOptions = Apollo.BaseMutationOptions<CreateStockCardCategoryMutation, CreateStockCardCategoryMutationVariables>;
export const RemoveStockCardCategoryDocument = gql`
    mutation RemoveStockCardCategory($id: ID!) {
  removeStockCardCategory(id: $id)
}
    `;
export type RemoveStockCardCategoryMutationFn = Apollo.MutationFunction<RemoveStockCardCategoryMutation, RemoveStockCardCategoryMutationVariables>;
export type RemoveStockCardCategoryComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<RemoveStockCardCategoryMutation, RemoveStockCardCategoryMutationVariables>, 'mutation'>;

export const RemoveStockCardCategoryComponent = (props: RemoveStockCardCategoryComponentProps) => (
    <ApolloReactComponents.Mutation<RemoveStockCardCategoryMutation, RemoveStockCardCategoryMutationVariables> mutation={RemoveStockCardCategoryDocument} {...props} />
);


/**
 * __useRemoveStockCardCategoryMutation__
 *
 * To run a mutation, you first call `useRemoveStockCardCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveStockCardCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeStockCardCategoryMutation, { data, loading, error }] = useRemoveStockCardCategoryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveStockCardCategoryMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveStockCardCategoryMutation, RemoveStockCardCategoryMutationVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useMutation<RemoveStockCardCategoryMutation, RemoveStockCardCategoryMutationVariables>(RemoveStockCardCategoryDocument, options);
}
export type RemoveStockCardCategoryMutationHookResult = ReturnType<typeof useRemoveStockCardCategoryMutation>;
export type RemoveStockCardCategoryMutationResult = Apollo.MutationResult<RemoveStockCardCategoryMutation>;
export type RemoveStockCardCategoryMutationOptions = Apollo.BaseMutationOptions<RemoveStockCardCategoryMutation, RemoveStockCardCategoryMutationVariables>;
export const StockCardCategoriesDocument = gql`
    query StockCardCategories {
  stockCardCategories {
    id
    name
  }
}
    `;
export type StockCardCategoriesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<StockCardCategoriesQuery, StockCardCategoriesQueryVariables>, 'query'>;

export const StockCardCategoriesComponent = (props: StockCardCategoriesComponentProps) => (
    <ApolloReactComponents.Query<StockCardCategoriesQuery, StockCardCategoriesQueryVariables> query={StockCardCategoriesDocument} {...props} />
);


/**
 * __useStockCardCategoriesQuery__
 *
 * To run a query within a React component, call `useStockCardCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useStockCardCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStockCardCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useStockCardCategoriesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<StockCardCategoriesQuery, StockCardCategoriesQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<StockCardCategoriesQuery, StockCardCategoriesQueryVariables>(StockCardCategoriesDocument, options);
}
export function useStockCardCategoriesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<StockCardCategoriesQuery, StockCardCategoriesQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<StockCardCategoriesQuery, StockCardCategoriesQueryVariables>(StockCardCategoriesDocument, options);
}
export type StockCardCategoriesQueryHookResult = ReturnType<typeof useStockCardCategoriesQuery>;
export type StockCardCategoriesLazyQueryHookResult = ReturnType<typeof useStockCardCategoriesLazyQuery>;
export type StockCardCategoriesQueryResult = Apollo.QueryResult<StockCardCategoriesQuery, StockCardCategoriesQueryVariables>;
export function refetchStockCardCategoriesQuery(variables?: StockCardCategoriesQueryVariables) {
    return { query: StockCardCategoriesDocument, variables };
}
export const RossumUploadsCountByWarehouseIdDocument = gql`
    query RossumUploadsCountByWarehouseId($warehouseId: ID!) {
  rossumUploadsCountByWarehouseId(warehouseId: $warehouseId)
}
    `;
export type RossumUploadsCountByWarehouseIdComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<RossumUploadsCountByWarehouseIdQuery, RossumUploadsCountByWarehouseIdQueryVariables>, 'query'> & ({ variables: RossumUploadsCountByWarehouseIdQueryVariables; skip?: boolean } | { skip: boolean });

export const RossumUploadsCountByWarehouseIdComponent = (props: RossumUploadsCountByWarehouseIdComponentProps) => (
    <ApolloReactComponents.Query<RossumUploadsCountByWarehouseIdQuery, RossumUploadsCountByWarehouseIdQueryVariables> query={RossumUploadsCountByWarehouseIdDocument} {...props} />
);


/**
 * __useRossumUploadsCountByWarehouseIdQuery__
 *
 * To run a query within a React component, call `useRossumUploadsCountByWarehouseIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useRossumUploadsCountByWarehouseIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRossumUploadsCountByWarehouseIdQuery({
 *   variables: {
 *      warehouseId: // value for 'warehouseId'
 *   },
 * });
 */
export function useRossumUploadsCountByWarehouseIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RossumUploadsCountByWarehouseIdQuery, RossumUploadsCountByWarehouseIdQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useQuery<RossumUploadsCountByWarehouseIdQuery, RossumUploadsCountByWarehouseIdQueryVariables>(RossumUploadsCountByWarehouseIdDocument, options);
}
export function useRossumUploadsCountByWarehouseIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RossumUploadsCountByWarehouseIdQuery, RossumUploadsCountByWarehouseIdQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return ApolloReactHooks.useLazyQuery<RossumUploadsCountByWarehouseIdQuery, RossumUploadsCountByWarehouseIdQueryVariables>(RossumUploadsCountByWarehouseIdDocument, options);
}
export type RossumUploadsCountByWarehouseIdQueryHookResult = ReturnType<typeof useRossumUploadsCountByWarehouseIdQuery>;
export type RossumUploadsCountByWarehouseIdLazyQueryHookResult = ReturnType<typeof useRossumUploadsCountByWarehouseIdLazyQuery>;
export type RossumUploadsCountByWarehouseIdQueryResult = Apollo.QueryResult<RossumUploadsCountByWarehouseIdQuery, RossumUploadsCountByWarehouseIdQueryVariables>;
export function refetchRossumUploadsCountByWarehouseIdQuery(variables?: RossumUploadsCountByWarehouseIdQueryVariables) {
    return { query: RossumUploadsCountByWarehouseIdDocument, variables };
}